webpackJsonp([0],{

/***/ 1043:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SNcheckout_vue__ = __webpack_require__(1096);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_85c0f8e0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SNcheckout_vue__ = __webpack_require__(1146);
function injectStyle (ssrContext) {
  __webpack_require__(1142)
  __webpack_require__(1144)
}
var normalizeComponent = __webpack_require__(24)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-85c0f8e0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SNcheckout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_85c0f8e0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SNcheckout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1078:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBhcmlhLWhpZGRlbj0idHJ1ZSIgZm9jdXNhYmxlPSJmYWxzZSIgZGF0YS1wcmVmaXg9ImZhcyIgZGF0YS1pY29uPSJjaGV2cm9uLWxlZnQiIGNsYXNzPSJzdmctaW5saW5lLS1mYSBmYS1jaGV2cm9uLWxlZnQgZmEtdy0xMCIgcm9sZT0iaW1nIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMjAgNTEyIj48cGF0aCBmaWxsPSIjZmZmIiBkPSJNMzQuNTIgMjM5LjAzTDIyOC44NyA0NC42OWM5LjM3LTkuMzcgMjQuNTctOS4zNyAzMy45NCAwbDIyLjY3IDIyLjY3YzkuMzYgOS4zNiA5LjM3IDI0LjUyLjA0IDMzLjlMMTMxLjQ5IDI1NmwxNTQuMDIgMTU0Ljc1YzkuMzQgOS4zOCA5LjMyIDI0LjU0LS4wNCAzMy45bC0yMi42NyAyMi42N2MtOS4zNyA5LjM3LTI0LjU3IDkuMzctMzMuOTQgMEwzNC41MiAyNzIuOTdjLTkuMzctOS4zNy05LjM3LTI0LjU3IDAtMzMuOTR6Ij48L3BhdGg+PC9zdmc+"

/***/ }),

/***/ 1084:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./1Seats.png": 1085,
	"./2Seats.png": 1086,
	"./3Seats.png": 1087,
	"./4Seats.png": 1088,
	"./5Seats.png": 1089,
	"./6Seats.png": 1090
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1084;

/***/ }),

/***/ 1085:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 1086:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2Seats.cf3c8c1.png";

/***/ }),

/***/ 1087:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3Seats.e4db332.png";

/***/ }),

/***/ 1088:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/4Seats.4526efe.png";

/***/ }),

/***/ 1089:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/5Seats.1913372.png";

/***/ }),

/***/ 1090:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/6Seats.bd1b484.png";

/***/ }),

/***/ 1096:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_phone_number_input__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_phone_number_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_phone_number_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helper_internet_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helper_internet_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__helper_internet_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helper_storage__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helper_storage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__helper_storage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__main__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_friendly_iframe__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_friendly_iframe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_friendly_iframe__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__services_storage_service__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__services_storage_service___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__services_storage_service__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__helper_constant__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__helper_constant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__helper_constant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_jquery__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__helper_constant_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__helper_constant_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__helper_constant_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vee_validate__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vuex__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_slick__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__helper_countryCodes_js__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__helper_countryCodes_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__helper_countryCodes_js__);






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

















// import VueSnackbar from 'vue-snack'
// Vue.use(VueSnackbar)
__WEBPACK_IMPORTED_MODULE_6_vue__["default"].component("vue-friendly-iframe", __WEBPACK_IMPORTED_MODULE_11_vue_friendly_iframe___default.a);
//import { fromBits } from "long";

// import {
//   // mapActions
//   mapGetters
// } from "vuex";

/* harmony default export */ __webpack_exports__["a"] = ({
  metaInfo: __WEBPACK_IMPORTED_MODULE_16__helper_constant_js__["metaInfo"],
  components: {
    Slick: __WEBPACK_IMPORTED_MODULE_19_vue_slick__["default"],
    VuePhoneNumberInput: __WEBPACK_IMPORTED_MODULE_7_vue_phone_number_input___default.a
  },
  props: {
    // allShowTimes: {
    //   type: Array,
    //   default: []
    // }
  },
  head: {
    title: function title() {
      return "Ticketak";
    },

    meta: [{
      name: "description",
      content: function content() {
        return "Here is the description";
      }
    }]
  },
  //   asyncData({ store, route }) {
  //   },
  data: function data() {
    var _ref;

    return _ref = {
      payment_options: [],
      SeatErrormessage: "",
      countryList: __WEBPACK_IMPORTED_MODULE_20__helper_countryCodes_js___default.a,
      showPaymentCollapse: false,
      get screenWidth() {
        return window.innerWidth >= 767 ? true : false;
      },
      ratingContent: null,
      isValidNumber: false,
      selectedSeatType: "",
      resultsExample: null,
      results: true,
      onUpdate: "",
      phoneNumber: null,
      defaultCountry: "FR",
      valid: true,
      countriesList: [],
      countriesIgnored: [],
      dark: false,
      disabled: false,
      hasLoaderActive: false,
      hasErrorActive: true,
      modalTrue: true,
      studentIDs: [],
      studentIDFilter: [],
      paymentBlock: true,
      Discount: {
        isstudentcheck: 0,
        totaldiscountticket: 0,
        totalticketbook: 0,
        studentvaluearray: []
      },
      discountAmount: 0,
      totalDiscountAmount: 0,
      SeatTypeMT: "",
      SelectedSeatType: "",
      myticketDisplaySeatType: "",
      BASEURL: __WEBPACK_IMPORTED_MODULE_14__helper_constant__["URL_BASE"],
      ConfirmationURL: "",
      FailedURL: "",
      MinSeatsFlag: false,
      seatLayoutDateSlider: {
        loop: false,
        dots: true,
        arrows: true,
        infinite: false,
        slidesToShow: 2,
        responsive: [{
          breakpoint: 1450,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        }, {
          breakpoint: 1300,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        }, {
          breakpoint: 1100,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        }, {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        }, {
          breakpoint: 768,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 3
          }
        }, {
          breakpoint: 576,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        }, {
          breakpoint: 400,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        }]
      },
      project: __WEBPACK_IMPORTED_MODULE_16__helper_constant_js__["PROJECT"],
      bankPage: {
        src: ""
      },
      showDate: {
        actualDate: "",
        day: "",
        date: "",
        month: "",
        year: "",
        actualtime: ""
      },
      CountryID: "",
      SchTime: "",
      showOTP: false,
      OTP: "",
      cinemaDetails: {},
      Default: {},
      showDetails: {},
      savedBankPage: {
        src: ""
      },
      timerStartFunction: null,
      conditions: false,
      savecardradio: false,
      studentCheck: false,
      creditCardDetails: {
        number: ["", "", "", ""],
        expiryMonth: "",
        expiryYear: "",
        name: "",
        cvv: "",
        saveCard: true,
        error: ""
      },
      savedCreditCardDetails: {
        error: ""
      },
      isUserLoggedIn: false,
      verifyError: "",
      savedCreditCards: [],
      getSeatLayout: 1,
      backURL: "",
      OTPScreen: false,
      walletResponse: {},
      timer: {
        TimeoutModal: false,
        minutes: 9,
        seconds: 59,
        stop: false
      },
      modal: {
        signIn: false,
        guestLogin: false,
        payment: false, //make false
        payUsingWallet: false,
        userTicketsDetails: false
      },
      paymentModal: {
        editContactDetails: false,
        viewContactDetails: true,
        wallet: false
      },
      selectedCard: {},
      sectionName: {
        seatLayout: true,
        checkout: false,
        confirmation: false,
        foodAndBeverages: false,
        detailFooter: true,
        noOfSeats: false,
        typeSelector: false
      },
      seatData: {},
      SeatType: "",
      selectedSeatName: [],
      numberofSeatsArray: [1, 2, 3, 4, 5, 6, 7, 8],
      numberOfSeatsSelected: 0,
      totalNumberOfSeats: 0,
      selectedSeats: [],
      DefaultCountryCode: "",
      totalAmount: 0,
      internetHandling: 10,
      discount: 0,
      movieDetails: {},
      foodAndBeverages: {
        listing: [],
        status: false,
        selected: [],
        allListing: [],
        selectedCategory: "All"
      },
      userDetails: {
        email: "",
        phoneNumber: "",
        password: "",
        countryCode: ""
      },
      signIn: {
        email: "",
        password: "",
        flag: false
      },
      cardError: "",
      loginErrorMessage: "",
      UserIPAddress: {},
      promoApplied: false,
      reservationID: "",
      bookingID: "",
      voucherCode: "",
      VoucherMsg: "",
      voucherApplied: false,
      seatTypes: [],
      SBScreenName: "",
      CountryCodeList: [],
      promoListCopy: [],

      promoCode: {
        message: "",
        selected: {
          Title: "",
          PromotionID: ""
        },
        promoList: [],
        errorMessage: "",
        errorInputMessage: "",
        successMessage: "",
        applied: false,
        tab: ""
      },
      errorMessage: {
        otpError: ""
      },
      walletInfo: {},
      finalBookingID: "",
      bookingDetails: {},
      bookingDetailsCopy: {},
      finalBookingDetails: {},
      bookingTermsAndConditions: null,

      guest: {
        errorMessage: ""
      },
      ProcessPaymentMessage: "",
      newPaymentOptions: [],
      Paymentoptions: {
        wallet: {},
        ExpressPay: {},
        creditCard: {}
      },

      FoodNAMessage: "",
      FoodNAStatus: true,
      IsSeatTypePopup: false,
      fnbtotal: 0,
      fnbQty: 0,
      nbs: "",
      Currency: "",
      movieID: "",
      scheduleID: ""
    }, __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_ref, "movieDetails", {}), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_ref, "seatLayout", []), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_ref, "reserveID", ""), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_ref, "days", ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_ref, "months", ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_ref, "status", {
      emailStatus: false,
      phoneNumberStatus: "",
      offer: false
    }), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_ref, "firstCollapsed", true), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_ref, "secondCollapsed", false), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_ref, "fnbCollapsed", true), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_ref, "OnlySeatType", []), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_ref, "isPromoFromList", false), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_ref, "isfocus", {
      item0: false,
      item1: false,
      item2: false,
      item3: false
    }), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_ref, "allShowTimes", []), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_ref, "isStudent", false), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_ref, "isscb", 0), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_ref, "isVoucherApplicable", false), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_ref, "glassval", 0), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_ref, "langName", "English"), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_ref, "checkFnB", false), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_ref, "checkDiscount", true), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_ref, "PromotionTabs", []), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_ref, "SelectedReferralCode", []), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_ref, "promotionFlag", "Apply"), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_ref, "promotionNotAllowed", ""), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_ref, "glassInfoHoverCheck", false), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_ref, "offerPopupCheck", true), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_ref, "isPromo", false), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_ref, "SeatCatWidth", []), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_ref, "onErrorMeesage", null), _ref;
  },


  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({
    seatsClass: function seatsClass() {
      return Math.round(12 / parseInt(this.OnlySeatType.length));
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_18_vuex__["mapGetters"])(["isRTL"]), {
    phonenumbertrue: function phonenumbertrue() {
      if (this.hasErrorActive = false) {
        return this.status.phoneNumberStatus;
      }
    },
    checkoutButtonStatus: function checkoutButtonStatus() {
      // console.log("HELLO", this.onErrorMeesage,this.status.emailStatus, this.status.phoneNumberStatus, this.conditions )
      var value = !this.onErrorMeesage && this.status.emailStatus && this.status.phoneNumberStatus && this.conditions ? true : false;

      if (value) {
        this.showPaymentCollapse = false;
      } else {
        this.showPaymentCollapse = false;
      }
      return value;
    },
    checkoutOfferButtonStatus: function checkoutOfferButtonStatus() {
      return this.status.offer ? true : false;
    },
    discountSpace: function discountSpace() {},
    finalValue: function finalValue() {
      return parseInt(this.totalAmount) + parseInt(this.seatData.ConFee * this.selectedSeats.length) - parseInt(this.discount);
    }
  }),
  watch: {
    // "showDate.actualtime": function(newVal, oldVal){
    //   console.log('newVal, oldVal', newVal, oldVal);
    // }
    // results:function(val){
    //   this.results=val
    //   console.log(this.results,"from watchers")
    // }
    resultsExample: {
      handler: function handler(value) {
        console.log(value);
        this.isValidNumber = value.isValid;
      }
    }
  },

  beforeCreate: function beforeCreate() {},
  beforeMount: function beforeMount() {
    document.addEventListener("DOMContentLoaded", function () {
      var head = document.getElementsByTagName("head")[0];
      var script = document.createElement("script");
      var ngeniusScript = document.createElement("script");
      script.src = "https://html2canvas.hertzen.com/dist/html2canvas.min.js";
      ngeniusScript.src = Movie;
      "https://ajax.googleapis.com/ajax/libs/jquery/3.4.1/jquery.min.js";
      head.appendChild(script);
      head.appendChild(ngeniusScript);
    }, false);

    this.backURL = "/movie-showtimes-page?movieId=" + this.$route.params.movieID;
    this.getIPAddress();
    if (__WEBPACK_IMPORTED_MODULE_12__services_storage_service__["TokenService"].getToken()) {
      this.signIn.flag = true;
    }
    this.movieID = this.$route.params.movieID;
    this.scheduleID = this.$route.params.scheduleID;
    this.getSeatLayout = this.$route.params.seatLayout > 0 ? true : false;
    this.totalNumberOfSeats = 1;
    this.ConfirmationURL = window.location.origin + "/confirmation";
    this.FailedURL = window.location.origin + "/failedPayment";
    this.fetchMovieDetails();
    this.getPromotionList();
    this.getSeatType();
    this.getRatingContent(this.movieID);
    /**
     * SaifGetMovieTime
     */
    //
    //
    console.log(" this.scheduleID", this.scheduleID);
  },

  mounted: function mounted() {
    var _this = this;

    this.getSeatLayoutNew();
    // this.getPaymentOptions();
    this.onErrorMeesage = null;
    //this.createNgeniusCardSection();

    var country = __WEBPACK_IMPORTED_MODULE_12__services_storage_service__["CountryService"].getCountry();
    //countryid
    if (!country) {
      this.CountryID = 119;
    } else {
      this.CountryID = country.CountryID;
    }
    this.userDetails.countryCode = country.CountryISOCode;
    //languageid
    window.localStorage.removeItem("ReserveID");
    //network gateway call
    /*let recaptchaScript = document.createElement("script");
    recaptchaScript.setAttribute(
      "src",
      "https://network.gateway.mastercard.com/checkout/version/49/checkout.js"
    );
    recaptchaScript.setAttribute(
      "data-error",
      window.location.origin + "/failedPayment"
    );this.results
    recaptchaScript.setAttribute(
      "data-complete",
      window.location.origin + "/PaymentComplete/"
    );
    document.head.appendChild(recaptchaScript);*/

    // if (this.$attrs.props && this.$attrs.props.allShowTimes) {
    //   this.allShowTimes = this.$attrs.props.allShowTimes;
    // }

    // this.getScheduleSeatClasses();
    // this.getPromoCodes();
    this.getAllGetCountryList();
    __WEBPACK_IMPORTED_MODULE_10__main__["EventBus"].$on("onProfileSuccess", function () {
      _this.getUserDetails();
    });

    __WEBPACK_IMPORTED_MODULE_10__main__["EventBus"].$on("paymentCompletionEvent", function (user) {
      _this.paymentConfirmation();
    });
    window.addEventListener("message", function (e) {
      if (e.data === "sb:bn:loaded") {
        console.log("eventworking", e);
        __WEBPACK_IMPORTED_MODULE_10__main__["EventBus"].$emit("paymentCompletionEvent", e);
      }
    });

    //
  },
  methods: {
    onClickScbOk: function onClickScbOk() {
      this.$refs.scbModal.hide();
    },
    getRatingContent: function getRatingContent() {
      var _this2 = this;

      var MovieID = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        var payload, _ref2, error, res;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                payload = { MovieID: MovieID };

                console.log("rating=>>>>>>", MovieID);
                _context.next = 4;
                return Object(__WEBPACK_IMPORTED_MODULE_8__helper_internet_js__["makeRequest"])("/GetRatingContent", "POST", null, payload);

              case 4:
                _ref2 = _context.sent;
                error = _ref2.error;
                res = _ref2.res;

                if (!error && res.data && res.data.Status && res.data.Data) {
                  _this2.ratingContent = res.data.Data;

                  if (_this2.ratingContent) {
                    // this.$refs.tncModal && this.$refs.tncModal.show()
                  }
                } else {
                  console.error({ error: error });
                  _this2.$refs.tncModal && _this2.$refs.tncModal.hide();
                }

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    getPaymentName: function getPaymentName(payOption) {
      if (payOption.payment_id == "3") {
        this.$refs.scbModal.show();
        this.isscb = 1;
        this.getReservesDetails();
      } else {
        this.isscb = 0;
        this.getReservesDetails();
      }
    },
    getPaymentOptions: function getPaymentOptions() {
      var _this3 = this;

      this.showLoading();
      if (this.reserveID) {
        Object(__WEBPACK_IMPORTED_MODULE_8__helper_internet_js__["makeRequest"])("/v1/payment?reserve_id=" + this.reserveID, "GET", null, null, __WEBPACK_IMPORTED_MODULE_14__helper_constant__["EVENT_URL"]).then(function (response) {
          var error = response.error,
              res = response.res;

          console.log(res, error);

          if (!error) {
            _this3.payment_options = res.data.data;
            _this3.showPaymentCollapse = true;
            setTimeout(function () {
              var elmnt = document.getElementById("payment-mode-section");
              elmnt.scrollIntoView({ behavior: "smooth", inline: "start" });
            }, 0);
            _this3.hideLoading();
          } else {
            console.log("Response Error ");
          }
        }).catch(function (error) {
          console.log("Error", error);
        });
        this.hideLoading();
      }
    },
    sessionExpired: function sessionExpired() {
      var payload = {
        ReserveID: this.reserveID
      };
      Object(__WEBPACK_IMPORTED_MODULE_8__helper_internet_js__["makeRequest"])("/BookingReserveDisable", "POST", null, payload).then(function (response) {
        var error = response.error,
            res = response.res;
        var data = res.data.data;
      }).catch(function (error) {
        console.log("Error", error);
        //   resolve(null);
      });
    },
    onCountryChange: function onCountryChange() {},
    onUpdate: function onUpdate(payload) {
      this.status.phoneNumberStatus = payload.isValid;
      console.log("gsdgasddgasjhah", this.status.phoneNumberStatus);
    },
    showRatedModal: function showRatedModal() {
      this.$refs.rated_modal && this.$refs.rated_modal.show();
    },
    hideRatedModal: function hideRatedModal() {
      this.$refs.rated_modal && this.$refs.rated_modal.hide();
      this.showSeatNoModal();
    },
    showSeatNoModal: function showSeatNoModal() {
      this.$refs.tncModal && this.$refs.tncModal.show();
    },
    onClickSeatSelectionModal: function onClickSeatSelectionModal() {
      this.$refs.tncModal && this.$refs.tncModal.hide();
      this.$refs.seat_select_modal && this.$refs.seat_select_modal.show();
    },
    onCancelRedirectBack: function onCancelRedirectBack() {
      history.back();
    },
    hideSeatNoModal: function hideSeatNoModal() {
      this.$refs.seat_select_modal && this.$refs.seat_select_modal.hide();
    },
    onShowSeatImg: function onShowSeatImg(number) {
      this.totalNumberOfSeats = number;
    },
    onSelectNumberOfSeats: function onSelectNumberOfSeats(number) {
      var _this4 = this;

      this.selectedSeats.map(function (x) {
        _this4.seatLayout[x.rowIndex][x.seatIndex].SelectStatus = false;
        _this4.seatLayout[x.rowIndex][x.seatIndex].SelectStatusFlag = false;
      });
      this.selectedSeats = [];
      // this.seatLayout.map(seatRow => {
      //   seatRow.map(seat => {
      //     seat.SelectStatusFlag = false;
      //     seat.SelectStatus = false;
      //   });
      // });
      //   this.selectedSeats = [];
      if (this.cinemaDetails.Name.includes("Novo")) {
        this.getSeatLayoutNew();
      }

      this.hideSeatNoModal();
    },


    getCinemaMovieTimes: function getCinemaMovieTimes(payload) {
      var _this5 = this;

      this.allShowTimes = [];
      Object(__WEBPACK_IMPORTED_MODULE_8__helper_internet_js__["makeRequest"])("/GetCinemaSchedule", "POST", null, payload).then(function () {
        var _ref3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2(response) {
          var error, res;
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  error = response.error, res = response.res;

                  if (!(!error && res.data && res.data["Data"] && res.data.Data.length > 0)) {
                    _context2.next = 9;
                    break;
                  }

                  console.log("res.data.Data", res.data.Data);
                  // this.allShowTimes = res.data.Data;
                  // this.allcinemas = res.data.Data;
                  // this.allcinemas.push({ name: "All Cinemas" });
                  // // this.selectedCinema = this.allcinemas[0].name;
                  _this5.allShowTimes = res.data.Data[0].timings.map(function (x) {
                    x["ShowTime"] = x.time;
                    x["SchID"] = x.id;
                    x["Format"] = x.format;
                    return x;
                  });
                  _context2.next = 6;
                  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(_this5.allShowTimes);

                case 6:
                  console.log(" this.allShowTimes", _this5.allShowTimes);
                  // console.log(
                  //   "this.$refs.cinemaMovieTimeSlick",
                  //   this.$refs.cinemaMovieTimeSlick
                  // );
                  // this.$refs.cinemaMovieTimeSlick.destroy();
                  // this.$nextTick(() => {
                  //   this.$refs.cinemaMovieTimeSlick.create();
                  // });
                  _context2.next = 10;
                  break;

                case 9:
                  console.log("Response Error ");

                case 10:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, _this5);
        }));

        return function (_x2) {
          return _ref3.apply(this, arguments);
        };
      }()).catch(function (error) {
        console.log("Error", error);
      });
    },
    closeModal: function closeModal() {
      this.modalTrue = false;
    },

    ///
    createNgeniusCardSection: function createNgeniusCardSection() {
      /* Method call to mount the card input on your website */
      window.NI.mountCardInput("mount-id" /* the mount id*/, {
        style: {
          main: {
            margin: "0px",
            padding: "0px",
            color: "#FFFFFF",
            fontFamily: "Odibee Sans !important"
          },
          base: {
            fontSize: "16px",
            color: "#FFFFFF",
            fontFamily: "Odibee Sans !important"
          },
          input: {
            borderWidth: "1px",
            borderRadius: "5px",
            borderStyle: "solid",
            backgroundColor: "#FFFFFF",
            borderColor: "#DDDDDD",
            color: "#000000",
            padding: "5px",
            fontUrl: "https://fonts.googleapis.com/css?family=Odibee+Sans&display=swap",
            fontFamily: "Odibee Sans !important"
          },
          invalid: {
            borderColor: "red"
          }
        }, // Style configuration you can pass to customize the UI
        /*apiKey : 'ZDJkOGJlY2EtYzBiZS00MTQ1LWFiZjYtYzg1MjVlODUxMGI3OjM2NDgyZWRmLTM1NmEtNGRlYy04YjcwLWE4ZTUzMTA5NzljMg==', // API Key for WEB SDK from the portal
                 outletRef : '5edab6d7-5946-43f4-b8c7-06b29c272bdd', // outlet reference from the portal
                 */

        //UAT

        apiKey: "YWJjMjQyZDEtZWJlMC00NDc1LTlkMmItMWY3Y2ZmYWY0MGFkOjFmMmRlNWY2LTM1NTYtNDU3Yi05ZDVhLTExMGQ4MTU5M2ViNg==", // API Key for WEB SDK from the portal
        outletRef: "e209b88c-9fb6-4be8-ab4b-e4b977ad0e0d", // outlet reference from the portal

        //Live
        /*apiKey:
          "YTJjZTg2ZWMtMzMwMi00MWE2LWFlZmMtOWEyZjQ5YWIzYTI4OjYyMjYzYjlhLTM0NDUtNDVkZS1iOGFiLWNkOTAxZGE0YWRkZA==", // API Key for WEB SDK from the portal
        outletRef: "16dd685a-7139-4b10-a821-7bede1070010", // outlet reference from the portal*/

        onSuccess: "", // Success callback if apiKey validation succeeds
        onFail: "", // Fail callback if apiKey validation fails
        onChangeValidStatus: function onChangeValidStatus(_ref4) {
          var isCVVValid = _ref4.isCVVValid,
              isExpiryValid = _ref4.isExpiryValid,
              isNameValid = _ref4.isNameValid,
              isPanValid = _ref4.isPanValid;

          console.log(isCVVValid, isExpiryValid, isNameValid, isPanValid);
        }
      });
    },

    payNowNetowrk: function payNowNetowrk() {
      var _this6 = this;

      this.showLoading();
      var payload = {
        ReserveID: this.reserveID,
        ctoken: 1110266398,
        Email: this.userDetails.email,
        Number: this.userDetails.phoneNumber,
        countrycode: this.DefaultCountryCode
      };
      Object(__WEBPACK_IMPORTED_MODULE_8__helper_internet_js__["makeRequest"])("/ReserveDetailsNew", "POST", null, payload).then(function (result) {
        var error = result.error,
            res = result.res;

        if (!error && res.data.Status) {
          _this6.hideLoading();
          console.log(res.data);
          //this.bankPage.src = res.data.order_paypage_url;
          _this6.sectionName.foodAndBeverages = false;
          window.location.href = res.data.order_paypage_url;
          //window.open(res.data.order_paypage_url, '_blank');
        }
      }).catch(function (error) {
        console.log("Error on vue front", error);
      });
    },
    checkingOnPaymentCall: function checkingOnPaymentCall() {
      var self = this;
      // console.log("Here we area calling", Checkout);
      Checkout.configure({
        merchant: "001110266368",
        session: {
          id: self.bookingDetails.SessionID
          // id: "SESSION0002304652986E8327415I86"
        },
        order: {
          amount: function amount() {
            return parseFloat(self.bookingDetails.total_amt);
            // return 1;
          },
          currency: "AED",
          description: "Ordered goods",
          id: "TCK0" + self.reserveID
        },
        interaction: {
          merchant: {
            name: "Rasikh Portal LLC ",
            address: {
              line1: "200 Sample St",
              line2: "1234 Example Town"
            },
            email: "support@ticketak.com"
          }
        }
      });

      //HARDCODEED
      // Checkout.configure({
      //   merchant: "001110266368",
      //   session: {
      //     id: "SESSION0002304652986E8327415I86"
      //   },
      //   order: {
      //     amount: function() {
      //       return 169.5;
      //     },
      //     currency: "AED",
      //     description: "Ordered goods",
      //     id: "TCK014399"
      //   },
      //   interaction: {
      //     merchant: {
      //       name: "Rasikh Portal LLC ",
      //       address: {
      //         line1: "200 Sample St",
      //         line2: "1234 Example Town"
      //       },
      //       email: "support@ticketak.com"
      //     }
      //   }
      // });
      Checkout.showLightbox();
    },
    handler: function handler(e) {
      //do stuff
      e.preventDefault();
    },
    onClickSignModal: function onClickSignModal() {
      this.$root.$emit("bv::show::modal", "signIn");
    },
    addhyphen: function addhyphen(params) {
      return params.replace(/\s+/g, "-");
    },
    openModal: function openModal() {
      this.$refs.hurryupmodal.show();
    },
    onCloseModal: function onCloseModal(name) {
      this.$refs[name].hide();
    },
    onClickGoBack: function onClickGoBack() {
      this.$router.go(-1);
    },
    onClickShowTime: function onClickShowTime(showTime) {
      this.scheduleID = showTime.SchID;
      this.seatData = {};
      this.seatLayout = [];
      // this.SeatType = "";
      this.seatTypes = [];
      this.selectedSeats = [];
      this.totalAmount = 0;
      this.SchTime = showTime.ShowTime;
      // Saif Get Seat Types and Show Modal
      if (this.project == "myticketi") {
        this.getTempSeatType();
      } else {
        this.getSeatLayoutNew();
      }
    },
    onClickRestart: function onClickRestart() {
      this.$refs.sessionTimeOut.hide();
      this.timer.minutes = 9;
      this.timer.seconds = 59;
      this.timer.stop = false;
      this.$router.go(this.$router.fullPath);
      //reset data
      this.cinemaId = {};
      this.selectedCard = {};
      this.seatData = {};
      this.SeatType = "";
      this.numberOfSeatsSelected = 0;
      this.totalNumberOfSeats = 0;
      this.selectedSeats = [];
      this.totalAmount = 0;
      this.singleTicketPrice = 0;
      this.discount = 0;
      this.promoApplied = false;
      this.isPromoFromList = false;
      this.reservationID = "";
      this.bookingID = "";
      this.seatTypes = [];
      this.promoCode.message = "";
      this.promoCode.selected.Title = "";
      this.promoCode.selected.PromotionID = "";
      this.promoCode.selected.Name = "";

      this.promoCode.promoList = [];
      this.promoCode.errorMessage = "";
      this.promoCode.errorInputMessage = "";
      this.promoCode.successMessage = "";
      this.promoCode.applied = false;
      this.bookingDetails = {};
      this.bookingDetailsCopy = {};
      this.bookingTermsAndConditions = null;
      this.finalBookingDetails = {};
      this.seatLayout = [];
      this.reserveID = "";
      this.OnlySeatType = [];
      this.getSeatType();
      this.getPromotionList();
      //
      this.sectionName.seatLayout = false;
      this.sectionName.checkout = false;
      this.sectionName.confirmation = false;
      this.sectionName.detailFooter = true;
      this.sectionName.noOfSeats = true;
      this.sectionName.typeSelector = false;
    },

    onHoverIn: function onHoverIn(glassInfoHover) {
      console.log(glassInfoHover);
      this.glassInfoHoverCheck = true;
    },
    onHoverOut: function onHoverOut(glassInfoHover) {
      console.log(glassInfoHover);
      this.glassInfoHoverCheck = false;
    },
    onHover: function onHover(glassInfoHover) {
      console.log(glassInfoHover);
      if (glassInfoHover) {
        this.glassInfoHoverCheck = true;
        this.bookingDetails.glassInfoHover = false;
      } else {
        this.glassInfoHoverCheck = false;
        this.bookingDetails.glassInfoHover = true;
      }
    },
    CCOnKeyUp: function CCOnKeyUp(item, type, e, card) {
      //for cvv
      if (type == "cvv") {
        if (card) {
          this.selectedCard = card;
        }

        if (this.creditCardDetails.cvv.length > 3) {
          this.creditCardDetails.cvv = this.creditCardDetails.cvv.slice(0, -1);
          this.$refs.cvv.blur();
        }
      }
      //for year and month
      if (type == "expiry") {
        if (this.creditCardDetails.expiryMonth.length == 2 && e.keyCode < 58 && e.keyCode > 47) {
          this.$refs["expiry2"].focus();
        }
        if (this.creditCardDetails.expiryYear.length > 2) {
          this.creditCardDetails.expiryYear = this.creditCardDetails.expiryYear.slice(0, -1);
          this.$refs.cvv.focus();
        }
        // if (this.creditCardDetails.expiryYear.length == 0 && item == 2) {
        //   this.$refs["expiry1"].focus();
        // }
      }
      // expiryYear
      if (type == "expiryYear") {
        if (this.creditCardDetails.expiryMonth.length == 2 && e.keyCode < 58 && e.keyCode > 47) {
          this.$refs["expiry2"].focus();
        }
        if (this.creditCardDetails.expiryYear.length > 2) {
          this.creditCardDetails.expiryYear = this.creditCardDetails.expiryYear.slice(0, -1);
          this.$refs.cvv.focus();
        }
      }
      //for number
      if (type == "number") {
        var temp = "item" + item;
        var focusVal = this.isfocus[temp];
        if (this.creditCardDetails.number[item].length == 0 && item != 0 && !focusVal) {
          var value = "card" + (item - 1);
          this.$refs[value].focus();
        }
        if (this.creditCardDetails.number[item].length > 4) {
          this.creditCardDetails.number[item] = this.creditCardDetails.number[item].slice(0, -1);
        }
        if (this.creditCardDetails.number[item].length == 4 && e.keyCode < 58 && e.keyCode > 47) {
          if (item == 3) {
            this.$refs["cardName"].focus();
            return;
          }
          var _value = "card" + (item + 1);
          this.$refs[_value].focus();
        }
      }
    },
    onClickBackButton: function onClickBackButton() {
      if (this.sectionName.noOfSeats == true) {
        this.$router.go(-1);
      } else if (this.sectionName.seatLayout == true) {
        this.$router.go(-1);
      }
    },
    onKeyUp: function onKeyUp(event, name) {
      this.showPaymentCollapse = false;
      this.onErrorMeesage = null;
      var emailreg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (name == "email") {
        this.status.emailStatus = emailreg.test(this.userDetails.email);
        ///check email validation
      } else if (name == "mobile") {
        this.userDetails.countryCode = event.countryCallingCode;
        // this.userDetails.phoneNumber = this.userDetails.phoneNumber.replace(
        //   /\./g,
        //   ""
        // );
        // let passwordRege = /\d{9}/;
        // this.status.phoneNumberStatus = passwordRege.test(
        //   this.userDetails.phoneNumber
        // );
        console.log(event);
        if (event.isValid) {
          this.status.phoneNumberStatus = true;
        } else {
          this.status.phoneNumberStatus = false;
        }
        //check mobile validation
      }
      if (name == "offer") {
        // this.promoCode.selected.Title = event.value;
        if (this.promoCode.selected.Name.length > 0) {
          this.status.offer = true;
          this.promoCode.errorInputMessage = "";
        } else if (this.promoCode.selected.Name.length == 0) {
          this.status.offer = false;
        }
      }
      if (name == "studentCheck") {
        if (!this.promoApplied) {
          this.studentIDs = [];
          this.promotionDiscount();
        } else {
          event.preventDefault();
          this.studentCheck = false;
          this.promotionNotAllowed = "You have already applied for a coupon.";
          this.$refs.couponNotAllowed.show();
        }
      }
    },
    onApplyPromocode: function onApplyPromocode(type) {
      this.showLoading();
      this.VoucherMsg = "";
      // this.promoCode.promoList = this.promoCode.promoListCopy;
      // if (this.promoListCopy.length > 0) {
      //   for (var i = 0; i < this.promoListCopy.length; i++) {
      //     if (
      //       this.promoListCopy[i].Name.toLowerCase() ==
      //       this.promoCode.selected.Name.toLowerCase()
      //     ) {
      this.verifyPromotion(type);
      //     } else {
      //       this.bookingDetails = this.bookingDetailsCopy;
      //       this.promoCode.errorInputMessage = "Not a Valid Coupon";
      //       this.promoApplied = false;
      //     }
      //   }
      // } else {
      //   this.promoCode.errorInputMessage = "Not a Valid Coupon";
      // }

      // this.promoListCopy.map((x, index) => {
      //   if (
      //     this.promoCode.selected.Name.toLowerCase() === x.Name.toLowerCase()
      //   ) {
      //     this.verifyPromotion(x, index);
      //   } else {
      //     this.bookingDetails = this.bookingDetailsCopy;
      //     this.promoCode.errorInputMessage = "Not a Valid Coupon";
      //     this.promoApplied = false;
      //   }
      // });
    },
    promotionDiscount: function promotionDiscount() {
      //this.discountAmount
      this.totalDiscountAmount = 0;
      this.bookingDetails.glassamount = parseInt(0);
      this.bookingDetails.ptdvalue = this.bookingDetails.ticketprize - this.discountAmount;
      this.bookingDetails.promotioncount = 0;
      var enteredIDCount = 0;
      var balanceGlassAmount = 0;
      console.log("onblur called :", this.bookingDetails.ptdvalue);
      for (var i = 1; i < this.studentIDs.length; i++) {
        console.log("this.studentIDs[i] :", this.studentIDs[i]);
        if (this.studentIDs[i] != "") {
          this.totalDiscountAmount += this.bookingDetails.ticketprize - this.discountAmount;
          this.bookingDetails.promotioncount = parseInt(this.bookingDetails.promotioncount + 1);
          if (this.glassval > 0) {
            this.bookingDetails.glassamount += parseInt(this.glassval);
          }
          enteredIDCount += 1;
        }
      }

      var studentIDCount = this.totalNumberOfSeats - parseInt(this.studentIDs.length - 1);
      for (var j = 0; j < this.totalNumberOfSeats; j++) {
        if (this.glassval > 0) {
          balanceGlassAmount += parseInt(this.glassval);
        }
      }
      if (this.glassval > 0) {
        this.bookingDetails.glassamount = balanceGlassAmount - parseInt(this.bookingDetails.glassamount);
      }
      this.bookingDetails.student_discount = this.totalDiscountAmount;
      this.bookingDetails.total_amt = parseInt(this.totalNumberOfSeats * this.bookingDetails.ticketprize - this.bookingDetails.student_discount + parseInt(this.totalNumberOfSeats * this.bookingDetails.internet_handling_amt) + parseInt(this.bookingDetails.glassamount) + parseInt(this.bookingDetails.fnb_total));
      this.checkDiscount = false;
      console.log(this.checkDiscount);
    },
    getAllGetCountryList: function getAllGetCountryList() {
      var _this7 = this;

      Object(__WEBPACK_IMPORTED_MODULE_8__helper_internet_js__["makeRequest"])("/GetCountryCode", "POST", null, {}).then(function (response) {
        var error = response.error,
            res = response.res;

        if (res.data.Status) {
          _this7.CountryCodeList = res.data.List;
          _this7.DefaultCountryCode = res.data.Default.CountryCode || res.data.List.length ? res.data.List[3].CountryISOCode : "";
        }
      }).catch(function (error) {
        console.log("Error", error);
        //   resolve(null);
      });
    },
    onChangeCountry: function onChangeCountry(country) {
      this.DefaultCountryCode = country.CountryISOCode;
    },
    onclickAdd: function onclickAdd(index) {
      var _this8 = this;

      this.OnlySeatType = this.OnlySeatType.map(function (x, seatIndex) {
        if (_this8.OnlySeatType.length == 1) {
          _this8.SeatTypeMT = x.SeatLabel;
          if (seatIndex == index && x.count < 10 || x.isuniqueSeat) {
            _this8.SeatTypeMT = x.SeatLabel;
            x.count++;
          } else {
            x["clickDisabled"] = true;
          }
        } else {
          if (seatIndex == index && x.count < 10 && x.isuniqueSeat) {
            _this8.SeatTypeMT = x.SeatLabel;
            x.count++;
          } else {
            x["clickDisabled"] = true;
          }
        }
        return x;
      });
      this.totalNumberOfSeats = 0;
      this.OnlySeatType.filter(function (x) {
        _this8.totalNumberOfSeats += x.count;
      });
      this.totalAmount = 0.0;
      this.singleTicketPrice = 0.0;
      this.OnlySeatType.filter(function (x) {
        if (x.count > 0) {
          if (x.count >= x.seatqty) {
            _this8.MinSeatsFlag = true;
          }
          _this8.singleTicketPrice = x.Price;
          _this8.totalAmount += parseFloat(x.Price * x.count);
        }
      });
    },
    onclickSubtract: function onclickSubtract(index) {
      var _this9 = this;

      var checkSeatZero = false;
      this.OnlySeatType = this.OnlySeatType.map(function (x, seatIndex) {
        if (seatIndex == index && x.count > 0) {
          x.count--;
          if (x.count == 0) {
            x["clickDisabled"] = false;
            checkSeatZero = true;
          }
        }
        return x;
      });

      if (checkSeatZero) {
        this.OnlySeatType = this.OnlySeatType.map(function (x, seatIndex) {
          x["clickDisabled"] = false;
          return x;
        });
      }
      this.totalNumberOfSeats = 0;
      this.OnlySeatType.filter(function (x) {
        _this9.totalNumberOfSeats += x.count;
      });
      this.totalAmount = 0.0;
      this.singleTicketPrice = 0.0;
      this.OnlySeatType.filter(function (x) {
        if (x.count > 0) {
          if (x.count < x.seatqty) {
            _this9.MinSeatsFlag = false;
          }
          _this9.singleTicketPrice = x.Price;
          _this9.totalAmount += parseFloat(x.Price * x.count);
        }
      });
    },
    onNewSelectSeatType: function onNewSelectSeatType(type) {
      console.log("type", type);

      // this.showSeatNoModal();
      this.SeatType = type;
      this.SeatTypeMT = type;
      this.SelectedSeatType = type.areaCategoryCode;
      this.selectedSeatType = type.ID;
      // this.OnlySeatType.map(x => {
      //   if (x.SeatType !== type) {
      //     x.count = 0;
      //     x.clickDisabled = false;
      //   }
      // });
      // this.$refs.seattypesmodal.hide();
      // this.getSeatLayoutNew();
    },

    getTempSeatType: function getTempSeatType() {
      var _this10 = this;

      var payload = {
        SchID: this.scheduleID
        // RequiredSeats: this.totalNumberOfSeats
      };
      Object(__WEBPACK_IMPORTED_MODULE_8__helper_internet_js__["makeRequest"])("/GetSeatType", "POST", null, payload).then(function () {
        var _ref5 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3(result) {
          var error, res, __SeatTypes, array, promises;

          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  error = result.error, res = result.res;

                  if (!(!error && res.data.Status && res.data["SeatTypes"] && res.data.SeatTypes.length > 0)) {
                    _context3.next = 13;
                    break;
                  }

                  __SeatTypes = res.data.SeatTypes.filter(function (_ref6) {
                    var SeatLabel = _ref6.SeatLabel;
                    return _this10.SeatTypeMT !== SeatLabel;
                  });
                  array = _this10.OnlySeatType.filter(function (_ref7) {
                    var count = _ref7.count;
                    return count > 0;
                  });

                  if (!(__SeatTypes.length > 0)) {
                    _context3.next = 12;
                    break;
                  }

                  _this10.OnlySeatType = [];
                  promises = res.data.SeatTypes.map(function (x) {
                    _this10.OnlySeatType.push(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, x, {
                      count: array.length > 0 ? array[0].count : 0,
                      clickDisabled: array.length > 0 ? array[0].clickDisabled : false
                    }));
                    return x;
                  });
                  _context3.next = 9;
                  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all(promises);

                case 9:

                  _this10.getSeatLayoutNew();
                  _context3.next = 13;
                  break;

                case 12:
                  _this10.getSeatLayoutNew();

                case 13:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, _this10);
        }));

        return function (_x3) {
          return _ref5.apply(this, arguments);
        };
      }());
    },
    getSeatType: function getSeatType() {
      var _this11 = this;

      console.log("this.OnlySeatType", this.OnlySeatType);
      var payload = {
        SchID: this.scheduleID
        // RequiredSeats: this.totalNumberOfSeats
      };

      Object(__WEBPACK_IMPORTED_MODULE_8__helper_internet_js__["makeRequest"])("/GetSeatType", "POST", null, payload).then(function (result) {
        var error = result.error,
            res = result.res;
        //res.data.Status = false;

        if (!error && res.data.Status) {
          _this11.IsSeatTypePopup = res.data.IsPopup;

          _this11.OnlySeatType = res.data.SeatTypes;
          _this11.OnlySeatType.map(function (x) {
            x["count"] = 0;
            x["clickDisabled"] = false;
            return;
          });
          // this.SeatType = this.OnlySeatType[0].SeatType;
          // if (this.OnlySeatType.length == 1) {
          //   this.SeatType = this.OnlySeatType[0].SeatType;
          // }
          _this11.Currency = res.data.Currency;

          _this11.cinemaDetails = res.data.Cinema;
          _this11.showDate.actualDate = _this11.cinemaDetails.SchDate;
          _this11.showDate.actualtime = _this11.cinemaDetails.Time;
          _this11.SBScreenName = _this11.cinemaDetails.SBScreenName;
          _this11.SchTime = _this11.cinemaDetails.SchTime;

          var parts = _this11.showDate.actualDate.split("-"),
              year = parseInt(parts[0], 10),
              month = parseInt(parts[1], 10) - 1,
              // NB: month is zero-based!
          day = parseInt(parts[2], 10);
          var date1 = new Date(year, month, day);
          _this11.showDate.day = _this11.days[date1.getDay()].substring(0, 3);
          _this11.showDate.date = date1.getDate();
          _this11.showDate.year = year;
          _this11.showDate.month = _this11.months[date1.getMonth()].substring(0, 3);

          _this11.getCinemaMovieTimes({
            MovieID: _this11.$route.params.movieID,
            show_date: _this11.showDate.actualtime,
            cinema_name: _this11.cinemaDetails.CinemaID
          });
          // if (this.IsSeatTypePopup == true) {
          //   this.$refs.showSeatNoModal.show();
          // } else {
          // if (this.IsSeatTypePopup == false) {
          _this11.showSeatNoModal();
          //  }
          // this.getSeatLayoutNew();
          // }
        } else {
          // this.$refs.noseattype.show();
          console.log("else :>> ", "else", res.data.Message);
          // this.SeatType = res.data.Message;
        }
      }).catch(function (error) {
        console.log("Error on vue front", error);
      });
    },
    onSelectSeatType: function onSelectSeatType(type) {
      this.SeatType = type;
    },
    // CardonKeyUp: function(item, e) {
    //   console.log('item :', item,this.creditCardDetails.number[item].length);
    //   if (this.creditCardDetails.number[item].length > 4) {
    //     this.creditCardDetails.number[item] = this.creditCardDetails.number[item][this.creditCardDetails.number[item].length];
    //   }
    //   if (e.keyCode < 58 && e.keyCode > 47) {
    //     let value = "card" + (item + 2);
    //     this.$refs[value].focus();
    //   }
    // },
    fetchMovieDetails: function fetchMovieDetails() {
      var _this12 = this;

      var token = null;
      var payload = {
        MovieID: this.movieID
      };
      // if (this.$persistStore.get("accessToken")) {
      //   token = this.$persistStore.get("accessToken");
      //   payload["access_token"] = token;
      // }
      Object(__WEBPACK_IMPORTED_MODULE_8__helper_internet_js__["makeRequest"])("/GetShowDetails", "POST", null, payload).then(function (response) {
        var error = response.error,
            res = response.res;

        if (!error && res.data) {
          if (!error) {
            _this12.movieDetails = res.data.Show[0];

            var rating = _this12.movieDetails.rated || "";

            if (false) {
              _this12.showRatedModal();
            } else {}
            // this.showSeatNoModal();


            // this.showDetails = res.data.
            // this.movieDetails["url"] =
            //   "/movie-showtimes-page?movieId=" + this.movieDetails.ID;
            // this.movieDetails.IMDBRating = this.movieDetails.IMDBRating.split(
            //   "/"
            // )[0];
            // this.movieDetails.IMDBRating = Math.round(
            //   parseFloat(this.movieDetails.IMDBRating)
            // );
          }
        } else {
          console.log("Response Error ");
        }
      }).catch(function (error) {
        console.log("Error", error);
      });
    },
    confirmNumber: function confirmNumber() {
      __WEBPACK_IMPORTED_MODULE_15_jquery___default()("html, body").animate({
        scrollTop: 0
      }, "slow");
      if (this.totalNumberOfSeats < 1) {
        //   vm.$snack.metodo('Please Pick Number of Seats') // Displays a snackbar without action button
        return;
      }
      if (this.getSeatLayout == true) {
        this.sectionName.noOfSeats = false;
        this.sectionName.seatLayout = true;
        this.$root.$emit("bv::toggle::collapse", "checkout");
        this.getSeatLayoutNew();
      } else {
        this.sectionName.noOfSeats = false;
        //Handle No seat layout
        this.noSeatLayout();

        // this.sectionName.seatLayout = true;
        // this.getSeatLayoutNew();
      }

      // this.startTimer();
    },
    noSeatLayout: function noSeatLayout() {
      var _this13 = this;

      var payload = {
        SchID: this.scheduleID,
        RequiredSeats: this.totalNumberOfSeats
      };

      Object(__WEBPACK_IMPORTED_MODULE_8__helper_internet_js__["makeRequest"])("/SNGetSeatLayout", "POST", null, payload).then(function (result) {
        var error = result.error,
            res = result.res;
        //   const { data } = res.data;

        if (!res.data.Status) {
          _this13.SeatErrormessage = res.data.Message;
        }
        if (!error) {
          _this13.cinemaId = res.data.Cinema;
          console.log("Cinema Array", cinemaId);
          _this13.seatTypes = res.data.SeatTypes;

          console.log("seat type", _this13.seatTypes);
          _this13.selectedSeats = res.data.BookSeatsID;
          _this13.sectionName.noOfSeats = false;
          _this13.sectionName.checkout = true;
          _this13.sectionName.detailFooter = true;
          _this13.startTimer();
          _this13.bookingRequestConfirmSeats();
        } else {
          console.log("error from resp", res.message);
        }
      }).catch(function (error) {
        console.log("Error on vue front", error);
      });
    },
    getSeatLayoutNew: function getSeatLayoutNew() {
      var _this14 = this;

      this.seatLayout = [];
      this.seatTypes = [];
      this.bookingTermsAndConditions = null;
      this.onErrorMeesage = null;
      this.myticketDisplaySeatType = "";
      this.OnlySeatType.map(function (x, index) {
        if (x.count > 0) {
          _this14.myticketDisplaySeatType += _this14.OnlySeatType.length - 1 == index ? x.SeatType + ":" + _this14.Currency + " " + x.Price : x.SeatType + ":" + _this14.Currency + " " + x.Price + " | ";
        }
      });
      // this.showLoading();
      var seatLayoutLoading = this.$loading.show({
        color: __WEBPACK_IMPORTED_MODULE_16__helper_constant_js__["PROJECT"] == "ticketak" ? "#e0007c" : "#AD2318",
        // color: '#AD2318',

        loader: "spinner",
        width: 105,
        height: 105,
        class: "css-loader",
        backgroundColor: "rgba(0, 0, 0, 0.5);",
        opacity: 0.5,
        zIndex: 1000
      });
      var payload = {
        SchID: this.scheduleID,
        RequiredSeats: this.totalNumberOfSeats,
        SelectedSeatType: this.SelectedSeatType
      };
      // if (this.project == "myticketi") {
      //   payload.selectedSeats = this.OnlySeatType;
      // }

      Object(__WEBPACK_IMPORTED_MODULE_8__helper_internet_js__["makeRequest"])("/SNGetSeatLayout", "POST", null, payload).then(function (result) {
        var error = result.error,
            res = result.res;

        _this14.seatLayout = [];
        _this14.seatTypes = [];

        if (!res.data.Status) {
          // this.SeatErrormessage = res.data.Message;
          res.data.Message == "The Requested ShowTime is Expired." ? _this14.SeatErrormessage = "The show you requested is unavailable" : _this14.SeatErrormessage = res.data.Message;
        }
        //   const { data } = res.data;
        if (!error) {
          if (res.data.SeatCatWidth) {
            _this14.SeatCatWidth = res.data.SeatCatWidth;
          }
          if (_this14.SeatCatWidth.length == 0) {
            console.log("this.SeatCatWidth.length :>> ", _this14.SeatCatWidth.length, res.data.SeatLayouts[0].length);
            for (var i = 0; i < res.data.SeatTypes.length; i++) {
              _this14.SeatCatWidth.push((res.data.SeatLayouts[0].length + 1) * 45);
            }
          }
          _this14.cinemaDetails = res.data.Cinema;
          _this14.Default = res.data.Default;
          var d = new Date(0); // The 0 there is the key, which sets the date to the epoch
          d.setUTCSeconds(_this14.cinemaDetails.Time);
          _this14.showDetails.month = d;
          _this14.showDate.actualDate = res.data.SchDate;
          _this14.SBScreenName = res.data.SBScreenName;
          // this.SchTime = res.data.SchTime;
          var parts = _this14.showDate.actualDate.split("-"),
              year = parseInt(parts[0], 10),
              month = parseInt(parts[1], 10) - 1,
              // NB: month is zero-based!
          day = parseInt(parts[2], 10);
          var date1 = new Date(year, month, day);
          _this14.showDate.day = _this14.days[date1.getDay()].substring(0, 3);
          _this14.showDate.date = date1.getDate();
          _this14.showDate.year = year;
          _this14.showDate.month = _this14.months[date1.getMonth()].substring(0, 3);
          if (res.data.FNB) {
            _this14.foodAndBeverages.status = true;
            _this14.getFoodAndBeverages();
          }
          if (_this14.getSeatLayout == "1") {
            if (_this14.project == "ticketak") {
              _this14.seatLayout = res.data.SeatLayouts;
            } else {
              var startSeatLayout = res.data.SeatLayouts;
              var counter = 0;
              var array = [];
              _this14.seatLayout = [];
              _this14.seatTypes = [];
              startSeatLayout.map(function (row, rowIndex) {
                console.log(row, "row");
                row.map(function (singleSeat, singleSeatIndex) {
                  var arrayIndex = array.indexOf(singleSeat.SeatType);

                  if (arrayIndex > -1 && arrayIndex !== array.length - 1) {
                    console.log("singleSeat.SeatType :", singleSeat.SeatType);
                    singleSeat.SeatType = singleSeat.SeatType + "_1";
                    if (array.indexOf(singleSeat.SeatType) === -1) {
                      array.push(singleSeat.SeatType);
                    }
                  } else if (arrayIndex === -1) {
                    array.push(singleSeat.SeatType);
                  }
                });
              });

              // thisstartSeatLayout = [...startSeatLayout].reverse();
              _this14.seatLayout = startSeatLayout.reverse();
            }

            var seatRowType = "";
            console.log(_this14.seatLayout, "jituggg");
            _this14.seatLayout.map(function (seatRow) {
              if (seatRowType != seatRow[0].SeatType) {
                seatRowType = seatRow[0].SeatType;

                _this14.seatTypes.push({
                  ID: seatRow[0]["ID"] || 291,
                  Price: seatRow[0].SeatPrice,
                  SeatID: seatRow[0].SeatClassID,
                  SeatType: seatRowType,
                  isuniqueSeat: seatRow[0].isuniqueSeat,
                  screen_id: seatRow[0].screen_id
                });
                // }
              }
            });
          } else {
            _this14.seatLayout = res.data.SeatLayouts;
            _this14.seatTypes = res.data.SeatTypes;
          }

          console.log(_this14.seatLayout, "hhhh", _this14.seatTypes);
        } else {
          console.log("error from res", res.message);
        }
      }).catch(function (error) {
        console.log("Error on vue front", error);
      }).finally(function () {
        _this14.hideLoading();
        seatLayoutLoading.hide();
      });
    },
    onSelectPromoCode: function onSelectPromoCode(event) {
      var promocode = event.target.value.split("-");
      this.promoCode.selected.Title = promocode[0];
      this.promoCode.selected.PromotionID = promocode[1];
    },

    singleSeatSelectHandler: function singleSeatSelectHandler(seat, rowIndex, seatIndex, originalIndex, backward, e, type) {
      var _this15 = this;

      seat.seatIndex = seatIndex;
      seat.rowIndex = rowIndex;

      console.log(seat, "seat");
      if (type) {
        if (this.SeatType.length > 0 && this.SeatType !== type) {
          this.SeatType = "";
          this.selectedSeats.map(function (x) {
            _this15.seatLayout[x.rowIndex][x.seatIndex].SelectStatus = false;
            _this15.seatLayout[x.rowIndex][x.seatIndex].SelectStatusFlag = false;
          });
          this.selectedSeats = [];
          // this.singleSeatSelectHandler(
          //   this.seatLayout[rowIndex][parseInt(seatIndex)],
          //   rowIndex,
          //   seatIndex,
          //   originalIndex,
          //   backward,
          //   e,
          //   type
          // );
        }
        this.SeatType = type;
      }
      var firstTime = 0;

      if (!originalIndex) {
        firstTime = 1;
        originalIndex = seatIndex;
      } else if (this.totalNumberOfSeats != this.selectedSeats.length) {
        this.seatLayout[rowIndex][seatIndex].SelectStatusFlag = true;
      }

      if (this.seatLayout[rowIndex][seatIndex].SelectStatusFlag == false) {
        if (this.totalNumberOfSeats != this.selectedSeats.length) {
          this.seatLayout[rowIndex][seatIndex].SelectStatusFlag = true;
        }
      }
      //deselect all
      if (this.totalNumberOfSeats == this.selectedSeats.length && firstTime == 1) {
        this.selectedSeats.map(function (x) {
          _this15.seatLayout[x.rowIndex][x.seatIndex].SelectStatus = false;
          _this15.seatLayout[x.rowIndex][x.seatIndex].SelectStatusFlag = false;
        });
        this.selectedSeats = [];
      }

      var removeSeats = this.selectedSeats.filter(function (r) {
        return r.seatIndex == seatIndex && r.rowIndex == rowIndex;
      });

      if (removeSeats.length > 0) {
        var addedSeatIndex = this.selectedSeats.findIndex(function (x) {
          return x.seatIndex === seatIndex && x.rowIndex == rowIndex;
        });
        this.selectedSeats.splice(addedSeatIndex, 1);
        this.seatLayout[rowIndex][seatIndex].SelectStatus = false;
        this.seatLayout[rowIndex][seatIndex].SelectStatusFlag = false;
      } else {
        if (this.seatLayout[rowIndex][seatIndex].SelectStatus == false) {
          //check if seat is selected, if yes, do nothing else
          //check how many selected
          if (parseInt(this.totalNumberOfSeats) - this.selectedSeats.length > 0) {
            this.seatLayout[rowIndex][seatIndex].SelectStatus = true;
            this.seatLayout[rowIndex][seatIndex].SelectStatusFlag = true;
            this.selectedSeats.push(seat);
          }
          var autoSeatIndex = seatIndex;

          var seatsTobeadded = parseInt(this.totalNumberOfSeats - 1) - this.selectedSeats.length;

          for (var z = 0; z <= seatsTobeadded; z++) {
            console.log(seatsTobeadded, "seatsTobeadded");
            if (parseInt(this.totalNumberOfSeats) != this.selectedSeats.length) {
              autoSeatIndex = autoSeatIndex - 1;
              var newSeat = this.seatLayout[rowIndex][autoSeatIndex];
              if (newSeat) {
                //console.log(newSeat, "newSeat");
                if (!newSeat.SeatName || newSeat.SeatName == "" || newSeat.Status != "1" || newSeat.SelectStatusFlag == true || newSeat.SelectStatus == true) {
                  break;
                }
                newSeat.seatIndex = autoSeatIndex;
                newSeat.rowIndex = rowIndex;
                this.seatLayout[rowIndex][autoSeatIndex].SelectStatus = true;
                this.seatLayout[rowIndex][autoSeatIndex].SelectStatusFlag = true;
                this.selectedSeats.push(newSeat);
              }
            }
          }
        }
      }

      this.totalAmount = 0.0;
      this.singleTicketPrice = 0.0;
      this.selectedSeats.map(function (x, index) {
        _this15.singleTicketPrice = x.SeatPrice;
        _this15.totalAmount = parseFloat(_this15.totalAmount) + parseFloat(x.SeatPrice);
      });
    },
    onSelectCategory: function onSelectCategory(value) {
      this.foodAndBeverages.selectedCategory = value;
    },
    onSeatConfirmaton: function onSeatConfirmaton() {
      console.log("onSeatConfirmaton");
      __WEBPACK_IMPORTED_MODULE_15_jquery___default()("html, body").animate({
        scrollTop: 0
      }, "slow");
      this.sectionName.checkout = true;
      this.sectionName.detailFooter = false;
      this.sectionName.seatLayout = false;
      this.totalAmount = parseFloat(this.totalAmount) + parseFloat(this.internetHandling);
      var token2 = __WEBPACK_IMPORTED_MODULE_12__services_storage_service__["TokenService"].getToken();
      if (token2) {
        this.modal = {
          signIn: true,
          guestLogin: true,
          payment: false,
          payUsingWallet: false
        };
        this.getUserDetails();
      } else {
        this.modal = {
          signIn: true,
          guestLogin: true,
          payment: false,
          payUsingWallet: true
        };
      }
      //          this.dropDownFunction();
      this.sectionName.foodAndBeverages = false;
      this.startTimer();
      this.bookingRequestConfirmSeats();
    },
    bookingRequestConfirmSeats: function bookingRequestConfirmSeats() {
      var _this16 = this;

      this.showLoading();
      var payload = {
        SchID: this.scheduleID,
        SelectedSeats: this.selectedSeats,
        movieID: this.movieID,
        cinemaID: this.cinemaDetails.CinemaID
      };
      if (this.project == "myticketi") {
        payload.TicketType = this.OnlySeatType;
      } else {
        console.log("BR OnlySeatType :", this.OnlySeatType, this.SeatType);
        this.OnlySeatType = this.OnlySeatType.map(function (x, seatIndex) {
          if (_this16.SeatType == x.SeatLabel) {
            console.log(_this16.SeatType);
            x.count = _this16.selectedSeats.length;
          }
          return x;
        });
        payload.TicketType = this.OnlySeatType;
      }

      Object(__WEBPACK_IMPORTED_MODULE_8__helper_internet_js__["makeRequest"])("/BookingReserve", "POST", null, payload).then(function (result) {
        var error = result.error,
            res = result.res;
        var data = res.data.data;

        if (!error) {
          console.log("Booking Reserve: ", res.data);
          if (res.data.Status) {
            if (_this16.project == "tickekat") {
              //this.createNgeniusCardSection();
            }

            _this16.reserveID = res.data.ReserveID;
            _this16.isVoucherApplicable = res.data.isVoucherApplicable;
            _this16.isStudent = res.data.isstudentdiscount;
            _this16.discountAmount = res.data.ptdiscount;
            _this16.sectionName.foodAndBeverages = res.data.isfnb;
            //this.foodAndBeverages.selected = res.data.CinemaFNB.FNBCheck;
            console.log("res.data.totalseatcount :", res.data.totalseatcount);
            for (var i = 0; i < _this16.selectedSeats.length; i++) {
              console.log("for i :", i);
              //this.onSelectFoodItem(res.data.CinemaFNB.FNBCheck[0], "add", 0);
            }

            //this.bookFoodAndBeverages();
            _this16.glassval = parseInt(res.data.glassval);
            //this.bookingDetails.ptdvalue = 200;
            window.localStorage.setItem("ReserveID", _this16.reserveID);
            // this.getPaymentOptions();
            _this16.getReservesDetails();
            _this16.paymentBlock = true;
          } else {
            // this.sectionName.checkout = false;
            // this.sectionName.detailFooter = true;
            // this.sectionName.seatLayout = true;
            // this.$toasted.show(
            //   res.data.Message ||
            //     "Sorry! Something went wrong. kindly contact your administrator"
            // );
            _this16.onErrorMeesage = res.data.Message || "Sorry! Something went wrong. kindly contact your administrator";
          }
        }
      }).catch(function (error) {
        console.log("Error on vue front", error);
      }).finally(function () {
        _this16.hideLoading();
      });
    },

    changeNumberFormat: function changeNumberFormat(number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    skipFnB: function skipFnB() {
      var _this17 = this;

      this.foodAndBeverages.selected = [];
      this.fnbQty = 0;
      this.checkFnB = false;
      this.fnbCollapsed = false;
      console.log("F&B", this.foodAndBeverages.listing);
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.foodAndBeverages.listing).map(function (category) {
        _this17.foodAndBeverages.listing[category].map(function (item) {
          item.Qty = 0;
        });
      });
      this.fnbtotal = 0;
      this.removeFnB();
    },
    onSelectFoodItem: function onSelectFoodItem(foodItem, type, index) {
      var _this18 = this;

      console.log("foodItem :", foodItem);
      this.checkFnB = false;
      var currentQty = parseInt(this.foodAndBeverages.listing[foodItem.Category.Title][index].Qty);
      if (type == "add") {
        currentQty += 1;
        if (currentQty <= 10) {
          this.foodAndBeverages.listing[foodItem.Category.Title][index].Qty = currentQty;
          this.fnbtotal = parseInt(this.fnbtotal) + parseInt(foodItem.Amount);
        }
      }
      if (type == "subtract" && this.foodAndBeverages.listing[foodItem.Category.Title][index].Qty != 0) {
        this.foodAndBeverages.listing[foodItem.Category.Title][index].Qty -= parseInt(1);
        this.fnbtotal = parseInt(this.fnbtotal) - parseInt(foodItem.Amount);
      }

      this.foodAndBeverages.selected = [];
      this.fnbQty = 0;
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.foodAndBeverages.listing).map(function (category) {
        _this18.foodAndBeverages.listing[category].map(function (item) {
          if (item.Qty != 0) {
            _this18.foodAndBeverages.selected.push(item);
          }
        });
      });
      this.foodAndBeverages.selected.map(function (fb) {
        _this18.fnbQty = parseInt(_this18.fnbQty) + parseInt(fb.Qty);
      });
      console.log("Selected F&B", this.foodAndBeverages.selected);
      this.checkDiscount = false;
    },

    getFoodAndBeverages: function getFoodAndBeverages() {
      var _this19 = this;

      return false;
      var payload = {
        SchID: this.scheduleID,
        CinemaID: this.cinemaDetails.CinemaID
      };
      var URL = "/GetFnBItems";
      if (this.cinemaDetails.CinemaID == 1) {
        //URL = "/GetFnBItemsCentury";
      } else {
        URL = "/GetFnBItems";
      }
      Object(__WEBPACK_IMPORTED_MODULE_8__helper_internet_js__["makeRequest"])(URL, "POST", null, payload).then(function (result) {
        var error = result.error,
            res = result.res;
        var data = res.data.data;

        if (!error && res.data.Status) {
          _this19.foodAndBeverages.listing = res.data.List;
          _this19.foodAndBeverages.allListing = res.data.List;
          console.log("FnB", _this19.foodAndBeverages.allListing);
          _this19.foodAndBeverages.listing = Object(__WEBPACK_IMPORTED_MODULE_13_lodash__["groupBy"])(_this19.foodAndBeverages.listing, "Category.Title");
          //this.foodAndBeverages.Listing = res.data.ReserveID;
          _this19.sectionName.foodAndBeverages = true;
          console.log(_this19.sectionName.foodAndBeverages);
        }
      }).catch(function (error) {
        console.log("Error on vue front", error);
      });
    },
    removeFnB: function removeFnB() {
      var _this20 = this;

      this.studentIDFilter = [];
      this.studentIDFilter = this.studentIDs.filter(function (x) {
        if (x != "") {
          console.log("index of student id", _this20.studentIDFilter.indexOf(x));
          if (_this20.studentIDFilter.indexOf(x) === -1) {
            return x;
          }
        }
      });
      this.Discount.isstudentcheck = this.studentCheck ? 1 : 0;
      this.Discount.totaldiscountticket = this.studentIDFilter.length;
      this.Discount.totalticketbook = this.totalNumberOfSeats;
      this.Discount.studentvaluearray = this.studentIDFilter;
      var payload = {
        ReserveID: this.reserveID,
        Flag: "Remove",
        StudentFlag: this.studentCheck,
        Discount: this.Discount,
        CinemaID: this.cinemaDetails.CinemaID
      };
      Object(__WEBPACK_IMPORTED_MODULE_8__helper_internet_js__["makeRequest"])("/BookingFNBItem", "POST", null, payload).then(function (result) {
        var error = result.error,
            res = result.res;
        var data = res.data.data;

        if (!error) {
          _this20.fnbCollapsed = false;
          _this20.checkFnB = true;
          _this20.getReservesDetails();
          //this.promotionDiscount();
        }
      }).catch(function (error) {
        console.log("Error on vue front", error);
      });
    },

    bookFoodAndBeverages: function bookFoodAndBeverages() {
      var _this21 = this;

      this.studentIDFilter = [];
      this.studentIDFilter = this.studentIDs.filter(function (x) {
        if (x != "") {
          console.log("index of student id", _this21.studentIDFilter.indexOf(x));
          if (_this21.studentIDFilter.indexOf(x) === -1) {
            return x;
          }
        }
      });
      this.Discount.isstudentcheck = this.studentCheck ? 1 : 0;
      this.Discount.totaldiscountticket = this.studentIDFilter.length;
      this.Discount.totalticketbook = this.totalNumberOfSeats;
      this.Discount.studentvaluearray = this.studentIDFilter;
      var payload = {
        ReserveID: this.reserveID,
        FNB: this.foodAndBeverages.selected,
        Flag: "Add",
        StudentFlag: this.studentCheck,
        Discount: this.Discount,
        CinemaID: this.cinemaDetails.CinemaID
      };
      Object(__WEBPACK_IMPORTED_MODULE_8__helper_internet_js__["makeRequest"])("/BookingFNBItem", "POST", null, payload).then(function (result) {
        var error = result.error,
            res = result.res;
        var data = res.data.data;

        if (!error) {
          _this21.fnbCollapsed = false;
          _this21.checkFnB = true;
          _this21.checkDiscount = true;
          _this21.getReservesDetails();
          //this.promotionDiscount();
        }
      }).catch(function (error) {
        console.log("Error on vue front", error);
      });
    },
    submitUserDetails: function submitUserDetails() {
      var payload = {
        ReserveID: this.reserveID,
        Email: userDetails.email,
        Mobile: userDetails.phoneNumber,
        CountryCode: userDetails.countryCode
      };
      Object(__WEBPACK_IMPORTED_MODULE_8__helper_internet_js__["makeRequest"])("/BookingFNBItem", "POST", null, payload).then(function (nresult) {
        var _result = result,
            error = _result.error,
            res = _result.res;
        var data = res.data.data;

        if (!error) {}
      }).catch(function (error) {
        console.log("Error on vue front", error);
      });
    },
    getReservesDetails: function getReservesDetails() {
      var _this22 = this;

      this.bookingTermsAndConditions = null;

      var payload = {
        ReserveID: this.reserveID,
        ctoken: 1110266398,
        isscb: this.isscb,
        utm: {
          utm_campaign: __WEBPACK_IMPORTED_MODULE_12__services_storage_service__["TokenService"].getUTM("utm_campaign"),
          utm_medium: __WEBPACK_IMPORTED_MODULE_12__services_storage_service__["TokenService"].getUTM("utm_medium"),
          utm_source: __WEBPACK_IMPORTED_MODULE_12__services_storage_service__["TokenService"].getUTM("utm_source")
        }
      };
      Object(__WEBPACK_IMPORTED_MODULE_8__helper_internet_js__["makeRequest"])("/ReserveDetails", "POST", null, payload).then(function (result) {
        var error = result.error,
            res = result.res;

        if (!error && res.data.Status) {
          _this22.bookingDetails = res.data;
          _this22.bookingTermsAndConditions = res.data["TermsAndConditions"] || null;

          //this.bookingDetails.glassInfoHover = true;
          //this.bookingDetails.glassInfoMessage = "*These are the fees for the 3D glasses which are compulsory and collected on behalf of the cinema management. In case you have any concerns, please reach out to the manager / customer service desk at the cinema.";
          if (_this22.bookingDetails.fnb_total > 0) {
            _this22.bookingDetails.total_amt = parseInt(_this22.bookingDetails.total_amt) + parseInt(_this22.bookingDetails.fnb_total);
            _this22.glassval = parseInt(_this22.bookingDetails.glassval);
          }
          if (_this22.bookingDetails.Ispromotionsctive == 1) {
            _this22.isPromo = true;
          }
          _this22.bookingDetailsCopy = res.data;
          console.log("glass val", _this22.glassval);
          //this.promotionDiscount();

          if (_this22.bookingDetails.Offer == 1 && _this22.offerPopupCheck) {
            _this22.$refs.offermodal.show();
            _this22.offerPopupCheck = false;
          }

          _this22.hideLoading();
        }
      }).catch(function (error) {
        console.log("Error on vue front", error);
        _this22.hideLoading();
      });
    },

    // getPaymentOptions: function () {
    //   this.savedCreditCards = [];
    //   let payload = {
    //     ReserveID: this.reserveID,
    //   };
    //   makeRequest("/GetPaymentOptions", "POST", null, payload)
    //     .then((result) => {
    //       const { error, res } = result;
    //       if (!error && res.status) {
    //         //   console.log(" pay Options res ", res);
    //         // console.log(" pay Options Data ", res.data);
    //         res.data.Paymentoptions.forEach((singlePaymentOption) => {
    //           if (singlePaymentOption.PaymentID == 3) {
    //             singlePaymentOption.Cards = singlePaymentOption.Cards.forEach(
    //               (x) => {
    //                 x["CVV"] = "";
    //                 this.savedCreditCards.push(x);
    //               }
    //             );
    //             //   this.savedCreditCards = singlePaymentOption.Cards;
    //             // console.log('test1', this.savedCreditCards,singlePaymentOption.Cards )
    //           }
    //         });
    //         this.newPaymentOptions = res.data.Paymentoptions;
    //         // this.savedCreditCards = res.data.Paymentoptions[1];
    //         // this.paymentOptions = data.paymentOptions.Paymentoptions;
    //       } else {
    //         console.log("error from res", res.message);
    //       }
    //     })
    //     .catch((error) => {
    //       console.log("Error on vue front", error);
    //     });
    // },
    onRemoveCard: function onRemoveCard(card) {
      var _this23 = this;

      var token = __WEBPACK_IMPORTED_MODULE_12__services_storage_service__["TokenService"].getToken();
      var payload = {
        CardID: card.cardID
      };
      Object(__WEBPACK_IMPORTED_MODULE_8__helper_internet_js__["makeRequest"])("/RemoveCard", "POST", token, payload).then(function (result) {
        var error = result.error,
            res = result.res;

        if (!error && res.data.Status) {
          _this23.$toasted.show(res.data.Message);
          //this.getPaymentOptions();
          _this23.getSavedCards();
          setTimeout(function () {
            _this23.$toasted.clear();
          }, 3000);
        } else {
          _this23.cardError = res.data.Message;
          _this23.$toasted.show(res.data.Message);
          setTimeout(function () {
            _this23.$toasted.clear();
          }, 3000);
        }
      }).catch(function (error) {
        console.log("Error on vue front", error);
      });
    },
    verifyPromotion: function verifyPromotion(type) {
      var _this24 = this;

      //console.log("Promo Data - ", promo);
      var token = __WEBPACK_IMPORTED_MODULE_12__services_storage_service__["TokenService"].getToken();
      this.VoucherMsg = "";

      var payload = {
        voucher_code: this.voucherCode,
        movieID: this.movieID,
        cinemaID: this.cinemaDetails.CinemaID,
        reserveID: this.reserveID,
        activityType: type
      };
      Object(__WEBPACK_IMPORTED_MODULE_8__helper_internet_js__["makeRequest"])("/verifyVoucher", "POST", token, payload).then(function (result) {
        var error = result.error,
            res = result.res;

        if (!error && res.data.Status) {
          _this24.voucherApplied = true;
          _this24.VoucherMsg = res.data.Message;
          _this24.getReservesDetails();
          if (type == "0") {
            _this24.voucherCode = "";
            _this24.voucherApplied = false;
          }
          //
        } else {
          _this24.hideLoading();
          _this24.VoucherMsg = res.data.Message;
        }
      }).catch(function (error) {
        _this24.hideLoading();
        //  this.promoCode.errorMessage = "Something went wrong";
      });
    },
    editDetails: function editDetails() {
      this.modal.signIn = true;
      this.modal.userTicketsDetails = false;
      this.modal.payment = false;
    },

    processPayment: function processPayment() {
      var _this25 = this;

      var token2 = __WEBPACK_IMPORTED_MODULE_12__services_storage_service__["TokenService"].getToken();

      var payload = {
        ReserveID: this.reserveID,
        PaymentID: 1
        // PromotionID: 0
      };
      if (this.promoCode.selected) {
        payload.PromotionID = this.promoCode.selected.PromotionID;
      }
      Object(__WEBPACK_IMPORTED_MODULE_8__helper_internet_js__["makeRequest"])("/ProcessPayment", "POST", token2, payload).then(function (result) {
        var error = result.error,
            res = result.res;

        if (res.data.Status) {
          _this25.showOTP = true;
        } else {
          _this25.ProcessPaymentMessage = res.data.Message;
        }
      }).catch(function (error) {
        _this25.ProcessPaymentMessage = "Something went wrong";
      });
    },
    onRemoveReferralPromotion: function onRemoveReferralPromotion() {
      var _this26 = this;

      console.log("Promo Data - ", this.promoCode);
      this.SelectedReferralCode.map(function (x) {
        var indexNew = _this26.promoCode.promoList.findIndex(function (y) {
          return x.ID == y.ID;
        });
        console.log("indexNew :", indexNew);
        if (indexNew >= 0) {
          _this26.promoCode.promoList[indexNew]["Apply"] = false;
        }
      });
      var token = __WEBPACK_IMPORTED_MODULE_12__services_storage_service__["TokenService"].getToken();
      this.promoCode.message = "";
      var payload = {
        ReserveID: this.reserveID,
        flag: "Remove",
        PromotionID: 1,
        Tab: "Referral"
      };
      console.log("Referral payload :", payload);
      Object(__WEBPACK_IMPORTED_MODULE_8__helper_internet_js__["makeRequest"])("/VerifyPromotion", "POST", token, payload).then(function (result) {
        var error = result.error,
            res = result.res;

        if (!error && res.data.Status) {
          _this26.promoApplied = false;
          //this.onRemovedPromocode();
          _this26.getReservesDetails();
        } else {
          _this26.promoCode.promoList[promokey]["errorMessage"] = res.data.Message;
          _this26.promoCode.errorMessage = res.data.Message;
        }
      }).catch(function (error) {
        _this26.promoCode.errorMessage = "Something went wrong";
      });
    },
    onRemovedPromocode: function onRemovedPromocode() {
      var _this27 = this;

      this.isPromoFromList = false;
      this.promoApplied = false;
      this.promoCode.message = "";
      this.promoCode.selected.Title = "";
      this.promoCode.selected.Name = "";
      this.promoCode.selected.PromotionID = "";
      this.promoCode.promoList = [];
      this.promoCode.errorInputMessage = "";
      this.promoCode.errorMessage = "", this.promoCode.successMessage = "", this.promoCodeapplied = false;
      this.bookingDetails = this.bookingDetailsCopy;

      /* Remove Coupon Applied */
      var token = __WEBPACK_IMPORTED_MODULE_12__services_storage_service__["TokenService"].getToken();
      this.promoCode.message = "";
      var payload = {
        ReserveID: this.reserveID,
        flag: "Remove",
        PromotionID: 1,
        Tab: "Promotions"
      };
      Object(__WEBPACK_IMPORTED_MODULE_8__helper_internet_js__["makeRequest"])("/VerifyPromotion", "POST", token, payload).then(function (result) {
        var error = result.error,
            res = result.res;

        if (!error && res.data.Status) {
          _this27.promoApplied = false;
          //this.onRemovedPromocode();
          _this27.getReservesDetails();
        } else {
          _this27.promoCode.promoList[promokey]["errorMessage"] = res.data.Message;
          _this27.promoCode.errorMessage = res.data.Message;
        }
      }).catch(function (error) {
        _this27.promoCode.errorMessage = "Something went wrong";
      });
      /* Remove Coupon Applied */

      this.getPromotionList();
    },
    showApplyCouponModal: function showApplyCouponModal() {
      if (!this.studentCheck) {
        this.$refs.applycouponModal.show();
      } else {
        this.promotionNotAllowed = "You have already applied for a coupon.";
        this.$refs.couponNotAllowed.show();
      }
    },
    hideReferralModal: function hideReferralModal() {
      this.$refs.applycouponModal.hide();
    },
    onselectcard: function onselectcard(card) {
      this.selectedCard = card;
    },
    couponNotAllowedHide: function couponNotAllowedHide() {
      this.promotionNotAllowed = "";
      this.$refs.couponNotAllowed.hide();
    },
    onClickExpressPay: function onClickExpressPay() {
      console.log("this.selectedCard.CVV :", this.selectedCard.cardID);
      /*let self = this;
      self.showLoading();
      var sessionId;
      window.NI.generateSessionId()
        .then(function(response) {
          sessionId = response.session_id;
          console.log(sessionId);
          if (typeof response.session_id !== "undefined") {
            let payload = {
              ReserveID: self.reserveID,
              sid: sessionId,
              saveCard: self.savecardradio ? 1 : 0,
              cardID: 0 //self.selectedCard.cardID
            };
            console.log("payload :", payload);
            makeRequest("/NProcessPayment", "POST", null, payload)
              .then(response => {
                console.log("result :", response);
                const { res } = response;
                // console.log('Data :', Data);
                if (res.data.Status) {
                  document.getElementById("3ds_iframe").innerHTML =
                    res.data.Data;
                  self.paymentBlock = false;
                  self.check3ds(res.data.Data);
                  self.hideLoading();
                } else {
                  self.$toasted.show(res.data.Message, {
                    position: "top-center",
                    duration: 5000
                  });
                }
              })
              .catch(error => {
                self.$toasted.show(error, {
                  position: "top-center",
                  duration: 5000
                });
              });
            // $.ajax({
            //     url: "http://192.168.1.155/pay.php",
            //     type: "post",
            //     dataType: 'json',
            //     data: {
            //         sid: sessionId
            //     },
            //     success: function (result) {
            //       console.log('result :', result);
            //         document.getElementById("3ds_iframe").innerHTML = result;
            //         self.check3ds(result);
            //     },
            //     error: function (error) {
            //         console.log(error);
            //         self.$toasted.show(error, {
            //             position: "top-center",
            //             duration : 5000
            //     });
            //     }
            // });
          } else {
            self.$toasted.show(
              "Session cannot be generated, Please try again later",
              {
                position: "top-center",
                duration: 5000
              }
            );
          }
        })
        .catch(error => {
          console.log("error :", error);
          self.$toasted.show(error, {
            position: "top-center",
            duration: 5000
          });
        });*/
      this.PayViaNgenius(this.selectedCard.cardID);
      /*this.showLoading();
      let token = TokenService.getToken();
      let payload = {
        PaymentID: "3",
        ReserveID: this.reserveID,
        CVV: this.selectedCard.CVV,
        cardID: this.selectedCard.cardID,
        PromotionID: 0
      };
      makeRequest("/ProcessPayment", "POST", token, payload)
        .then(result => {
          this.hideLoading();
          const { error, res } = result;
          // if (!error && res.data.Status) {
          if (res.data._3DSecure == true) {
            let otpUrl = res.data._links.acsUrl;
            // this.bankPage.src = otpUrl;
            // console.log("otpUrl :", otpUrl);
            window.open(otpUrl, "_self");
          } else if (res.data._3DSecure == false) {
            window.location.pathname =
              "/processPayment/" + this.reserveID + "/" + res.data.token;
          }
          // if (res.data.ErrDesc && res.data.ErrDesc.ErrorCode == 1) {
          //   this.creditCardDetails.error = res.data.ErrDesc.ErrorMessage;
          // } else {
          //   this.bankPage.src = res.data.ErrDesc._links.acsUrl;
          // }
          else {
            this.cardError = res.data.Message;
            console.log("error from res", res.message);
          }
        })
        .catch(error => {
          this.cardError = "Please Provide Valid card details";
           console.log("Error on vue front", error);
        });*/
    },
    confirmBooking: function confirmBooking() {
      var _this28 = this;

      var payload = {
        ReserveID: this.reserveID,
        PaymentID: 1,
        LanguageID: 2,
        CountryID: 230,
        OTP: this.OTP
      };
      //if token send token else empty
      Object(__WEBPACK_IMPORTED_MODULE_8__helper_internet_js__["makeRequest"])("/ConfirmBooking", "POST", null, payload).then(function (result) {
        var error = result.error,
            res = result.res;

        if (!error && res.data.Status) {
          _this28.finalBookingID = res.data.BookingID;
          _this28.getBookingDetails();
        } else {
          _this28.ProcessPaymentMessage = res.data.Message;
        }
      }).catch(function (error) {
        _this28.ProcessPaymentMessage = "Something went wrong";
        console.log("Error on vue front", error);
      });
    },
    getBookingDetails: function getBookingDetails() {
      var _this29 = this;

      var payload = {
        BookingID: this.finalBookingID
      };

      Object(__WEBPACK_IMPORTED_MODULE_8__helper_internet_js__["makeRequest"])("/GetBookingDetails", "POST", null, payload).then(function (result) {
        var error = result.error,
            res = result.res;

        console.log("booking fetch final Confirmation", res.data);
        if (!error) {
          _this29.finalBookingDetails = res.data;
          _this29.sectionName.checkout = false;
          _this29.$refs.OTPModal.show();
          _this29.sectionName.confirmation = true;
        } else {
          console.log("error from res", res.message);
        }
      }).catch(function (error) {
        console.log("Error on vue front", error);
      });
    },
    selectPromoFromList: function selectPromoFromList(promo, e) {
      e.preventDefault();
      if (this.promoCode.selected.Title == "Reset Offer") {
        this.promoCode.selected = {
          Title: "Select Offer"
        };
        return;
      } else {
        this.promoCode.selected = promo;
      }
    },
    restartBooking: function restartBooking(e) {
      e.preventDefault();
      var movieId = this.$route.query.movieID;
      var scheduleId = this.$route.query.scheduleID;
      var seatLayout = this.$route.query.seatLayout;
      window.location = "/checkout/" + scheduleId + "/" + movieId + "/" + seatLayout;
    },
    payUsingWallet: function payUsingWallet() {
      var _this30 = this;

      var token = this.$persistStore.get("accessToken");
      var payload = {
        access_token: token,
        usertranstion: {
          Amount: this.totalAmount + this.seatData.ConFee * this.selectedSeats.length - this.discount,
          Narration: "Booked ticket for The Godfather",
          OrderId: this.bookingID,
          PaymentType: 3,
          TransType: 0,
          UserId: "105"
        }
      };
      Object(__WEBPACK_IMPORTED_MODULE_8__helper_internet_js__["makeRequestDirect"])("/cinematic/DebitTransation", "POST", null, payload).then(function (result) {
        var error = result.error,
            res = result.res;

        console.log("payment request", res.data);
        if (!error) {
          _this30.walletResponse = res.data;
          _this30.OTPScreen = true;
        } else {
          console.log("error from res", res.message);
        }
      }).catch(function (error) {
        console.log("Error on vue front", error);
      });
    },

    makeSavedCardPayment: function makeSavedCardPayment(cardID, CVV, $event) {
      console.log("cardID", cardID);
      $event.preventDefault();
      var token = this.$persistStore.get("accessToken");
      console.log("cardID", cardID);
      var payload = {
        PaymentID: "3",
        access_token: token,
        bookingOrderId: this.bookingID,
        cardDetails: {
          CVV: CVV,
          CardID: cardID
        }
      };
      Object(__WEBPACK_IMPORTED_MODULE_8__helper_internet_js__["makeRequestDirect"])("/ProcessPayment", "POST", null, payload).then(function (result) {
        var error = result.error,
            res = result.res;

        console.log("payment request", res.data);
        if (!error) {
          console.log("otp page");
        } else {
          console.log("error from res", res.message);
        }
      }).catch(function (error) {
        console.log("Error on vue front", error);
      });
    },

    validateBeforeSubmit: function validateBeforeSubmit(scope) {
      var _this31 = this;

      if (scope == "cardDetails") {
        this.$validator.validateAll(scope).then(function (result) {
          if (result) {
            //this.makeCardPayment();
            _this31.PayViaNgenius(0);
            return;
          }
        });
      } else if (scope == "bookUser") {
        // console.log("Hello", this.checkoutButtonStatus)
        // if (this.checkoutButtonStatus) {

        // } else {
        //   this.showPaymentCollapse = false;
        // }
        this.studentIDFilter = [];
        this.studentIDFilter = this.studentIDs.filter(function (x) {
          if (x != "") {
            console.log("index of student id", _this31.studentIDFilter.indexOf(x));
            if (_this31.studentIDFilter.indexOf(x) === -1) {
              return x;
            }
          }
        });

        this.checkDiscount = true;

        console.log("Student", this.studentIDFilter);
        console.log("Total Ticket", this.totalNumberOfSeats);
        console.log("Student ID Count", this.studentIDFilter.length);
        console.log("Student Check", this.studentCheck ? 1 : 0);
        this.$validator.validateAll(scope).then(function (result) {
          _this31.Discount.isstudentcheck = _this31.studentCheck ? 1 : 0;
          _this31.Discount.totaldiscountticket = _this31.studentIDFilter.length;
          _this31.Discount.totalticketbook = _this31.totalNumberOfSeats;
          _this31.Discount.studentvaluearray = _this31.studentIDFilter;
          if (result) {
            var payload = {
              Email: _this31.userDetails.email,
              Mobile: _this31.userDetails.phoneNumber,
              ReserveID: _this31.reserveID,
              CountryCode: _this31.userDetails.countryCode || 91,
              Discount: _this31.Discount
            };
            Object(__WEBPACK_IMPORTED_MODULE_8__helper_internet_js__["makeRequest"])("/UpdateBookUser", "POST", null, payload).then(function (response) {
              var error = response.error,
                  res = response.res;

              if (!error && res.data.Status) {
                // this.checkingOnPaymentCall();
                _this31.modal.signIn = false;
                _this31.modal.payUsingWallet = false;
                _this31.modal.userTicketsDetails = true;
                _this31.modal.payment = true;
                _this31.verifyError = "";
                console.log("payment_options :");
                _this31.firstCollapsed = false;
                _this31.secondCollapsed = true;
                _this31.$root.$emit("bv::toggle::expand", "payment_options");
                // this.$refs.OTPModal.show();
                // this.processPayment();
                if (_this31.project == "ticketak") {
                  _this31.getSavedCards();
                }
                _this31.onErrorMeesage = null;
                _this31.getPaymentOptions();
                _this31.getReservesDetails();
              } else {
                _this31.onErrorMeesage = res.data.Message;
                _this31.showPaymentCollapse = false;
                _this31.verifyError = res.data.Message;
                _this31.checkoutButtonStatus = false;
                setTimeout(function () {
                  var elmnt = document.getElementById("errorMsgDisplay");
                  elmnt.scrollIntoView({
                    behavior: "smooth",
                    inline: "start"
                  });
                }, 0);
              }
            }).catch(function (error) {
              _this31.verifyError = "Something went wrong";
            });
            return;
          }
        });
      }
    },

    getSavedCards: function getSavedCards() {
      var _this32 = this;

      //let token = this.$persistStore.get("accessToken");
      var token = "";
      var payload = {
        email: this.userDetails.email
      };
      console.log("payload :", payload);
      Object(__WEBPACK_IMPORTED_MODULE_8__helper_internet_js__["makeRequest"])("/GetSavedCards", "POST", null, payload).then(function (result) {
        var error = result.error,
            res = result.res;

        if (!error && res.data.Status) {
          if (res.data.Cards.length > 0) {
            _this32.savedCreditCards = res.data.Cards;
          }
        } else {
          console.log("error from res", res.message);
        }
      }).catch(function (error) {
        console.log("Error on vue front", error);
      });
    },
    onclickpaynow: function onclickpaynow(ind) {
      this.showLoading();
      console.log("ind", ind);
      window.location.href = this.payment_options[ind].redirect_url + "&reserve_id=" + this.reserveID;
    },
    onclickpaynow1: function onclickpaynow1() {
      window.localStorage.setItem("IHC", this.bookingDetails.total_internet_handling_amt);
      window.localStorage.setItem("sku", this.scheduleID);
      var singleTicketPrice = parseFloat(this.bookingDetails.amount) / parseInt(this.totalNumberOfSeats);
      window.localStorage.setItem("STP", singleTicketPrice);

      // let route = this.$router.resolve({ path: this.bookingDetails.PayURL });
      window.open(this.bookingDetails.PayURL, "_self");

      // if (this.project == "ticketak") {
      //   // this.PayViaNgenius();
      //   this.payNowNetowrk();
      //   //this.checkingOnPaymentCall();
      // } else if (this.project == "myticketi") {
      //   this.$refs.redirectPayment.show();
      // }
    },

    PayViaNgenius: function PayViaNgenius(cardID) {
      var _this33 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var self, sessionId;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                self = _this33;

                self.showLoading();
                _context4.next = 4;
                return window.NI.generateSessionId().then(function (response) {
                  sessionId = response.session_id;
                  console.log(sessionId);
                  if (typeof response.session_id !== "undefined") {
                    var payload = {
                      ReserveID: self.reserveID,
                      sid: sessionId,
                      saveCard: self.savecardradio ? 1 : 0,
                      cardID: cardID
                    };
                    console.log("payload :", payload);
                    Object(__WEBPACK_IMPORTED_MODULE_8__helper_internet_js__["makeRequest"])("/NProcessPayment", "POST", null, payload).then(function (response) {
                      console.log("result :", response);
                      var res = response.res;
                      // console.log('Data :', Data);

                      if (res.data.Status) {
                        document.getElementById("3ds_iframe").innerHTML = res.data.Data;
                        self.paymentBlock = false;
                        self.check3ds(res.data.Data);
                        self.hideLoading();
                      } else {
                        self.$toasted.show(res.data.Message, {
                          position: "top-center",
                          duration: 5000
                        });
                      }
                    }).catch(function (error) {
                      self.$toasted.show(error, {
                        position: "top-center",
                        duration: 5000
                      });
                    });
                    // $.ajax({
                    //     url: "http://192.168.1.155/pay.php",
                    //     type: "post",
                    //     dataType: 'json',
                    //     data: {
                    //         sid: sessionId
                    //     },
                    //     success: function (result) {
                    //       console.log('result :', result);
                    //         document.getElementById("3ds_iframe").innerHTML = result;
                    //         self.check3ds(result);
                    //     },
                    //     error: function (error) {
                    //         console.log(error);
                    //         self.$toasted.show(error, {
                    //             position: "top-center",
                    //             duration : 5000
                    //     });
                    //     }
                    // });
                  } else {
                    self.$toasted.show("Session cannot be generated, Please try again later", {
                      position: "top-center",
                      duration: 5000
                    });
                  }
                }).catch(function (error) {
                  self.$toasted.show(error, {
                    position: "top-center",
                    duration: 5000
                  });
                }).finally(function () {
                  self.hideLoading();
                });

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this33);
      }))();
    },
    check3ds: function check3ds(paymentResponse) {
      var self = this;
      if (typeof paymentResponse.orderReference !== "undefined") {
        window.NI.handlePaymentResponse(paymentResponse, {
          mountId: "3ds_iframe"
        }).then(function (response) {
          var status = response.status;

          console.log(status);
          console.log(paymentResponse.orderReference);
          if (status == "AUTHORISED" && paymentResponse && paymentResponse.orderReference && paymentResponse.orderReference.length > 0) {
            self.makeTransactions(paymentResponse);
            //self.authoriseReserve(self.reserveID, status, paymentResponse);
          } else {
            self.$toasted.show(status, {
              position: "top-center",
              duration: 5000
            });
          }
        });
      } else {
        self.$toasted.show("Unable to process payment", {
          position: "top-center",
          duration: 5000
        });
        //document.getElementById("error").style.display = "block";
        //document.getElementById("error").innerHTML = paymentResponse.error;
      }
    },
    authoriseReserve: function authoriseReserve(ReserveID, Status, paymentResponse) {
      var self = this;
      var payload = {
        ReserveID: ReserveID,
        Status: Status
      };
      Object(__WEBPACK_IMPORTED_MODULE_8__helper_internet_js__["makeRequest"])("/AuthoriseCheck", "POST", null, payload).then(function (response) {
        var res = response.res;

        if (Status == "AUTHORISED" && paymentResponse && paymentResponse.orderReference && paymentResponse.orderReference.length > 0) {
          self.makeTransactions(paymentResponse);
        } else {
          self.$toasted.show(status, {
            position: "top-center",
            duration: 5000
          });
        }
      }).catch(function (error) {
        self.$toasted.show(error, {
          position: "top-center",
          duration: 5000
        });
      });
    },
    makeTransactions: function makeTransactions(paymentResponse) {
      var self = this;
      var payload = {
        ReserveID: self.reserveID,
        orderReference: paymentResponse.orderReference
      };
      Object(__WEBPACK_IMPORTED_MODULE_8__helper_internet_js__["makeRequest"])("/ProcessTicket", "POST", null, payload).then(function (response) {
        var res = response.res;

        if (res.data.Status) {
          self.$router.push({
            path: "/paymentCheck?ref=" + paymentResponse.orderReference + "&rid=" + self.reserveID
          });
        } else if (res.data.Rebook) {
          self.makeTransactions(paymentResponse);
        } else {
          self.$toasted.show(res.data.Message, {
            position: "top-center",
            duration: 5000
          });
        }
      }).catch(function (error) {
        self.$toasted.show(error, {
          position: "top-center",
          duration: 5000
        });
      });
    },

    makeCardPayment: function makeCardPayment() {
      var _this34 = this;

      this.showLoading();
      var token = __WEBPACK_IMPORTED_MODULE_12__services_storage_service__["TokenService"].getToken();
      var payload = {
        PaymentID: "2",
        // access_token: token,
        ReserveID: this.reserveID,
        PromotionID: 0,
        // cardDetails: {
        cardNumber: this.creditCardDetails.number.toString().replace(/,/g, ""),
        expiryMonth: this.creditCardDetails.expiryMonth,
        expiryYear: this.creditCardDetails.expiryYear,
        CVV: this.creditCardDetails.cvv,
        cardNameHolder: this.creditCardDetails.name,
        saveCard: "1"
        // }
      };
      if (!this.creditCardDetails.saveCard) {
        payload.saveCard = "0";
      }
      Object(__WEBPACK_IMPORTED_MODULE_8__helper_internet_js__["makeRequest"])("/ProcessPayment", "POST", null, payload).then(function (result) {
        _this34.hideLoading();
        var error = result.error,
            res = result.res;

        console.log("payment request", res.data);
        // if (!error && res.data.Status) {
        if (res.data._3DSecure == true) {
          var otpUrl = res.data._links.acsUrl;
          // this.bankPage.src = otpUrl;
          // console.log("otpUrl :", otpUrl);
          window.open(otpUrl, "_self");
        } else if (res.data._3DSecure == false) {
          window.location.pathname = "/processPayment/" + _this34.reserveID + "/" + res.data.token;
        }
        // if (res.data.ErrDesc && res.data.ErrDesc.ErrorCode == 1) {
        //   this.creditCardDetails.error = res.data.ErrDesc.ErrorMessage;
        // } else {
        //   this.bankPage.src = res.data.ErrDesc._links.acsUrl;
        // }
        // }
        else {
            _this34.cardError = res.data.Message;
            console.log("error from res", res.message);
          }
      }).catch(function (error) {
        _this34.cardError = "Please Provide Valid card details";

        console.log("Error on vue front", error);
      });
    },
    bookingOrderConfirm: function bookingOrderConfirm() {
      var _this35 = this;

      var token = this.$persistStore.get("accessToken");
      var payload = {
        OTP: "1234",
        PaymentID: "1",
        access_token: token,
        bookingOrderId: this.bookingID
      };

      Object(__WEBPACK_IMPORTED_MODULE_8__helper_internet_js__["makeRequestDirect"])("/cinematic/BookingOrderConfirm", "POST", null, payload).then(function (result) {
        var error = result.error,
            res = result.res;

        console.log("booking OTP Confirmation", res.data);
        if (!error) {
          _this35.sectionName = {
            seatLayout: false,
            checkout: false,
            confirmation: true,
            noOfSeats: false,
            typeSelector: false
          };
          _this35.finalBookingID = res.data.BookingOrderId;
          _this35.getBookingDetails();
        } else {
          console.log("error from res", res.message);
        }
      }).catch(function (error) {
        console.log("Error on vue front", error);
      });
    },

    // editContactDetailsToggle: function(e) {
    //   if (e) e.preventDefault();
    //   this.paymentModal.editContactDetails = !this.paymentModal
    //     .editContactDetails;
    //   this.paymentModal.viewContactDetails = !this.paymentModal
    //     .viewContactDetails;
    // },
    submitContactDetails: function submitContactDetails(e) {
      e.preventDefault();
      //TODO Submit New Contact Details

      this.editContactDetailsToggle();
    },
    startTimer: function startTimer() {
      var _this36 = this;

      this.timerStartFunction = setInterval(function () {
        var self = _this36;
        if (_this36.timer.stop == true) {
          return;
        }
        if (parseInt(_this36.timer.seconds) == 0 && parseInt(_this36.timer.minutes) == 0) {
          // this.timer.seconds = 60;
          _this36.timer.stop = false;
          clearTimeout(self.timerStartFunction);
          _this36.$refs.sessionTimeOut.show();
          _this36.sessionExpired();
          return false;
        }
        if (_this36.timer.seconds == "00" && _this36.timer.minutes == 2
        // sectionName.checkout == true
        ) {
            _this36.$refs.hurryupmodal.show();
            setTimeout(function () {
              _this36.$refs.hurryupmodal.hide();
            }, 10000);
          }

        if (parseInt(_this36.timer.seconds) == 0) {
          _this36.timer.seconds = 60;
        }
        _this36.timer.seconds = parseInt(_this36.timer.seconds) - 1;
        if (_this36.timer.seconds < 10) {
          _this36.timer.seconds = "0" + _this36.timer.seconds;
        }
      }, 1000);
      var myVar = setInterval(function () {
        if (_this36.timer.stop == true) {
          return;
        }
        if (_this36.timer.minutes == 0 && _this36.sectionName.checkout == true) {
          //TODO Show timeout message and a redirect button
          _this36.$refs.sessionTimeOut.show();
          _this36.sessionExpired();
          clearTimeout(myVar);
          _this36.timer.TimeoutModal = true;
          _this36.timer.minutes = 0;
          _this36.timer.seconds = 0;
          _this36.timer.stop = true;
        }
        _this36.timer.minutes = parseInt(_this36.timer.minutes) - 1;
      }, 60000);
    },
    userSigninModalBack: function userSigninModalBack(e) {
      e.preventDefault();
      this.modal = {
        signIn: true,
        guestLogin: false,
        payment: false
      };
    },
    getIPAddress: function getIPAddress() {
      var _this37 = this;

      Object(__WEBPACK_IMPORTED_MODULE_8__helper_internet_js__["makeRequest"])("/GetCountryList", "POST", null, null).then(function (response) {
        var error = response.error,
            res = response.res;
        var data = res.data.data;

        _this37.UserIPAddress = res.data.Default.IPAddress;
        _this37.Default = res.data.Default;
      }).catch(function (error) {
        console.log("Error", error);
        //   resolve(null);
      });
    },
    editNumberOfSeats: function editNumberOfSeats(number) {
      this.totalNumberOfSeats = number;
    },
    showUserLogInModal: function showUserLogInModal(e) {
      e.preventDefault();
      this.modal = {
        signIn: true,
        guestLogin: false,
        payment: false
      };
    },
    showGuestModal: function showGuestModal(e) {
      e.preventDefault();
      this.modal = {
        signIn: false,
        guestLogin: true,
        payment: false
      };
    },
    checkOutAsGuest: function checkOutAsGuest() {
      //Save Details to user Details
      //check values of details
      if (this.userDetails && this.phoneNumber) {
        this.insertBookingOrderUserDetails();
        this.sectionName.checkout = true;
        this.modal.payment = true;
        modal.guestLogin = false;
      } else {
        this.guest.errorMessage = "Please enter a valid email and Phone Number";
      }

      //show payment details
    },
    getUserDetails: function getUserDetails(callback) {
      var _this38 = this;

      var payload = {};

      Object(__WEBPACK_IMPORTED_MODULE_8__helper_internet_js__["makeRequest"])("/GetProfile", "POST", null, payload).then(function (result) {
        var error = result.error,
            res = result.res;

        if (!error && res.status) {
          console.log("get User Details Data on my account  >>", res.data);
          // userDetails
          _this38.userDetails.email = res.data.Email;
          _this38.userDetails.phoneNumber = res.data.Mobile;
          _this38.userDetails.userName = res.data.UserName;
          _this38.userDetails.countryCode = res.data.CountryCode;
          _this38.modal.payUsingWallet = false;
          _this38.onKeyUp(null, "email");
          _this38.isUserLoggedIn = true;
          _this38.onKeyUp(null, "mobile");
          //   this.userDetails.phoneNumber = data.userDetails.MobileNo.replace(
          //       /\D/g,
          //       ""
          //   );
          if (callback) {
            callback();
          }
          //   this.userDetails.profilePic =
          //       data.userDetails.ProfileURl.length > 0
          //           ? data.userDetails.ProfileURl
          //           : "/images/svg/icon-profile.svg";
          //   this.loginData.loginInput.email = data.userDetails.Email;
        } else {
          console.log("error from res", res.message);
        }
      }).catch(function (error) {
        console.log("Error on vue front", error);
      });
    },
    onConfirmSubmit: function onConfirmSubmit() {
      var _this39 = this;

      // this.getReserveSeatsDetails,
      //   this.getSeatIds
      var payload = {
        bookSeats: this.getReserveSeatsDetails.seatLayoutId,
        categoryId: this.getSeatIds.categoryId,
        cinemaScheduleId: this.getSeatIds.cinemaScheduleId,
        ShowType: this.getSeatIds.type,
        coupon: this.promoCode.button ? this.promoCode.input : ""
      };
      // console.log("reserve-booking Payload>>>>", payload);

      Object(__WEBPACK_IMPORTED_MODULE_8__helper_internet_js__["makeRequest"])("/api/reserve-booking", "POST", null, payload).then(function (result) {
        var error = result.error,
            res = result.res;
        var data = res.data.data;

        if (!error && res.status) {
          console.log(" Reserve Seats Data ", data);
          if (data.reserveBooking.Status) {
            __WEBPACK_IMPORTED_MODULE_9__helper_storage__["secureStore"].set("GSRID", data.reserveBooking.ReserveID);
            _this39.$router.replace({
              path: "/seat-payment-mode",
              params: {}
            });
          }
        } else {
          console.log("error from res", res.message);
        }
      }).catch(function (error) {
        console.log("Error on vue front", error);
      });
    },
    getPromotionList: function getPromotionList() {
      var _this40 = this;

      var token = __WEBPACK_IMPORTED_MODULE_12__services_storage_service__["TokenService"].getToken();
      Object(__WEBPACK_IMPORTED_MODULE_8__helper_internet_js__["makeRequest"])("/GetPromotionList", "POST", token, null).then(function (response) {
        var error = response.error,
            res = response.res;

        if (!error) {
          if (res.data.UserPromotion) {
            _this40.promoCode.promoList = res.data.UserPromotion;
          }
          if (_this40.showDate.actualDate == "2020-02-14" && _this40.sectionName.noOfSeats >= 2) {
            _this40.isPromo = res.data.IsPromo;
          } else {
            _this40.isPromo = false;
          }
          console.log("this.isPromo :", _this40.isPromo);
          _this40.PromotionTabs = res.data.tabs;
          res.data.Promotions.map(function (promo) {
            _this40.promoCode.promoList.push(promo);
            // this.promoListCopy.push(promo);
          });
          _this40.promoListCopy = res.data.Promotions;
          // this.promoList.promoListCopy = this.promoCode.promoList;

          // this.promoCode.promoList.push({
          //   Title: "Reset Offer"
          // });
        }
      }).catch(function (error) {
        console.log("Error ", error);
      });
    },
    verifyPromoCode: function verifyPromoCode(e, type) {
      var _this41 = this;

      e.preventDefault();
      //   console.log("Here testing", this.promoCode.input);

      if (type == "bankOffer") {
        var payload = {
          OfferID: this.promoCode.selected.ID,
          CardNumber: this.creditCardDetails.number
        };
        Object(__WEBPACK_IMPORTED_MODULE_8__helper_internet_js__["makeRequestDirect"])("/api/Payment/VerifyCoupon/", "POST", null, payload).then(function (response) {
          var error = response.error,
              res = response.res;
          var data = res.data.data;

          console.log("Checking Verify Coupon result >", res.data);
          if (!error && res.data.Status) {
            _this41.discount = res.data.DiscountValue;
            _this41.promoCode.button = true;
            _this41.promoCode.errorMessage = "";
            _this41.promoCode.successMessage = res.data.Message;
          } else {
            _this41.discount = 0;
            _this41.promoCode.errorMessage = res.data.Message;
            _this41.promoCode.successMessage = "";
          }
        }).catch(function (error) {
          console.log("Error ", error);
        });
      } else {
        var _payload = {
          CouponCode: this.promoCode.input,
          Total: this.totalAmount
        };
        Object(__WEBPACK_IMPORTED_MODULE_8__helper_internet_js__["makeRequestDirect"])("/api/Payment/VerifyCoupon/", "POST", null, _payload).then(function (response) {
          var error = response.error,
              res = response.res;
          var data = res.data.data;

          console.log("Checking Verify Coupon result >", res.data);
          if (!error && res.data.Status) {
            _this41.discount = res.data.DiscountValue;
            _this41.promoCode.button = true;
            _this41.promoCode.errorMessage = "";
            _this41.promoCode.successMessage = res.data.Message;
          } else {
            _this41.discount = 0;
            _this41.promoCode.errorMessage = res.data.Message;
            _this41.promoCode.successMessage = "";
          }
        }).catch(function (error) {
          console.log("Error ", error);
        });
      }
    },

    getWallet: function getWallet() {
      var _this42 = this;

      // console.log("Here Wallet  >>", payment);
      var payload = {
        reserveId: this.reserveBookingId
      };

      Object(__WEBPACK_IMPORTED_MODULE_8__helper_internet_js__["makeRequestDirect"])("/cinematic/GetUserWallet", "POST", null, payload).then(function (result) {
        var error = result.error,
            res = result.res;

        console.log("check-wallet Result ", res);
        if (!error && res.data.status && res.data.data.checkWallet.Status) {
          _this42.status.enableOtpFlag = true;
        }
      }).catch(function (error) {
        console.log("Error on vue front", error);
      });
    },
    paymentConfirmation: function paymentConfirmation(e) {
      //   e.preventDefault();
      this.bankPage.src = "";
      this.savedBankPage.src = "";
      this.sectionName.confirmation = true;
      this.sectionName.checkout = false;
      //BookAPI
      this.getBookingDetails();
      //TODO Fetch final BookingID
    },
    userLogIn: function userLogIn(e) {
      var _this43 = this;

      e.preventDefault();
      Object(__WEBPACK_IMPORTED_MODULE_8__helper_internet_js__["makeRequest"])("/api/signin", "POST", null, {
        Password: this.userDetails.password,
        UserName: this.userDetails.email
      }).then(function (response) {
        var error = response.error,
            res = response.res;
        var data = res.data.data;

        console.log(res, "<<< Sign Im Data >>>", data);
        if (!error && res.data.status && data.result.Status) {
          // Handle Sign In
          _this43.$persistStore.set("accessToken", data.result.access_token);
          _this43.signIn.flag = true;
          _this43.modal.signIn = false;
          _this43.sectionName.checkout = true;
          __WEBPACK_IMPORTED_MODULE_10__main__["EventBus"].$emit("LoginUser", {
            status: true,
            userName: "test1"
          });
          _this43.modal.payment = true;
          // this.getUserDetails(() => {
          //   this.insertBookingOrderUserDetails();
          // });
        } else if (!data.result.Status) {
          _this43.loginErrorMessage = data.result.Message;
        }
      }).catch(function (error) {
        console.log("Error", error);
        //   resolve(null);
      });
    },
    handlerSeatSelected: function handlerSeatSelected(seat, rowIndex, seatIndex, originalIndex, backward, e, type) {
      this.singleSeatSelectHandler(seat, rowIndex, seatIndex, originalIndex, backward, e, type);
    },
    reserveSeatsSelected: function reserveSeatsSelected() {
      var payload = {
        bookSeats: this.getReserveSeatsDetails.seatLayoutId,
        categoryId: this.getSeatIds.categoryId,
        cinemaScheduleId: this.getSeatIds.cinemaScheduleId,
        ShowType: this.getSeatIds.type,
        coupon: this.promoCode.button ? this.promoCode.input : ""
      };
      // console.log("reserve-booking Payload>>>>", payload);

      Object(__WEBPACK_IMPORTED_MODULE_8__helper_internet_js__["makeRequest"])("/api/reserve-booking", "POST", null, payload).then(function (result) {
        var error = result.error,
            res = result.res;
        var data = res.data.data;

        if (!error && res.status) {
          console.log(" Reserve Seats Data ", data);
          if (data.reserveBooking.Status) {}
        } else {
          console.log("error from res", res.message);
        }
      }).catch(function (error) {
        console.log("Error on vue front", error);
      });
    },
    onclickok: function onclickok() {
      var _this44 = this;

      this.$refs.redirectPayment.hide();
      this.showLoading();
      var payload = {
        ReserveID: this.reserveID,
        email: this.userDetails.email,
        mobile: this.userDetails.phoneNumber,
        countrycode: this.userDetails.countryCode,
        CinemaType: "normal",
        PaymentID: 2,
        SucessUrl: this.ConfirmationURL,
        FailUrl: this.FailedURL,
        ApiCallURL: this.BASEURL,
        ismobile: 0
      };
      Object(__WEBPACK_IMPORTED_MODULE_8__helper_internet_js__["makeRequest"])("/MakePayment", "POST", null, payload).then(function (result) {
        var error = result.error,
            res = result.res;
        var data = res.data.data;

        if (res.data.Status) {
          var links = res.data.links;
          var x = document.getElementById("form_sample");
          var createform = document.createElement("form"); // Create New Element Form
          createform.setAttribute("action", links.requestUrl); // Setting Action Attribute on Form
          createform.setAttribute("method", "post"); // Setting Method Attribute on Form
          createform.setAttribute("ref", "submitForm"); // Setting Method Attribute on Form
          createform.setAttribute("name", "submitForm"); // Setting Method Attribute on Form
          x.appendChild(createform);
          var params = links.requestParameter;

          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(params).map(function (x) {
            var submitelement = document.createElement("input"); // Append Submit Button
            submitelement.setAttribute("type", "text");
            submitelement.setAttribute("name", x);
            submitelement.setAttribute("value", params[x]);
            createform.appendChild(submitelement);
          });

          var _submitelement = document.createElement("input"); // Append Submit Button
          _submitelement.setAttribute("type", "submit");
          _submitelement.setAttribute("value", "submit");
          createform.appendChild(_submitelement);

          setTimeout(function () {
            document.submitForm.submit();
            _this44.hideLoading();
            // this.$nextTick(() => {
            //   // this.sessionStore.set("EMRID", this.reserveID);
            //   this.$refs.submitForm.submit();
            // });
          }, 2000);
        }
      }).catch(function (error) {
        // this.$root.$emit("bv::show::modal", "checkoutModal");
        // this.userDetails.errorMessage = "Something went wrong!";
        // console.log("Error on vue front", error);
      });

      // this.$refs.submitForm.submit();
    }
  }
});

/***/ }),

/***/ 1097:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/demo-img.eb0f8ef.png";

/***/ }),

/***/ 1142:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1143);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1039)("5ea850bf", content, true, {});

/***/ }),

/***/ 1143:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1038)(true);
// imports


// module
exports.push([module.i, ".cus-list p[data-v-85c0f8e0]{position:relative}.owl-carousel .owl-nav .owl-next[data-v-85c0f8e0],.owl-carousel .owl-nav .owl-prev[data-v-85c0f8e0]{font-weight:700;font-size:24px;font-family:monospace;padding:10px 20px}.owl-carousel .owl-nav .owl-prev[data-v-85c0f8e0]{color:blue}.owl-carousel .owl-nav .owl-prev[data-v-85c0f8e0]:hover{color:aqua}.owl-carousel .owl-nav .owl-next[data-v-85c0f8e0]{color:red}.owl-carousel .owl-nav .owl-next[data-v-85c0f8e0]:hover{color:#ff0}.cus-list p .selected-items[data-v-85c0f8e0]{float:right;font-size:14px;font-weight:700;color:#e78785;position:absolute;right:0;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.cus-list .fbCat[data-v-85c0f8e0]::-webkit-scrollbar{width:0;height:0}.cus-list .fbCat li[data-v-85c0f8e0]{margin-right:1.8rem;font-size:14px;color:#810c13;font-weight:700;position:relative;cursor:pointer;text-transform:uppercase}.cus-list .fbCat li.active[data-v-85c0f8e0],.cus-list .fbCat li[data-v-85c0f8e0]:hover{color:#000}.cus-list .fbCat li.active[data-v-85c0f8e0]:after{left:0;right:0;content:\"\";z-index:9;width:15px;height:15px;bottom:-25px;margin:0 auto;position:absolute;border-color:#000;border-style:dotted;background:#bc112b;transform:rotate(45deg);-ms-transform:rotate(45deg);-webkit-transform:rotate(45deg);border-width:0 1.4px 1.4px 0}.counter-box[data-v-85c0f8e0]{border-radius:15px}.counter-box .decrease[data-v-85c0f8e0]{font-size:12px;height:20px;width:20px;outline:0;-webkit-box-shadow:none;box-shadow:none;border:none;cursor:pointer;color:#000;font-weight:bolder;background-color:#cc202e;border-top-left-radius:15px;border-bottom-left-radius:15px;border-right:.5px solid #000}.counter-box .output[data-v-85c0f8e0]{width:20px;display:-webkit-box;display:-ms-flexbox;display:flex;font-size:10px;color:#000;font-weight:700;text-align:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;background-color:transparent}.counter-box .increase[data-v-85c0f8e0]{height:20px;width:20px;outline:0;border:none;font-size:12px;cursor:pointer;color:#000;-webkit-box-shadow:none;box-shadow:none;font-weight:bolder;background-color:#87c03f;border-top-right-radius:15px;border-bottom-right-radius:15px;border-left:.5px solid #000}.red-fb-box[data-v-85c0f8e0]{border:1px dotted #fff;padding:10px;border-radius:10px}.foodBevrage .fb-name[data-v-85c0f8e0],.red-fb-box img[data-v-85c0f8e0]{word-break:break-word}.foodBevrage .fb-desc[data-v-85c0f8e0]{margin-bottom:0;font-size:14px;color:#000;word-break:break-word}.foodBevrage .sub-box[data-v-85c0f8e0]:last-child{margin-bottom:80px!important}.foodBevrage .fb-name[data-v-85c0f8e0],.foodBevrage .fb-price[data-v-85c0f8e0]{font-size:12px}.fbDetails[data-v-85c0f8e0]{width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;padding:15px;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.premiere-fb-box[data-v-85c0f8e0]{border:1px dotted #b71f1f;padding:10px;border-radius:10px}.foodBevrage .fb-name[data-v-85c0f8e0]{margin-bottom:0;font-size:18px;color:#000}.foodBevrage .fb-price[data-v-85c0f8e0]{font-size:14px;color:#000;text-transform:uppercase}.food-list[data-v-85c0f8e0],.genre-list[data-v-85c0f8e0],.lang-list[data-v-85c0f8e0],.prefCinema-list[data-v-85c0f8e0],.seat-list[data-v-85c0f8e0]{cursor:default;padding-left:0;margin-bottom:0;list-style:none}.food-list li[data-v-85c0f8e0]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex}.food-list li span[data-v-85c0f8e0]{font-weight:400}.food-list li[data-v-85c0f8e0]:after{content:\"\\2022\";margin-left:5px;margin-right:5px}", "", {"version":3,"sources":["/var/www/html/wanasa/website/vue-pwa-initial-setup/src/components/pages/SNcheckout.vue"],"names":[],"mappings":"AACA,6BACE,iBAAmB,CACpB,AACD,oGAEE,gBAAkB,AAClB,eAAgB,AAChB,sBAAuB,AACvB,iBAAmB,CACpB,AACD,kDACE,UAAY,CACb,AACD,wDACE,UAAY,CACb,AACD,kDACE,SAAW,CACZ,AACD,wDACE,UAAc,CACf,AACD,6CACE,YAAa,AACb,eAAgB,AAChB,gBAAkB,AAClB,cAAe,AACf,kBAAmB,AACnB,QAAS,AACT,QAAS,AACT,mCAAoC,AAC5B,0BAA4B,CACrC,AACD,qDACE,QAAW,AACX,QAAY,CACb,AACD,qCACE,oBAAqB,AACrB,eAAgB,AAChB,cAAe,AACf,gBAAkB,AAClB,kBAAmB,AACnB,eAAgB,AAChB,wBAA0B,CAC3B,AACD,uFAEE,UAAe,CAChB,AACD,kDACE,OAAQ,AACR,QAAS,AACT,WAAY,AACZ,UAAW,AACX,WAAY,AACZ,YAAa,AACb,aAAc,AACd,cAAe,AACf,kBAAmB,AACnB,kBAAmB,AACnB,oBAAqB,AACrB,mBAAoB,AACpB,wBAAyB,AACzB,4BAA6B,AAC7B,gCAAiC,AACjC,4BAAkC,CACnC,AACD,8BAEE,kBAAoB,CACrB,AACD,wCACE,eAAgB,AAChB,YAAa,AACb,WAAY,AACZ,UAAW,AACX,wBAAyB,AACjB,gBAAiB,AACzB,YAAa,AACb,eAAgB,AAChB,WAAY,AACZ,mBAAoB,AACpB,yBAA0B,AAC1B,4BAA6B,AAC7B,+BAAgC,AAChC,4BAA+B,CAChC,AACD,sCACE,WAAY,AACZ,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,eAAgB,AAChB,WAAY,AACZ,gBAAkB,AAClB,kBAAmB,AACnB,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,4BAA8B,CAC/B,AACD,wCACE,YAAa,AACb,WAAY,AACZ,UAAW,AACX,YAAa,AACb,eAAgB,AAChB,eAAgB,AAChB,WAAe,AACf,wBAAyB,AACjB,gBAAiB,AACzB,mBAAoB,AACpB,yBAA0B,AAC1B,6BAA8B,AAC9B,gCAAiC,AACjC,2BAAiC,CAClC,AAeD,6BACE,uBAAwB,AACxB,aAAc,AACd,kBAAoB,CACrB,AAID,wEAKE,qBAAuB,CACxB,AACD,uCACE,gBAAiB,AACjB,eAAgB,AAChB,WAAe,AAEf,qBAAuB,CACxB,AAMD,kDACE,4BAA+B,CAChC,AAID,+EACE,cAAgB,CACjB,AACD,4BACE,WAAY,AACZ,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,sBAAuB,AAC/B,aAA6B,AAC7B,yBAA0B,AACtB,sBAAuB,AACnB,6BAA+B,CACxC,AACD,kCACE,0BAA2B,AAC3B,aAAc,AACd,kBAAoB,CACrB,AACD,uCACE,gBAAiB,AACjB,eAAgB,AAChB,UAAe,CAEhB,AACD,wCACE,eAAgB,AAChB,WAAe,AACf,wBAA0B,CAC3B,AACD,mJAKE,eAAgB,AAChB,eAAgB,AAChB,gBAAiB,AACjB,eAAiB,CAClB,AACD,+BACE,2BAA4B,AAC5B,2BAA4B,AAC5B,mBAAqB,CACtB,AACD,oCACE,eAAoB,CACrB,AACD,qCACE,gBAAiB,AACjB,gBAAiB,AACjB,gBAAkB,CACnB","file":"SNcheckout.vue","sourcesContent":["\n.cus-list p[data-v-85c0f8e0] {\n  position: relative;\n}\n.owl-carousel .owl-nav .owl-prev[data-v-85c0f8e0],\n.owl-carousel .owl-nav .owl-next[data-v-85c0f8e0] {\n  font-weight: bold;\n  font-size: 24px;\n  font-family: monospace;\n  padding: 10px 20px;\n}\n.owl-carousel .owl-nav .owl-prev[data-v-85c0f8e0] {\n  color: blue;\n}\n.owl-carousel .owl-nav .owl-prev[data-v-85c0f8e0]:hover {\n  color: aqua;\n}\n.owl-carousel .owl-nav .owl-next[data-v-85c0f8e0] {\n  color: red;\n}\n.owl-carousel .owl-nav .owl-next[data-v-85c0f8e0]:hover {\n  color: yellow;\n}\n.cus-list p .selected-items[data-v-85c0f8e0] {\n  float: right;\n  font-size: 14px;\n  font-weight: bold;\n  color: #e78785;\n  position: absolute;\n  right: 0;\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n          transform: translateY(-50%);\n}\n.cus-list .fbCat[data-v-85c0f8e0]::-webkit-scrollbar {\n  width: 0px;\n  height: 0px;\n}\n.cus-list .fbCat li[data-v-85c0f8e0] {\n  margin-right: 1.8rem;\n  font-size: 14px;\n  color: #810c13;\n  font-weight: bold;\n  position: relative;\n  cursor: pointer;\n  text-transform: uppercase;\n}\n.cus-list .fbCat li[data-v-85c0f8e0]:hover,\n.cus-list .fbCat li.active[data-v-85c0f8e0] {\n  color: #000000;\n}\n.cus-list .fbCat li.active[data-v-85c0f8e0]::after {\n  left: 0;\n  right: 0;\n  content: \"\";\n  z-index: 9;\n  width: 15px;\n  height: 15px;\n  bottom: -25px;\n  margin: 0 auto;\n  position: absolute;\n  border-color: #000;\n  border-style: dotted;\n  background: #bc112b;\n  transform: rotate(45deg);\n  -ms-transform: rotate(45deg);\n  -webkit-transform: rotate(45deg);\n  border-width: 0px 1.4px 1.4px 0px;\n}\n.counter-box[data-v-85c0f8e0] {\n  /* border: 1px solid #000; */\n  border-radius: 15px;\n}\n.counter-box .decrease[data-v-85c0f8e0] {\n  font-size: 12px;\n  height: 20px;\n  width: 20px;\n  outline: 0;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  border: none;\n  cursor: pointer;\n  color: #000;\n  font-weight: bolder;\n  background-color: #cc202e;\n  border-top-left-radius: 15px;\n  border-bottom-left-radius: 15px;\n  border-right: 0.5px solid #000;\n}\n.counter-box .output[data-v-85c0f8e0] {\n  width: 20px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  font-size: 10px;\n  color: #000;\n  font-weight: bold;\n  text-align: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  background-color: transparent;\n}\n.counter-box .increase[data-v-85c0f8e0] {\n  height: 20px;\n  width: 20px;\n  outline: 0;\n  border: none;\n  font-size: 12px;\n  cursor: pointer;\n  color: #000000;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  font-weight: bolder;\n  background-color: #87c03f;\n  border-top-right-radius: 15px;\n  border-bottom-right-radius: 15px;\n  border-left: 0.5px solid #000000;\n}\n.fbDetails[data-v-85c0f8e0] {\n  width: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  padding: 15px 15px 15px 15px;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.red-fb-box[data-v-85c0f8e0] {\n  border: 1px dotted #fff;\n  padding: 10px;\n  border-radius: 10px;\n}\n.red-fb-box img[data-v-85c0f8e0] {\n  word-break: break-word;\n}\n.foodBevrage .fb-name[data-v-85c0f8e0] {\n  margin-bottom: 0;\n  font-size: 18px;\n  color: #000000;\n  /* text-transform: uppercase; */\n  word-break: break-word;\n}\n.foodBevrage .fb-desc[data-v-85c0f8e0] {\n  margin-bottom: 0;\n  font-size: 14px;\n  color: #000000;\n  /* text-transform: uppercase; */\n  word-break: break-word;\n}\n.foodBevrage .fb-price[data-v-85c0f8e0] {\n  font-size: 14px;\n  color: #000000;\n  text-transform: uppercase;\n}\n.foodBevrage .sub-box[data-v-85c0f8e0]:last-child {\n  margin-bottom: 80px !important;\n}\n.foodBevrage .fb-name[data-v-85c0f8e0] {\n  font-size: 12px;\n}\n.foodBevrage .fb-price[data-v-85c0f8e0] {\n  font-size: 12px;\n}\n.fbDetails[data-v-85c0f8e0] {\n  width: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  padding: 15px 15px 15px 15px;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.premiere-fb-box[data-v-85c0f8e0] {\n  border: 1px dotted #b71f1f;\n  padding: 10px;\n  border-radius: 10px;\n}\n.foodBevrage .fb-name[data-v-85c0f8e0] {\n  margin-bottom: 0;\n  font-size: 18px;\n  color: #000000;\n  /* text-transform: uppercase; */\n}\n.foodBevrage .fb-price[data-v-85c0f8e0] {\n  font-size: 14px;\n  color: #000000;\n  text-transform: uppercase;\n}\n.seat-list[data-v-85c0f8e0],\n.lang-list[data-v-85c0f8e0],\n.food-list[data-v-85c0f8e0],\n.genre-list[data-v-85c0f8e0],\n.prefCinema-list[data-v-85c0f8e0] {\n  cursor: default;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n.food-list li[data-v-85c0f8e0] {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n}\n.food-list li span[data-v-85c0f8e0] {\n  font-weight: normal;\n}\n.food-list li[data-v-85c0f8e0]::after {\n  content: \"\\2022\";\n  margin-left: 5px;\n  margin-right: 5px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1144:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1145);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1039)("64ac1c1e", content, true, {});

/***/ }),

/***/ 1145:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1038)(true);
// imports


// module
exports.push([module.i, "input[type=checkbox][data-v-85c0f8e0]{height:16px;position:relative}footer[data-v-85c0f8e0]{display:none}.modal-bg[data-v-85c0f8e0]{width:100%;position:fixed;z-index:100000;margin:0 0 auto auto;background:#00000078;padding:100px 0 0;height:100%}div.b[data-v-85c0f8e0]{white-space:nowrap;overflow:hidden;height:20px;text-overflow:ellipsis}.pointer-none[data-v-85c0f8e0]{pointer-events:none}.tnc[data-v-85c0f8e0]{list-style:decimal;padding-left:12px}.rtl .tnc li[data-v-85c0f8e0]{text-align:right}.fnb-info[data-v-85c0f8e0]{min-height:150px}.tooltip[data-v-85c0f8e0]{max-width:300px;width:300px}.tooltip-inner[data-v-85c0f8e0]{max-width:300px!important;width:300px!important}.number_reverse[data-v-85c0f8e0]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:reverse;-ms-flex-direction:row-reverse;flex-direction:row-reverse;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-ms-flex-wrap:wrap;flex-wrap:wrap}.sbtr[data-v-85c0f8e0]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-evenly}.screen-text[data-v-85c0f8e0]{position:absolute;top:0;width:100%}.screen-img[data-v-85c0f8e0]{width:100%;height:100%}.big-seat[data-v-85c0f8e0]{width:50px!important;height:50px!important}", "", {"version":3,"sources":["/var/www/html/wanasa/website/vue-pwa-initial-setup/src/components/pages/SNcheckout.vue"],"names":[],"mappings":"AACA,sCACE,YAAa,AACb,iBAAmB,CAEpB,AACD,wBACE,YAAc,CACf,AAID,2BACE,WAAY,AACZ,eAAgB,AAChB,eAAgB,AAChB,qBAAsB,AACtB,qBAAsB,AACtB,kBAAqB,AACrB,WAAa,CACd,AACD,uBACE,mBAAoB,AAEpB,gBAAiB,AAEjB,YAAa,AACb,sBAAwB,CACzB,AACD,+BACE,mBAAqB,CACtB,AACD,sBACE,mBAAoB,AACpB,iBAAmB,CACpB,AACD,8BACE,gBAAkB,CACnB,AACD,2BACE,gBAAkB,CACnB,AACD,0BACE,gBAAiB,AACjB,WAAa,CACd,AACD,gCACE,0BAA4B,AAC5B,qBAAwB,CACzB,AACD,iCACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,8BAA+B,AAC/B,8BAA+B,AAC3B,+BAAgC,AAC5B,2BAA4B,AACpC,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,mBAAoB,AAChB,cAAgB,CACrB,AACD,uBACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AAC1B,sBAAuB,AACvB,4BAA8B,CAC/B,AAMD,8BACE,kBAAmB,AACnB,MAAS,AAET,UAAY,CACb,AACD,6BACE,WAAY,AACZ,WAAa,CACd,AACD,2BACE,qBAAuB,AACvB,qBAAwB,CACzB","file":"SNcheckout.vue","sourcesContent":["\ninput[type=\"checkbox\"][data-v-85c0f8e0] {\n  height: 16px;\n  position: relative;\n  /* margin-right: 12px; */\n}\nfooter[data-v-85c0f8e0] {\n  display: none;\n}\n.pointer-none[data-v-85c0f8e0] {\n  pointer-events: none;\n}\n.modal-bg[data-v-85c0f8e0] {\n  width: 100%;\n  position: fixed;\n  z-index: 100000;\n  margin: 0 0 auto auto;\n  background: #00000078;\n  padding: 100px 0 0 0;\n  height: 100%;\n}\ndiv.b[data-v-85c0f8e0] {\n  white-space: nowrap;\n  /* width: 150px; */\n  overflow: hidden;\n  /* background: red; */\n  height: 20px;\n  text-overflow: ellipsis;\n}\n.pointer-none[data-v-85c0f8e0] {\n  pointer-events: none;\n}\n.tnc[data-v-85c0f8e0] {\n  list-style: decimal;\n  padding-left: 12px;\n}\n.rtl .tnc li[data-v-85c0f8e0] {\n  text-align: right;\n}\n.fnb-info[data-v-85c0f8e0] {\n  min-height: 150px;\n}\n.tooltip[data-v-85c0f8e0] {\n  max-width: 300px;\n  width: 300px;\n}\n.tooltip-inner[data-v-85c0f8e0] {\n  max-width: 300px !important;\n  width: 300px !important;\n}\n.number_reverse[data-v-85c0f8e0] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: reverse;\n      -ms-flex-direction: row-reverse;\n          flex-direction: row-reverse;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n}\n.sbtr[data-v-85c0f8e0] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  justify-content: space-evenly;\n}\n@media (max-width: 768px) {\n.sbtr[data-v-85c0f8e0] {\n    /* justify-content: space-between; */\n}\n}\n.screen-text[data-v-85c0f8e0] {\n  position: absolute;\n  top: 0px;\n  /* right: 67%; */\n  width: 100%;\n}\n.screen-img[data-v-85c0f8e0] {\n  width: 100%;\n  height: 100%;\n}\n.big-seat[data-v-85c0f8e0] {\n  width: 50px !important;\n  height: 50px !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1146:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-modal',{ref:"tncModal",staticClass:"country-modal",attrs:{"no-close-on-esc":"","no-close-on-backdrop":"","hide-header-close":"","id":"tncModal","hide-header":"","hide-footer":""}},[(_vm.ratingContent && _vm.ratingContent.title)?_c('div',{staticClass:"modal-title"},[_c('h4',[_vm._v(_vm._s(_vm.ratingContent.title))])]):_vm._e(),_vm._v(" "),(_vm.ratingContent)?_c('div',{staticClass:"d-flex mx-2"},[(_vm.ratingContent.image && false)?_c('div',{staticClass:"col-3"},[_c('img',{attrs:{"src":_vm.ratingContent.image,"alt":"rating_icon"}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12"},[(_vm.ratingContent && _vm.ratingContent.content)?_c('p',[_c('span',{domProps:{"innerHTML":_vm._s(_vm.ratingContent.content)}})]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.ratingContent)?_c('div',{staticClass:"row mx-0 py-3"},[_c('div',{staticClass:"col-6"},[_c('button',{staticClass:"btn-confirm active",attrs:{"type":"button"},on:{"click":function($event){return _vm.onCancelRedirectBack()}}},[_vm._v("\n          "+_vm._s(_vm.$t("Cancel"))+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('button',{staticClass:"btn-confirm active",attrs:{"type":"button"},on:{"click":function($event){return _vm.onClickSeatSelectionModal()}}},[_vm._v("\n          "+_vm._s(_vm.$t("Accept"))+"\n        ")])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"select-seat-modal"},[_c('b-modal',{ref:"seat_select_modal",staticClass:"seat_select_modal",attrs:{"hide-footer":"","hide-header":"","no-close-on-esc":"","no-close-on-backdrop":"","id":"seat_select_modal"}},[_c('div',{staticClass:"seats_num py-2 text-center"},[_c('h5',[_vm._v("\n          "+_vm._s(_vm.$t("SELECT_NO_OF_SEAT"))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"my-4"},_vm._l((6),function(data,index){return _c('div',{key:index},[(_vm.totalNumberOfSeats == index + 1)?_c('div',[_c('img',{staticClass:"numbers-seats-img",attrs:{"src":__webpack_require__(1084)("./" + (index + 1) + 'Seats.png'),"alt":""}})]):_vm._e()])}),0),_vm._v(" "),_c('ul',{staticClass:"seatNumList list-inline pl-0 mb-0",class:_vm.isRTL ? 'number_reverse' : ''},_vm._l((6),function(item,itemKey){return _c('li',{key:itemKey,staticClass:"list-inline-item seat_btn",class:_vm.totalNumberOfSeats == item ? 'seat_btn_active active' : '',on:{"click":function($event){return _vm.onShowSeatImg(item)}}},[_vm._v("\n            "+_vm._s(itemKey + 1)+"\n          ")])}),0),_vm._v(" "),(_vm.OnlySeatType.length > 0)?_c('div',{staticClass:"my-4"},[_c('div',{staticClass:"row justify-content-center"},_vm._l((_vm.OnlySeatType),function(SingleSeatType,SeatKey){return _c('div',{key:SeatKey,class:_vm.OnlySeatType.length == 1 ? 'col-6' : 'col-' + _vm.seatsClass},[_c('div',{class:_vm.IsSeatTypePopup == true && _vm.SeatType.ID === SingleSeatType.ID
                    ? 'seat_btn seat_btn_type seat_btn_active seat-align'
                    : '',on:{"click":function($event){return _vm.onNewSelectSeatType(SingleSeatType)}}},[(_vm.IsSeatTypePopup == true)?_c('input',{staticClass:"sncheck-align",attrs:{"type":"checkbox","id":'index' + SeatKey},domProps:{"checked":_vm.IsSeatTypePopup == true &&
                    _vm.SeatType.ID === SingleSeatType.ID
                      ? 'true'
                      : ''}}):_vm._e(),_vm._v(" "),(_vm.cinemaDetails.CinemaID != 33)?_c('div',[(SingleSeatType.SeatType == 'balcony')?_c('span',[_vm._v("\n                    VIP\n                  ")]):(
                      SingleSeatType.SeatType == 'orchestra' &&
                        _vm.cinemaDetails.CinemaID == '35'
                    )?_c('span',[_vm._v("\n                    VIP Gold (RECLINERS)\n                  ")]):(SingleSeatType.SeatType == 'orchestra')?_c('span',[_vm._v("\n                    VIP Gold\n                  ")]):(
                      SingleSeatType.SeatType == 'Standard' &&
                        SingleSeatType.screen_id == '65'
                    )?_c('span',[_vm._v("\n                    VIP DIAMOND (RECLINERS)\n                  ")]):(SingleSeatType.SeatType == 'Standard')?_c('span',[_vm._v("\n                    STANDARD\n                  ")]):_c('span',[_vm._v(" "+_vm._s(SingleSeatType.SeatType)+" ")])]):_c('div',[_vm._v(_vm._s(SingleSeatType.SeatType))]),_vm._v("\n                ("+_vm._s(_vm.Currency)+" "+_vm._s(SingleSeatType.Price)+")\n              ")])])}),0)]):_vm._e(),_vm._v(" "),_c('div',[_c('button',{staticClass:"btn btn-pink w-100",attrs:{"disabled":_vm.IsSeatTypePopup == true && _vm.SelectedSeatType == '' ? true : false},on:{"click":function($event){return _vm.onSelectNumberOfSeats(_vm.totalNumberOfSeats)}}},[_vm._v("\n            SELECT SEATS\n          ")])])])])],1),_vm._v(" "),_c('div',{staticClass:"select-seat-modal"},[_c('b-modal',{ref:"rated_modal",staticClass:"seat_select_modal",attrs:{"hide-footer":"","hide-header":"","size":"lg","no-close-on-esc":"","no-close-on-backdrop":"","id":"rated_modal"}},[_c('div',{staticClass:"seats_num py-lg-3 py-3 text-center"},[_c('h5',{staticClass:"font-weight-bold"},[_vm._v("\n          "+_vm._s(_vm.$t("NOTE"))+"\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          "+_vm._s(_vm.$t("RATED_NOTE", { rated: _vm.movieDetails.rated || "" }))+"\n        ")]),_vm._v(" "),_c('button',{staticClass:"active btn-proceed-myticket mt-2",on:{"click":function($event){return _vm.hideRatedModal()}}},[_vm._v("\n          "+_vm._s(_vm.$t("PROCEED"))+"\n        ")])])])],1),_vm._v(" "),(_vm.savedBankPage.src)?_c('div',{staticClass:"modal-bg"},[(_vm.savedBankPage.src)?_c('vue-friendly-iframe',{staticClass:"text-center",attrs:{"src":_vm.savedBankPage.src}}):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.bankPage.src)?_c('div',{staticClass:"modal-bg"},[(_vm.bankPage.src)?_c('vue-friendly-iframe',{staticClass:"text-center",attrs:{"src":_vm.bankPage.src}}):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.sectionName.noOfSeats && false)?_c('section',[_c('div',{staticClass:"banner",style:({ background: 'url(' + _vm.movieDetails.movie_card_banner + ')' })}),_vm._v(" "),(_vm.sectionName.noOfSeats)?_c('div',{staticClass:"select-seat-section"},[_c('div',{staticClass:"container px-2 px-md-3"},[(_vm.project == 'myticketi')?_c('div',{staticClass:"select-seat-container-myticket"},[_c('div',{staticClass:"col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8 mx-auto"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 py-3 bg-light rounded"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-3"},[_c('strong',[_vm._v(_vm._s(_vm.$t("TICKET")))])]),_vm._v(" "),_c('div',{staticClass:"col-3"},[_c('strong',[_vm._v(_vm._s(_vm.$t("PRICE")))])]),_vm._v(" "),_c('div',{staticClass:"col-4"},[_c('strong',[_vm._v(_vm._s(_vm.$t("NO_OF_SEATS")))])]),_vm._v(" "),_c('div',{staticClass:"col-2"})])]),_vm._v(" "),_vm._l((_vm.OnlySeatType),function(seatType,seatTypeIndex){return _c('div',{key:seatTypeIndex,staticClass:"col-12 py-2 border-bottom"},[_c('div',{staticClass:"row align-self-center"},[_c('div',{staticClass:"col-3 align-self-center"},[_c('strong',[_vm._v(_vm._s(seatType.SeatType))])]),_vm._v(" "),_c('div',{staticClass:"col-3 align-self-center"},[_c('strong',[_vm._v(_vm._s(seatType.Price)+" "+_vm._s(_vm.Currency))])]),_vm._v(" "),_c('div',{staticClass:"col-4"},[_c('div',{staticClass:"\n                        d-flex\n                        align-items-center\n                        justify-content-center\n                        w-100\n                        h-100\n                      "},[_c('button',{staticClass:"cursor-pointer btn-subtract-myticket",on:{"click":function($event){return _vm.onclickSubtract(seatTypeIndex)}}},[_vm._v("\n                        -\n                      ")]),_vm._v(" "),_c('strong',{staticClass:"w-100px"},[_vm._v(_vm._s(seatType.count))]),_vm._v(" "),_c('button',{staticClass:"cursor-pointer btn-add-myticket",attrs:{"disabled":seatType.clickDisabled},on:{"click":function($event){return _vm.onclickAdd(seatTypeIndex)}}},[_vm._v("\n                        +\n                      ")]),_vm._v(" "),(seatType.seatqty > '1')?_c('img',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"ml-2",attrs:{"width":"20px","src":__webpack_require__(1147),"title":'Minimum Required seats is ' + seatType.seatqty}}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-2"},[_c('strong',[_vm._v(_vm._s(_vm.$t("ADD_SEATS")))])])])])}),_vm._v(" "),_c('div',{staticClass:"col-12 py-3 bg-light rounded text-pink"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-3"},[_c('strong',[_vm._v(_vm._s(_vm.$t("TOTAL")))])]),_vm._v(" "),_c('div',{staticClass:"col-3"},[_c('strong',[_vm._v(_vm._s(_vm.totalAmount)+" "+_vm._s(_vm.Currency))])]),_vm._v(" "),_c('div',{staticClass:"col-4"},[_c('strong',[_vm._v(_vm._s(_vm.totalNumberOfSeats))])]),_vm._v(" "),_c('div',{staticClass:"col-2"})])]),_vm._v(" "),_c('div',{staticClass:"col-12 py-4"},[_c('button',{staticClass:"btn-proceed-myticket",class:_vm.totalNumberOfSeats > 0 && _vm.MinSeatsFlag ? 'active' : '',attrs:{"disabled":!(_vm.totalNumberOfSeats > 0 && _vm.MinSeatsFlag)},on:{"click":function($event){return _vm.confirmNumber()}}},[_vm._v("\n                  "+_vm._s(_vm.$t("PROCEED"))+"\n                ")])])],2)])]):_vm._e(),_vm._v(" "),(_vm.project == 'ticketak')?_c('div',{staticClass:"select-seat-container"},[_c('div',[(_vm.OnlySeatType.length > 0)?_c('div',{staticClass:"mb-4",staticStyle:{"border-bottom":"1px solid #cecece","padding-bottom":"14px"}},[_c('div',{staticClass:"row"},_vm._l((_vm.OnlySeatType),function(SingleSeatType,SeatKey){return _c('div',{key:SeatKey,staticClass:"pr-2",class:_vm.OnlySeatType.length == 1 ? 'col-12' : 'col-' + _vm.seatsClass},[_c('button',{staticClass:"btn-rounded h-auto pointer-none",staticStyle:{"border":"none"},attrs:{"disabled":""},on:{"click":function($event){return _vm.onSelectSeatType(SingleSeatType.SeatType)}}},[_vm._v("\n                    "+_vm._s(SingleSeatType.SeatType)+"\n                    "),_c('br'),_vm._v("\n                    ("+_vm._s(_vm.Currency)+" "+_vm._s(SingleSeatType.Price)+")\n                  ")])])}),0)]):_vm._e(),_vm._v(" "),_c('div',{class:_vm.SeatType.length > 0 || !_vm.getSeatLayout ? '' : ''},[_c('h6',{staticClass:"mb-3"},[_vm._v(_vm._s(_vm.$t("HOW_MANY_SEATS")))]),_vm._v(" "),_c('ul',{staticClass:"select-seat-list"},_vm._l((_vm.numberofSeatsArray),function(number,index){return _c('li',{key:index},[(number == _vm.totalNumberOfSeats)?_c('span',{staticClass:"selected",on:{"click":function($event){return _vm.editNumberOfSeats(number)}}},[_vm._v(_vm._s(number))]):_c('span',{on:{"click":function($event){return _vm.editNumberOfSeats(number)}}},[_vm._v(_vm._s(number))])])}),0)]),_vm._v(" "),_c('button',{staticClass:"btn-confirm",class:_vm.totalNumberOfSeats > 0 ? 'active' : '',on:{"click":function($event){return _vm.confirmNumber()}}},[_vm._v("\n              "+_vm._s(_vm.$t("PROCEED"))+"\n            ")])])]):_vm._e()])]):_vm._e()]):_vm._e(),_vm._v(" "),(this.SeatErrormessage != '')?_c('div',{staticClass:"seat-layout-message"},[_c('h3',{attrs:{"className":"font-weight-bold"}},[_vm._v(_vm._s(this.SeatErrormessage))])]):_vm._e(),_vm._v(" "),(_vm.sectionName.seatLayout && this.SeatErrormessage == '')?_c('section',{staticClass:"seat_layout_container seat-layout-two"},[_c('div',{staticClass:"d-flex"},[_c('div',{staticClass:"section-seatlayout"},[_c('section',{staticClass:"d-md-none text-left small text-dark mb-2"},[_c('div',[_vm._v(_vm._s(_vm.cinemaDetails.MovieTitle))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.cinemaDetails.Name))]),_vm._v(" "),_c('div',[_vm._v("\n            "+_vm._s(_vm.showDate.date)+" "+_vm._s(_vm.showDate.month)+" "+_vm._s(_vm.showDate.year)+",\n            "+_vm._s(_vm.SchTime)+"\n          ")])]),_vm._v(" "),(false)?_c('section',{staticClass:"seat-layout-shows mb-3"},[(_vm.allShowTimes.length > 0)?_c('Slick',{ref:"cinemaMovieTimeSlick",staticClass:"shedule_seat",attrs:{"options":_vm.seatLayoutDateSlider}},_vm._l((_vm.allShowTimes),function(singleShow,showTimeIndex){return _c('section',{key:showTimeIndex},[_c('div',{staticClass:"seat-datebox",class:singleShow.SchID == _vm.scheduleID ? 'active' : '',on:{"click":function($event){return _vm.onClickShowTime(singleShow)}}},[_vm._v("\n                "+_vm._s(singleShow.ShowTime)+"\n\n                "+_vm._s(singleShow.Format !== "2D" ? singleShow.Format : "")+"\n              ")])])}),0):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.seatTypes.length > 0)?_c('div',{staticClass:"seat_layout_nav"},[_c('hr',{staticClass:"w-75"}),_vm._v(" "),_c('nav',{staticClass:"navigation w-100"},[_c('ul',{staticClass:"seat-appearance-list"},[_c('li',[_vm._v(_vm._s(_vm.$t("SOLD")))]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.$t("AVAILABLE")))]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.$t("SELECTED")))])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"seat_layout mb-3 seat-layout-one"},_vm._l((_vm.seatTypes),function(seatType,seatTypeIndex){return _c('table',{key:seatTypeIndex,staticClass:"seat-layout-table mx-auto",style:('width:' + _vm.SeatCatWidth[seatTypeIndex] + 'px')},[(seatTypeIndex == 0)?_c('tr',[_c('td',{attrs:{"colspan":"50"}})]):_vm._e(),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',{attrs:{"colspan":"50"}},[_c('div',{staticClass:"text-left pb-2 pt-3"},[(_vm.cinemaDetails.CinemaID != 33)?_c('div',[(seatType.SeatType == 'balcony' && _vm.cinemaDetails.CinemaID == '45')?_c('span',[_vm._v("\n                      Premium\n                    ")]):(seatType.SeatType == 'balcony')?_c('span',[_vm._v(" VIP ")]):(
                          seatType.SeatType == 'orchestra' &&
                            _vm.cinemaDetails.CinemaID == '35'
                        )?_c('span',[_vm._v("\n                        VIP Gold (RECLINERS)\n                      ")]):(
                        seatType.SeatType == 'orchestra' &&
                          _vm.cinemaDetails.CinemaID == '45'
                      )?_c('span',[_vm._v("\n                      VIP\n                    ")]):(seatType.SeatType == 'orchestra')?_c('span',[_vm._v("\n                        VIP Gold\n                      ")]):(
                          seatType.SeatType == 'Standard' &&
                            seatType.screen_id == '65'
                        )?_c('span',[_vm._v("\n                        VIP DIAMOND (RECLINERS)\n                      ")]):(seatType.SeatType == 'Standard')?_c('span',[_vm._v("\n                        STANDARD\n                      ")]):_c('span',[_vm._v("\n                        "+_vm._s(seatType.SeatType && /_1/.test(seatType.SeatType)
                            ? seatType.SeatType.replace(/_1/g, "")
                            : seatType.SeatType)+"\n                      ")]),_vm._v(" "),(seatType.Price != '')?_c('span',{staticClass:"text-muted"},[_vm._v("\n                        ( "+_vm._s(_vm.Currency)+" "+_vm._s(seatType.Price)+" )")]):_vm._e()]):_c('div',[_vm._v("\n                      "+_vm._s(seatType.SeatType && /_1/.test(seatType.SeatType)
                          ? seatType.SeatType.replace(/_1/g, "")
                          : seatType.SeatType)+"\n\n                      "),(seatType.Price != '')?_c('span',{staticClass:"text-muted"},[_vm._v("( "+_vm._s(_vm.Currency)+" "+_vm._s(seatType.Price)+" )")]):_vm._e()])]),_vm._v(" "),(seatType.isuniqueSeat)?_c('div',{staticClass:"text-left"},[_vm._v("\n                    "+_vm._s(seatType.SeatType && /_1/.test(seatType.SeatType)
                        ? seatType.SeatType.replace(/_1/g, "")
                        : seatType.SeatType)+"\n                    : "+_vm._s(_vm.Currency)+" "+_vm._s(seatType.Price)+"\n                  ")]):_c('div',{staticClass:"text-left"},[_vm._v("\n                    "+_vm._s(_vm.myticketDisplaySeatType)+"\n                  ")])])]),_vm._v(" "),_vm._l((_vm.seatLayout),function(seatsArray,seatArrayIndex){return _c('tr',{key:seatArrayIndex,staticClass:"sbtr",class:seatsArray[0].SeatType == seatType.SeatType ? '' : 'd-none'},_vm._l((seatsArray),function(singleSeat,singleSeatIndex){return _c('td',{key:singleSeatIndex,class:singleSeat.Status == 5
                      ? ' d-none ' + singleSeat.ClassName
                      : singleSeat.ClassName},[(
                      singleSeat.SeatType == seatType.SeatType &&
                        singleSeat.Status == 1 &&
                        singleSeat.Occupied == '2'
                    )?_c('div',{staticClass:"big-seat seat-available",class:singleSeat.SelectStatusFlag
                        ? ' big-seat selectedSeat'
                        : '',on:{"click":function($event){return _vm.handlerSeatSelected(
                        singleSeat,
                        seatArrayIndex,
                        singleSeatIndex,
                        null,
                        null,
                        $event,
                        seatType.SeatType
                      )}}},[_vm._v("\n                    "+_vm._s(singleSeat.SeatName)+"\n                  ")]):_vm._e(),_vm._v(" "),(
                      singleSeat.SeatType == seatType.SeatType &&
                        singleSeat.Status == 1 &&
                        !singleSeat.Occupied
                    )?_c('div',{staticClass:"seat-available",class:singleSeat.SelectStatusFlag ? ' selectedSeat' : '',on:{"click":function($event){return _vm.handlerSeatSelected(
                        singleSeat,
                        seatArrayIndex,
                        singleSeatIndex,
                        null,
                        null,
                        $event,
                        seatType.SeatType
                      )}}},[_vm._v("\n                    "+_vm._s(singleSeat.SeatName)+"\n                  ")]):_vm._e(),_vm._v(" "),(
                      singleSeat.SeatType == seatType.SeatType &&
                        singleSeat.Occupied == '2' &&
                        singleSeat.SeatName != '' &&
                        (singleSeat.Status == 2 || singleSeat.Status == 0)
                    )?_c('div',{staticClass:"big-seat seat-unavailable"},[_vm._v("\n                    "+_vm._s(singleSeat.SeatName)+"\n                  ")]):_vm._e(),_vm._v(" "),(
                      singleSeat.SeatType == seatType.SeatType &&
                        !singleSeat.Occupied &&
                        singleSeat.SeatName != '' &&
                        (singleSeat.Status == 2 || singleSeat.Status == 0)
                    )?_c('div',{staticClass:"seat-unavailable"},[_vm._v("\n                    "+_vm._s(singleSeat.SeatName)+"\n                  ")]):_vm._e(),_vm._v(" "),(
                      singleSeat.SeatType == seatType.SeatType &&
                        singleSeat.Status == 0
                    )?_c('div',{staticStyle:{"width":"30px"}}):_vm._e()])}),0)})],2)])}),0),_vm._v(" "),(_vm.seatTypes.length > 0)?_c('div',{staticClass:"screen sticky-top mb-3",staticStyle:{"max-width":"700px","margin":"0 auto"}},[_c('img',{staticClass:"screen-img",attrs:{"src":__webpack_require__(1148)}}),_vm._v(" "),_c('div',{staticClass:"screen-text pt-3"},[_c('p',[_vm._v(_vm._s(_vm.cinemaDetails.SBScreenName))]),_vm._v("\n            "+_vm._s(_vm.$t("SCREEN_THIS_WAY"))+"\n          ")])]):_vm._e()])])]):_vm._e(),_vm._v(" "),_c('section',{staticClass:"bg-light finalCheckout mt-2"},[(_vm.sectionName.checkout)?_c('div',{staticClass:"wrapper pb-4",staticStyle:{"min-height":"100vh"}},[_c('div',{staticClass:"row flex-row-reverse mx-0"},[_c('div',{staticClass:"col-md-12 col-lg-8 order-2 order-md-1 mb-3 px-0 px-md-3"},[(_vm.foodAndBeverages.allListing.length > 0)?_c('section',{staticClass:"section-offer pt-0 pb-2 mb-3"},[_c('div',{staticClass:"d-flex justify-content-between"},[_c('h6',{directives:[{name:"b-toggle",rawName:"v-b-toggle.fnbSection",modifiers:{"fnbSection":true}}],staticClass:"pt-3 font-weight-bold mb-2 text-pink w-100"},[_vm._v("\n                Food & Beverages\n                "),(_vm.fnbtotal > 0)?_c('span',{staticStyle:{"color":"#000000","font-size":"15px"}},[_vm._v(": "+_vm._s(_vm.Currency)+" "+_vm._s(_vm.fnbtotal)+" Added to the cart")]):_vm._e()]),_vm._v(" "),(_vm.fnbCollapsed)?_c('a',{staticStyle:{"color":"#0000ee","margin-top":"8px","cursor":"pointer"},on:{"click":function($event){return _vm.skipFnB()}}},[_vm._v("SKIP")]):_vm._e()]),_vm._v(" "),(_vm.fnbCollapsed)?_c('div',{staticClass:"align-items-center"}):_vm._e(),_vm._v(" "),_c('b-collapse',{attrs:{"visible":"","id":"fnbSection"},model:{value:(_vm.fnbCollapsed),callback:function ($$v) {_vm.fnbCollapsed=$$v},expression:"fnbCollapsed"}},[_c('div',{staticClass:"col-12 col-md-11 px-0"},[_c('div',{staticClass:"my-4 text-center cus-list mb-5 d-none"},[_c('p',{staticClass:"eTitle eTitlewhite"},[_c('img',{staticClass:"img-fluid pb-2",class:_vm.langName == 'ar' ? 'ml-2' : 'mr-2',attrs:{"src":__webpack_require__(1149)}}),_vm._v("\n                    "+_vm._s(_vm.allLanguageData.GrabABite)+"!\n                    "),_c('span',{staticClass:"selected-items"},[_vm._v(_vm._s(_vm.foodAndBeverages.allListing.length)+" ITEMS")])]),_vm._v(" "),_c('div',{staticClass:"whitedotline-box w-100"},[_c('hr',{staticClass:"white-dotline"}),_vm._v(" "),_c('span',{staticClass:"d-none"})]),_vm._v(" "),_c('ul',{staticClass:"list-inline fbCat"},[_c('li',{staticClass:"list-inline-item",class:{
                        active: _vm.foodAndBeverages.selectedCategory == 'All'
                      },on:{"click":function($event){return _vm.onSelectCategory('All')}}},[_vm._v("\n                      All\n                    ")]),_vm._v(" "),_vm._l((_vm.foodAndBeverages.listing),function(category,foodCategoryIndex){return _c('li',{key:foodCategoryIndex,staticClass:"list-inline-item",class:{
                        active:
                          _vm.foodAndBeverages.selectedCategory ==
                          category[0].Category.Title
                      },on:{"click":function($event){return _vm.onSelectCategory(category[0].Category.Title)}}},[_vm._v("\n                      "+_vm._s(category[0].Category.Title)+"\n                    ")])})],2),_vm._v(" "),_c('div',{staticClass:"whitedotline-box w-100"},[_c('hr',{staticClass:"white-dotline"}),_vm._v(" "),_c('span',{staticClass:"d-none"})])]),_vm._v(" "),(_vm.foodAndBeverages.allListing.length > 0)?_c('div',{staticClass:"row mx-0 foodBevrage"},[_vm._l((_vm.foodAndBeverages.listing),function(categories,fb){return (_vm.foodAndBeverages.selectedCategory == 'All')?_vm._l((categories),function(fbBox,fbIndex){return _c('div',{key:fbIndex + fbBox.ItemName,staticClass:"col-md-6 col-lg-4 mb-4 mb-md-5 sub-box",attrs:{"index":fb}},[_c('div',{staticClass:"h-100 premiere-fb-box red-fb-box"},[_c('div',{staticClass:"\n                            align-items-center\n                            text-center text-white\n                            small\n                          "},[(fbBox.ThumbnailImage.includes('/assets/'))?_c('img',{attrs:{"src":fbBox.ThumbnailImage,"alt":fbBox.ItemName}}):_c('img',{staticClass:"demo-img",attrs:{"src":__webpack_require__(1097),"alt":fbBox.ItemName}})]),_vm._v(" "),_c('div',{staticClass:"fbDetails"},[_c('div',{staticClass:"fnb-info"},[_c('p',{staticClass:"fb-name"},[_vm._v("\n                              "+_vm._s(fbBox.ItemName)+"\n                              ")]),_vm._v(" "),_c('p',{staticClass:"fb-desc"},[_c('small',{staticClass:"text-lowercase"},[_vm._v(_vm._s(fbBox.Description))])]),_vm._v(" "),_c('p',{staticClass:"fb-price"},[_vm._v("Qty: "+_vm._s(fbBox.Qty))]),_vm._v(" "),_c('p',{staticClass:"fb-price"},[_vm._v("\n                              "+_vm._s(fbBox.Currency)+"\n                              "+_vm._s(_vm.changeNumberFormat(fbBox.Amount))+"\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-end pr-0 pr-xl-3"},[_c('div',[_c('div',[_c('div',{staticClass:"d-flex counter-box mr-0 mr-md-3",class:_vm.langName == 'ar' ? 'ar-counter-box' : ''},[_c('button',{staticClass:"cursor-pointer btn-add-myticket",staticStyle:{"width":"25px","height":"25px","font-size":"14px"},attrs:{"id":"decrease","type":"button","data-inc":"-1"},on:{"click":function($event){return _vm.onSelectFoodItem(
                                        fbBox,
                                        'subtract',
                                        fbIndex
                                      )}}},[_vm._v("\n                                    -\n                                  ")]),_vm._v(" "),_c('div',{staticClass:"output",staticStyle:{"font-size":"14px","margin":"0 10px"},attrs:{"id":"output"}},[_vm._v("\n                                    "+_vm._s(fbBox.Qty)+"\n                                  ")]),_vm._v(" "),_c('button',{staticClass:"cursor-pointer btn-add-myticket",staticStyle:{"width":"25px","height":"25px","font-size":"14px"},attrs:{"id":"increase","type":"button","data-inc":"1"},on:{"click":function($event){return _vm.onSelectFoodItem(fbBox, 'add', fbIndex)}}},[_vm._v("\n                                    +\n                                  ")])])])])])])])])}):_vm._e()}),_vm._v(" "),_vm._l((_vm.foodAndBeverages.listing[
                      _vm.foodAndBeverages.selectedCategory
                    ]),function(fbBox,fb2){return (_vm.foodAndBeverages.selectedCategory != 'All')?_c('div',{key:fb2,staticClass:"col-md-6 col-lg-4 mb-4 mb-md-5"},[_c('div',{staticClass:"h-100 premiere-fb-box red-fb-box border"},[_c('div',{staticClass:"align-items-center"},[(fbBox.ThumbnailImage.includes('/assets/'))?_c('img',{attrs:{"src":fbBox.ThumbnailImage,"alt":fbBox.ItemName}}):_c('img',{staticClass:"demo-img",attrs:{"src":__webpack_require__(1097),"alt":fbBox.ItemName}})]),_vm._v(" "),_c('div',{staticClass:"fbDetails"},[_c('div',[_c('p',{staticClass:"fb-name"},[_vm._v("\n                            "+_vm._s(fbBox.ItemName)+"\n                            ")]),_vm._v(" "),_c('p',{staticClass:"fb-price"},[_vm._v("Qty: "+_vm._s(fbBox.Qty))]),_vm._v(" "),_c('p',{staticClass:"fb-price"},[_vm._v("\n                            "+_vm._s(fbBox.Currency)+"\n                            "+_vm._s(_vm.changeNumberFormat(fbBox.Amount))+"\n                          ")])]),_vm._v(" "),_c('div',{staticClass:"justify-content-end pr-0 pr-xl-3"},[_c('div',[_c('div',[_c('div',{staticClass:"counter-box mr-0 mr-md-3",class:_vm.langName == 'ar' ? 'ar-counter-box' : ''},[_c('button',{staticClass:"cursor-pointer btn-add-myticket",staticStyle:{"width":"25px","height":"25px","font-size":"14px"},attrs:{"id":"decrease","type":"button","data-inc":"-1"},on:{"click":function($event){return _vm.onSelectFoodItem(fbBox, 'subtract', fb2)}}},[_vm._v("\n                                  -\n                                ")]),_vm._v(" "),_c('div',{staticClass:"output",staticStyle:{"font-size":"14px","margin":"0 10px"},attrs:{"id":"output"}},[_vm._v("\n                                  "+_vm._s(fbBox.Qty)+"\n                                ")]),_vm._v(" "),_c('button',{staticClass:"cursor-pointer btn-add-myticket",staticStyle:{"width":"25px","height":"25px","font-size":"14px"},attrs:{"id":"increase","type":"button","data-inc":"1"},on:{"click":function($event){return _vm.onSelectFoodItem(fbBox, 'add', fb2)}}},[_vm._v("\n                                  +\n                                ")])])])])])])])]):_vm._e()}),_vm._v(" "),_c('div',{staticClass:"w-100"},[_c('button',{staticClass:"btn-confirm",class:_vm.fnbtotal > 0 ? 'active' : '',attrs:{"type":"button","disabled":_vm.fnbtotal > 0 ? false : true},on:{"click":_vm.bookFoodAndBeverages}},[_vm._v("\n                      Continue\n                    ")])])],2):_c('div',{staticClass:"eTitle eTitlewhite text-center"},[_vm._v("\n                  No FNB Data Found\n                ")])])])],1):_vm._e(),_vm._v(" "),_c('section',{staticClass:"section-offer pt-0 pb-2",class:_vm.isRTL ? 'rtl' : ''},[_c('p',{staticClass:"pt-3 font-20 font-weight-bold mb-2 text-pink",attrs:{"id":"errorMsgDisplay"}},[_vm._v("\n              "+_vm._s(_vm.onErrorMeesage)+"\n            ")]),_vm._v(" "),(_vm.isUserLoggedIn)?_c('h6',{directives:[{name:"b-toggle",rawName:"v-b-toggle.checkout",modifiers:{"checkout":true}}],staticClass:"pt-3 font-weight-bold mb-2 text-pink"},[_vm._v("\n              "+_vm._s(_vm.$t("CHECKOUT"))+"\n            ")]):_c('h6',{directives:[{name:"b-toggle",rawName:"v-b-toggle.checkout",modifiers:{"checkout":true}}],staticClass:"pt-3 font-weight-bold mb-2 text-pink"},[_vm._v("\n              "+_vm._s(_vm.$t("CHECKOUT_AS_GUEST"))+"\n            ")]),_vm._v(" "),_c('b-collapse',{attrs:{"visible":"","id":"checkout"}},[_c('div',{staticClass:"small mb-2"},[(_vm.project == 'ticketak')?_c('span',[_vm._v(_vm._s(_vm.$t("YOUR_TICKETS")))]):_vm._e(),_vm._v(" "),(_vm.project == 'myticketi')?_c('div',[_c('p',{staticClass:"text-pink"},[_vm._v("\n                    "+_vm._s(_vm.$t("PLEASE_MAKE_SURE_THAT_YOU_ENTER"))+"\n                    ")]),_vm._v(" "),_c('p',{staticStyle:{"color":"black"}},[_vm._v("\n                    "+_vm._s(_vm.$t("IF_YOU_ARE_A_REGISTERED_USER"))+"\n                  ")])]):_vm._e()]),_vm._v(" "),_c('form',{staticClass:"col-md-12 col-lg-10 col-xl-11 px-0",attrs:{"data-vv-scope":"bookUser"}},[_c('div',{staticClass:"w-100 mb-3"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 mb-2 mb-md-0"},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|email'),expression:"'required|email'"},{name:"model",rawName:"v-model",value:(_vm.userDetails.email),expression:"userDetails.email"}],staticClass:"form-control",attrs:{"name":"email","type":"text","placeholder":_vm.$t('ENTER_YOUR_EMAILADDRESS')},domProps:{"value":(_vm.userDetails.email)},on:{"keyup":function($event){return _vm.onKeyUp($event, 'email')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userDetails, "email", $event.target.value)}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('bookUser.email')),expression:"errors.has('bookUser.email')"}],staticClass:"fs-11 text-danger my-2"},[_vm._v("\n                        "+_vm._s(_vm.errors.first("bookUser.email"))+"\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 mb-2 mb-md-0"},[_c('VuePhoneNumberInput',{attrs:{"default-country-code":_vm.countryList.find(
                            function (o) { return o.phonecode == _vm.userDetails.countryCode; }
                          ) &&
                            _vm.countryList.find(
                              function (o) { return o.phonecode == _vm.userDetails.countryCode; }
                            ).isoCode,"id":"phoneNumber1"},on:{"update":function($event){return _vm.onKeyUp($event, 'mobile')}},model:{value:(_vm.userDetails.phoneNumber),callback:function ($$v) {_vm.$set(_vm.userDetails, "phoneNumber", $$v)},expression:"userDetails.phoneNumber"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('bookUser.Phone Number')),expression:"errors.has('bookUser.Phone Number')"}],staticClass:"fs-11 text-danger my-2"},[_vm._v("\n                        "+_vm._s(_vm.errors.first("bookUser.Phone Number"))+"\n                      ")])],1),_vm._v(" "),(_vm.isStudent)?_c('div',{staticClass:"col-md-12",staticStyle:{"margin-top":"20px"}},[_c('div',{staticClass:"align-items-center w-100 mb-3"},[(!_vm.promoApplied)?_c('div',[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('alpha_num'),expression:"'alpha_num'"},{name:"model",rawName:"v-model",value:(_vm.studentCheck),expression:"studentCheck"}],attrs:{"type":"checkbox","id":"studentCheckoutTerms"},domProps:{"checked":Array.isArray(_vm.studentCheck)?_vm._i(_vm.studentCheck,null)>-1:(_vm.studentCheck)},on:{"change":[function($event){var $$a=_vm.studentCheck,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.studentCheck=$$a.concat([$$v]))}else{$$i>-1&&(_vm.studentCheck=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.studentCheck=$$c}},function($event){return _vm.onKeyUp($event, 'studentCheck')}]}}),_vm._v(" "),_c('label',{staticClass:"mb-0",attrs:{"for":"studentCheckoutTerms"}},[_c('strong',[_vm._v("I want to avail student discount")])])]):_c('div',[_c('strong',[_vm._v("You have already availed a discount.")])]),_vm._v(" "),(_vm.studentCheck)?_c('div',{staticStyle:{"margin-top":"10px"}},[_vm._l((_vm.totalNumberOfSeats),function(i){return _c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.studentIDs[i]),expression:"studentIDs[i]"}],staticClass:"form-control",staticStyle:{"margin-top":"10px","width":"50%"},attrs:{"name":"'student'+i","type":"text","placeholder":"Please enter valid student ID"},domProps:{"value":(_vm.studentIDs[i])},on:{"keyup":function($event){return _vm.promotionDiscount()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.studentIDs, i, $event.target.value)}}}),_vm._v(" "),(
                                _vm.studentIDs[i] != '' &&
                                  !/^[0-9a-zA-Z]+$/.test(_vm.studentIDs[i])
                              )?_c('span',{staticClass:"help text-pink"},[_vm._v("Student ID should not contain special\n                              characters.")]):_vm._e(),_vm._v(" "),(
                                _vm.studentIDs[i] != '' &&
                                  !/^.{0,15}$/.test(_vm.studentIDs[i])
                              )?_c('span',{staticClass:"help text-pink"},[_vm._v("Student ID must not be more than 15\n                              characters.")]):_vm._e()])}),_vm._v(" "),_c('button',{staticClass:"btn-confirm active d-none",staticStyle:{"margin-top":"10px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.validateBeforeSubmit('bookUser')}}},[_vm._v("\n                            Submit\n                          ")]),_vm._v(" "),_c('p',{staticClass:"small mb-2 mt-2 text-pink"},[_vm._v("\n                            * Duplicate student id's will not be considered\n                            for discount.\n                          ")])],2):_vm._e()])]):_vm._e()])]),_vm._v(" "),(_vm.project == 'myticketi')?_c('div',[_c('p',{staticClass:"text-pink d-none",staticStyle:{"font-size":"10px"}},[_vm._v("\n                    Kindly note, Payment made via Debit or Credit card should\n                    be associated with the same email id & phone number as\n                    registered with your card issuing bank. Registered users\n                    will get the ticket confirmation on email id & mobile\n                    number used while registering with Wanasa Time.\n                  ")])]):_vm._e(),_vm._v(" "),(!_vm.isUserLoggedIn)?_c('div',{staticClass:"w-100 mb-3",class:_vm.isRTL ? 'text-right' : ''},[_vm._v("\n                  "+_vm._s(_vm.$t("ALREADY_A_MEMBER"))+"\n                  "),_c('a',{directives:[{name:"b-modal",rawName:"v-b-modal.signIn",modifiers:{"signIn":true}}],staticClass:"text-pink",staticStyle:{"cursor":"pointer"},on:{"contextmenu":function($event){return _vm.handler($event)}}},[_c('u',[_vm._v(_vm._s(_vm.$t("LOGIN"))+" ")])]),_vm._v("Or\n                  "),_c('a',{directives:[{name:"b-modal",rawName:"v-b-modal.signUp",modifiers:{"signUp":true}}],staticClass:"text-pink",staticStyle:{"cursor":"pointer"},on:{"contextmenu":function($event){return _vm.handler($event)}}},[_c('u',[_vm._v(_vm._s(_vm.$t("REGISTER"))+" ")])]),_vm._v(_vm._s(_vm.$t("NOW_FOR_MORE"))+"\n                ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"d-flex align-items-center w-100 mb-3",style:(_vm.isRTL ? 'gap:10px' : '')},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.conditions),expression:"conditions"}],attrs:{"type":"checkbox","id":"guestCheckoutTerms"},domProps:{"checked":Array.isArray(_vm.conditions)?_vm._i(_vm.conditions,null)>-1:(_vm.conditions)},on:{"change":[function($event){var $$a=_vm.conditions,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.conditions=$$a.concat([$$v]))}else{$$i>-1&&(_vm.conditions=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.conditions=$$c}},function($event){return _vm.onKeyUp($event, 'conditions')}]}}),_vm._v(" "),_c('label',{staticClass:"mb-0",attrs:{"for":"guestCheckoutTerms"}},[_vm._v("\n                    "+_vm._s(_vm.$t("I_ACCEPT_THE"))+"\n                    "),_c('router-link',{staticClass:"text-pink",attrs:{"target":"_blank","to":"/tnc"}},[_vm._v("\n                       \n                      "),_c('u',[_vm._v(_vm._s(_vm.$t("TERMS_CONDITIONS")))])])],1)]),_vm._v(" "),_c('div',{staticClass:"small mb-1 text-muted"},[_vm._v("\n                  "+_vm._s(_vm.$t("OPERATIONAL_TERMS_CONDITIONS"))+"\n                ")]),_vm._v(" "),_c('ul',{staticClass:"tnc"},[_c('li',{class:_vm.isRTL ? 'text-right' : ''},[_vm._v("\n                    "+_vm._s(_vm.$t("TICKET_COMPULSORY"))+"\n                  ")]),_vm._v(" "),_c('li',{class:_vm.isRTL ? 'text-right' : ''},[_vm._v("\n                    "+_vm._s(_vm.$t("AGE_RESTRISTIONS"))+"\n                  ")]),_vm._v(" "),_c('li',{class:_vm.isRTL ? 'text-right' : ''},[_vm._v("\n                    "+_vm._s(_vm.$t("AT_THE_CINEMA_PROOF"))+"\n                    ")]),_vm._v(" "),_c('li',{class:_vm.isRTL ? 'text-right' : ''},[_vm._v("\n                    "+_vm._s(_vm.$t("RETURNS_EXCHANGE"))+"\n                    ")]),_vm._v(" "),_c('li',{class:_vm.isRTL ? 'text-right' : ''},[_vm._v("\n                    "+_vm._s(_vm.$t("DECISIONS_TAKEN_CINEMAS"))+".\n                  ")]),_vm._v(" "),_c('li',{class:_vm.isRTL ? 'text-right' : ''},[_vm._v("\n                    "+_vm._s(_vm.$t("OUTSIDE_FOOD_BEVERAGES"))+"\n                  ")])]),_vm._v(" "),(_vm.bookingTermsAndConditions)?[_c('div',{domProps:{"innerHTML":_vm._s(_vm.bookingTermsAndConditions)}})]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"w-100 d-flex"},[_c('button',{staticClass:"btn-confirm",class:_vm.checkoutButtonStatus ? 'active' : '',attrs:{"type":"button","disabled":_vm.checkoutButtonStatus ? false : true},on:{"click":function($event){return _vm.validateBeforeSubmit('bookUser')}}},[_vm._v("\n                    "+_vm._s(_vm.$t("CONTINUE"))+"\n                  ")])])],2)])],1),_vm._v(" "),_c('section',{staticClass:"py-2 cursor-pointer section-offer mt-3 offers-collapse"},[_c('h6',{directives:[{name:"b-toggle",rawName:"v-b-toggle.offers_collapse",modifiers:{"offers_collapse":true}}],staticClass:"py-2 font-weight-bold mb-0 c-pointer text-pink"},[_vm._v("\n              OFFERS AND DISCOUNTS\n            ")]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"offers_collapse"}},[_c('div',{staticClass:"offers-grid"},[_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.voucherCode),expression:"voucherCode"}],staticClass:"voucher-input mt-3",attrs:{"type":"text","placeholder":"Enter Voucher Code"},domProps:{"value":(_vm.voucherCode)},on:{"keyup":function($event){return _vm.onKeyUp($event, 'offer')},"input":function($event){if($event.target.composing){ return; }_vm.voucherCode=$event.target.value}}}),_vm._v(" "),_c('span',{staticStyle:{}},[_vm._v(_vm._s(_vm.VoucherMsg))])]),_vm._v(" "),(_vm.voucherApplied == false)?_c('button',{staticClass:"btn-confirm",class:_vm.voucherCode == '' || _vm.voucherApplied == true
                      ? ' '
                      : 'active',attrs:{"disabled":_vm.voucherCode == '' || _vm.voucherApplied == true ? true : false},on:{"click":function($event){return _vm.onApplyPromocode('1')}}},[_vm._v("\n                  APPLY\n                ")]):_c('button',{staticClass:"btn-confirm",class:_vm.voucherCode != '' && _vm.voucherApplied == true
                      ? 'active'
                      : '',attrs:{"disabled":_vm.voucherCode != '' && _vm.voucherApplied == true ? false : true},on:{"click":function($event){return _vm.onApplyPromocode('0')}}},[_vm._v("\n                  Remove\n                ")])])])],1),_vm._v(" "),_c('section',{staticClass:"pt-0 section-offer mt-3 offers-collapse",class:this.showPaymentCollapse ? 'd-block' : 'd-none',attrs:{"id":"payment-mode-section"}},[_c('h6',{directives:[{name:"b-toggle",rawName:"v-b-toggle.payment_options",modifiers:{"payment_options":true}}],staticClass:"pt-3 font-weight-bold mb-0 c-pointer text-pink"},[_vm._v("\n              PAYMENT OPTIONS\n            ")]),_vm._v(" "),_c('b-collapse',{attrs:{"visible":"","id":"payment_options"}},[_c('b-tabs',{staticClass:"payment-tabs"},_vm._l((this.payment_options),function(data,index){return _c('b-tab',{key:index,on:{"click":function($event){return _vm.getPaymentName(data)}},scopedSlots:_vm._u([{key:"title",fn:function(){return [(data.title == 'CREDIT CARD')?_c('img',{attrs:{"src":data.image,"alt":"card","width":"70px","height":"14px","margin-right":"8px"}}):_vm._e(),_vm._v(" "),(data.title == 'DEBIT CARD')?_c('img',{attrs:{"src":data.image,"alt":"card","width":"15px","height":"18px","margin-right":"8px"}}):_vm._e(),_vm._v(" "),(
                        data.title == 'SCB CREDIT CARD OFFER' &&
                          !_vm.cinemaDetails.MovieTitle.includes('FIFA')
                      )?_c('img',{attrs:{"src":data.image,"alt":"card","width":"15px","height":"18px","margin-right":"8px"}}):_vm._e(),_vm._v("\n                    "+_vm._s(data.title)+"\n                  ")]},proxy:true}],null,true)},[_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn-confirm active",attrs:{"type":"submit"},on:{"click":function($event){return _vm.onclickpaynow(index)}}},[_vm._v("\n                      "+_vm._s(_vm.$t("PROCEED"))+"\n                    ")])])])}),1)],1),_vm._v(" "),_vm._m(0)],1)]),_vm._v(" "),_c('div',{staticClass:"d-md-none d-block text-pink pr-2 fs-18"},[_vm._v("\n          "+_vm._s(_vm.timer.minutes)+" : "+_vm._s(_vm.timer.seconds)+" left\n        ")]),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-lg-4 mb-3 px-0 px-md-3"},[_c('div',{staticClass:"sticky-selected-movie-details"},[_c('div',{staticClass:"section-booking pb-0"},[_c('h6',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.$t("BOOKING_SUMMARY")))]),_vm._v(" "),_c('div',{staticClass:"d-flex"},[_c('div',{staticClass:"img_poster"},[_c('img',{attrs:{"src":_vm.movieDetails.movie_card_img,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"d-flex selectedMovieInfo"},[_c('div',{staticClass:"movieTitle mb-1"},[_vm._v(_vm._s(_vm.movieDetails.title))]),_vm._v(" "),_c('div',{staticClass:"fpx"},[_c('span',[_vm._v(_vm._s(_vm.bookingDetails.desc))])]),_vm._v(" "),_c('div',{staticClass:"font-weight-bold"},[_c('span',[_vm._v(_vm._s(_vm.showDate.date)+" "+_vm._s(_vm.showDate.month)+"\n                      "+_vm._s(_vm.showDate.year))]),_vm._v(" "),_c('span',{staticClass:"mx-1"},[_vm._v("|")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.bookingDetails.time))])]),_vm._v(" "),_c('div',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"b",attrs:{"title":_vm.cinemaDetails.Name}},[_vm._v("\n                    "+_vm._s(_vm.cinemaDetails.Name)+"\n                  ")])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"font-weight-bold d-flex justify-content-between mb-3"},[_c('div',[_c('div',{staticClass:"text-muted small font-weight-bold mb-1"},[_vm._v("\n                    "+_vm._s(_vm.$t("SEATS"))+" ("+_vm._s(_vm.totalNumberOfSeats)+"\n                    "),(_vm.SeatType == 'balcony' && _vm.cinemaDetails.CinemaID == '45')?_c('span',[_vm._v("\n                      Premium\n                    ")]):(_vm.SeatType == 'balcony')?_c('span',[_vm._v("\n                      VIP\n                    ")]):(
                        _vm.SeatType == 'orchestra' &&
                          _vm.cinemaDetails.CinemaID == '35'
                      )?_c('span',[_vm._v("\n                      VIP Gold RECLINERS\n                    ")]):(
                        _vm.SeatType == 'orchestra' &&
                          _vm.cinemaDetails.CinemaID == '45'
                      )?_c('span',[_vm._v("\n                      VIP\n                    ")]):(_vm.SeatType == 'orchestra')?_c('span',[_vm._v("\n                      VIP Gold\n                    ")]):(
                        _vm.SeatType == 'Standard' &&
                          _vm.cinemaDetails.ScreenID == '65'
                      )?_c('span',[_vm._v("\n                      VIP DIAMOND RECLINERS\n                    ")]):(_vm.SeatType == 'Standard')?_c('span',[_vm._v("\n                      STANDARD\n                    ")]):_c('span',[_vm._v(" "+_vm._s(_vm.SeatType)+" ")]),_vm._v("\n\n                    )\n                  ")]),_vm._v(" "),(_vm.getSeatLayout == true)?_c('ul',{staticClass:"list-inline selected-seat"},_vm._l((_vm.selectedSeats),function(seat,seatKey){return _c('li',{key:seatKey},[_vm._v("\n                      "+_vm._s(seat.SeatName)+"\n                    ")])}),0):_c('div',[_vm._v(_vm._s(_vm.$t("OPEN_SEATING")))])]),_vm._v(" "),_c('div',{staticClass:"text-right"},[_c('div',{staticClass:"text-muted small font-weight-bold mb-1"},[_vm._v("\n                    "+_vm._s(_vm.$t("SCREEN"))+"\n                  ")]),_vm._v(" "),_c('div',[_vm._v("\n                    CINEMA "+_vm._s(_vm.cinemaDetails.SBScreenName.split(" ")[1])+"\n                  ")])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"bookingInfo"},[_c('div',[_c('div',{staticClass:"text-muted small mb-3 font-weight-bold"},[_vm._v("\n                    "+_vm._s(_vm.$t("BOOKING_DETAILS"))+"\n                  ")]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_vm._v("\n                    "+_vm._s(_vm.$t("TICKETS"))+" ("+_vm._s(_vm.totalNumberOfSeats)+" x\n                    "+_vm._s(_vm.bookingDetails.ticketprize)+")\n                  ")]),_vm._v(" "),_c('div',[(_vm.bookingDetails.student_discount > 0)?_c('div',{staticClass:"mb-3"},[_vm._v("\n                      "+_vm._s(_vm.$t("STUDENT_PROMOTION"))+" ("+_vm._s(_vm.bookingDetails.promotioncount)+"\n                      x "+_vm._s(_vm.bookingDetails.ptdvalue)+")\n                    ")]):_vm._e(),_vm._v(" "),(_vm.bookingDetails.glassamount > 0)?_c('div',{staticClass:"mb-3"},[_vm._v("\n                      "+_vm._s(_vm.$t("3D_GLASSES"))+"\n                      "),(
                          _vm.bookingDetails.glassInfoHover &&
                            _vm.bookingDetails.glassInfoMessage != ''
                        )?_c('img',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":_vm.bookingDetails.glassInfoMessage,"src":__webpack_require__(1150),"height":"15px","width":"15px","alt":"icon-info"}}):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_vm._v(_vm._s(_vm.$t("SERVICE_CHARGES")))]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_vm._v(_vm._s(_vm.$t("VAT_CHARGES")))]),_vm._v(" "),(_vm.promoApplied)?_c('div',{staticClass:"text-success"},[(_vm.promoCode.tab != 'Referral')?_c('p',[_c('button',{staticClass:"btn-delete",on:{"click":function($event){return _vm.onRemovedPromocode()}}}),_vm._v("\n                        "+_vm._s(_vm.promoCode.selected.Name)+"\n                      ")]):_c('p',[_c('button',{staticClass:"btn-delete",on:{"click":function($event){return _vm.onRemoveReferralPromotion()}}}),_vm._v("\n                        "+_vm._s(_vm.$t("REFERRAL"))+"\n                      ")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"lh-1"},[_c('div',{staticClass:"text-muted small mb-3 font-weight-bold"},[_vm._v("\n                    "+_vm._s(_vm.$t("AMOUNT"))+"\n                  ")]),_vm._v(" "),_c('div',{staticClass:"text-right mb-3"},[_vm._v("\n                    "+_vm._s(_vm.bookingDetails.currency)+" "+_vm._s(_vm.bookingDetails.amount)+"\n                  ")]),_vm._v(" "),(_vm.bookingDetails.student_discount > 0)?_c('div',{staticClass:"mb-3"},[_vm._v("\n                    -"+_vm._s(_vm.bookingDetails.currency)+"\n                    "+_vm._s(_vm.bookingDetails.student_discount)+"\n                  ")]):_vm._e(),_vm._v(" "),(_vm.bookingDetails.glassamount > 0)?_c('div',{staticClass:"text-right mb-3"},[_vm._v("\n                    "+_vm._s(_vm.bookingDetails.currency)+"\n                    "+_vm._s(_vm.bookingDetails.glassamount)+"\n                  ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"text-right mb-3"},[_vm._v("\n                    "+_vm._s(_vm.bookingDetails.currency)+"\n                    "+_vm._s(_vm.bookingDetails.service_charges)+"\n                  ")]),_vm._v(" "),_c('div',{staticClass:"text-right mb-3"},[_vm._v("\n                    "+_vm._s(_vm.bookingDetails.currency)+"\n                    "+_vm._s(_vm.bookingDetails.vat_charges)+"\n                  ")]),_vm._v(" "),(_vm.promoApplied)?_c('div',{staticClass:"text-right mb-3 text-success"},[_vm._v("\n                    -\n                    "+_vm._s(parseInt(_vm.bookingDetails.DiscountValue))+"\n                  ")]):_vm._e()])]),_vm._v(" "),(
                  _vm.bookingDetails.PromotionTextOne != '' &&
                    _vm.bookingDetails.PromotionTextOne != 'MTVAL' &&
                    _vm.bookingDetails.student_discount <= 0
                )?_c('div',{staticClass:"row mb-2"},[_c('div',{staticClass:"col-md-6 col-sm-6 col-6"},[_vm._v("\n                  "+_vm._s(_vm.bookingDetails.PromotionTextOne)+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-sm-6 col-6"},[_c('div',{staticClass:"text-right"},[_vm._v("\n                    - "+_vm._s(_vm.Currency)+"\n                    "+_vm._s(_vm.bookingDetails.PromotionTextOneValue)+"\n                  ")])])]):_vm._e(),_vm._v(" "),(this.foodAndBeverages.selected.length > 0 && _vm.checkFnB)?_c('div',{staticClass:"row mb-2"},[_c('div',{staticClass:"col-md-12 col-sm-12 col-12"},[_c('u',[_vm._v("Food & Beverages")]),_vm._v(" "),_c('a',{staticStyle:{"color":"#0000ee","margin-top":"8px","cursor":"pointer"},attrs:{"title":"Remove F&B Items"},on:{"click":function($event){return _vm.skipFnB()}}},[_c('img',{staticStyle:{"width":"15px","margin-left":"10px"},attrs:{"src":__webpack_require__(1044)}})])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._l((this.foodAndBeverages.selected),function(item,index){return _c('div',{key:index + 'Custom',staticClass:"col-md-12 col-sm-12 col-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 col-sm-6 col-6"},[_vm._v("\n                      "+_vm._s(item.ItemName)+"\n                    ")]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-sm-2 col-2"},[_vm._v(_vm._s(item.Qty))]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-sm-4 col-4"},[_c('div',{staticClass:"text-right"},[_vm._v("\n                        "+_vm._s(_vm.Currency)+" "+_vm._s(item.Qty * item.TotalAmount)+"\n                      ")])])])])})],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"totalAmount mb-3"},[_c('h6',{staticClass:"text-pink"},[_vm._v(_vm._s(_vm.$t("AMOUNT_PAYABLE")))]),_vm._v(" "),_c('h6',[_c('span',{staticClass:"mr-1"},[_vm._v(_vm._s(_vm.bookingDetails.currency))]),_vm._v("\n                  "+_vm._s(_vm.bookingDetails.total_amt)+"\n                ")])])]),_vm._v(" "),_c('div',{staticClass:"d-none d-lg-block"},[_c('div',{staticClass:"text-pink text-center mt-3",staticStyle:{"font-size":"18px","font-weight":"bold"}},[_vm._v("\n                "+_vm._s(_vm.$t("THIS_SESSION_WILL_EXPIRE"))+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"\n                  countdown\n                  mt-3\n                  d-flex\n                  justify-content-center\n                  align-items-center\n                  mx-auto\n                "},[_c('div',[_c('div',[_vm._v(_vm._s(_vm.timer.minutes)+" : "+_vm._s(_vm.timer.seconds))])])])])])])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"d-md-block"},[(_vm.sectionName.detailFooter)?_c('section',{staticClass:"detailHeader",class:_vm.isRTL ? 'rtl' : ''},[_c('div',{staticClass:"detailHeader-content"},[_c('div',[_c('router-link',{attrs:{"to":""},nativeOn:{"click":function($event){return _vm.onClickBackButton()}}},[_c('img',{attrs:{"src":__webpack_require__(1078),"height":"18px","width":"18px"}})])],1),_vm._v(" "),_c('div',{staticClass:"header-content"},[_c('div',[_vm._v("\n            "+_vm._s(_vm.cinemaDetails.MovieTitle)+" ("+_vm._s(_vm.movieDetails.rated)+") |\n            "+_vm._s(_vm.cinemaDetails.Name)+"\n          ")]),_vm._v(" "),_c('div',[_vm._v("\n            "+_vm._s(_vm.showDate.date)+" "+_vm._s(_vm.showDate.month)+" "+_vm._s(_vm.showDate.year)+",\n            "+_vm._s(_vm.SchTime)+"\n          ")])])]),_vm._v(" "),(_vm.totalNumberOfSeats && _vm.totalNumberOfSeats > 0)?_c('div',{directives:[{name:"b-modal",rawName:"v-b-modal.seat_select_modal",modifiers:{"seat_select_modal":true}}],staticClass:"no-tickets-header"},[_c('span',[_vm._v(_vm._s(_vm.totalNumberOfSeats)+" Tickets")]),_vm._v(" "),_vm._m(2)]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.sectionName.detailFooter && _vm.selectedSeats.length > 0)?_c('section',{staticClass:"detailFooter",class:_vm.isRTL ? 'rtl' : ''},[_c('div',{staticClass:"detailFooter-content"},[_c('div',{},[_c('div',{staticClass:"flex-1"},[_c('div',[_vm._v("\n              "+_vm._s(_vm.totalNumberOfSeats)+" Tickets x "+_vm._s(_vm.Currency)+"\n              "+_vm._s(_vm.singleTicketPrice)+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"primary-color"},[_vm._v("\n              "+_vm._s(_vm.Currency)+" "+_vm._s(_vm.totalAmount.toFixed(2))+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"flex-1",class:(_vm.selectedSeats.length > 0 && _vm.selectedSeats.length < 5) ||
              _vm.getSeatLayout == false
                ? ''
                : _vm.selectedSeats.length > 5
                ? ''
                : ''},[_c('div',[_vm._v(_vm._s(_vm.$t("SEATS_SELECTED")))]),_vm._v(" "),(_vm.getSeatLayout == true)?_c('div',[_c('ul',{staticClass:"list-inline seats-selected",class:_vm.selectedSeats.length > 0 ? 'mb-0' : 'mb-4'},_vm._l((_vm.selectedSeats),function(seats,seatKey){return _c('span',{key:seatKey,staticClass:"list-inline-item primary-color"},[_vm._v(_vm._s(seats.SeatName))])}),0)]):_c('div',[_vm._v(_vm._s(_vm.$t("OPEN_SEATING")))])])]),_vm._v(" "),_c('div',{class:this.totalNumberOfSeats == this.selectedSeats.length
              ? 'navProceed'
              : 'navProceedDisabled pointer-none',style:(_vm.isRTL ? 'gap:10px' : 'gap:10px')},[(_vm.sectionName.noOfSeats)?_c('router-link',{staticClass:"font-weight-bold text-white mr-2",class:_vm.totalNumberOfSeats > 0 ? '' : 'pointer-none',attrs:{"to":"#"},nativeOn:{"click":function($event){return _vm.confirmNumber()}}},[_vm._v(_vm._s(_vm.$t("PROCEED"))+" TO {AY}")]):_vm._e(),_vm._v(" "),(_vm.sectionName.seatLayout)?_c('router-link',{staticClass:"font-weight-bold text-white",class:_vm.totalNumberOfSeats && _vm.selectedSeats.length == _vm.totalNumberOfSeats
                ? ''
                : 'pointer-none',attrs:{"to":"#"},nativeOn:{"click":function($event){return _vm.onSeatConfirmaton()}}},[_vm._v(_vm._s(_vm.$t("PROCEED"))+" TO PAY")]):_vm._e()],1)])]):_vm._e()]),_vm._v(" "),_c('b-modal',{ref:"OTPModal",attrs:{"hide-header":"","hide-footer":"","centered":""}},[_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":function($event){return _vm.onCloseModal('OTPModal')}}},[_vm._v("\n      ×\n    ")]),_vm._v(" "),_c('div',{staticClass:"col-sm-9 col-md-10 mx-auto"},[_c('div',{staticClass:"modal-title"},[_vm._v("Welcome to Wanasa")]),_vm._v(" "),_c('div',{staticClass:"text-danger my-2 text-center"},[_vm._v("\n        "+_vm._s(_vm.ProcessPaymentMessage)+"\n      ")]),_vm._v(" "),_c('form',{attrs:{"data-vv-scope":"VerifyOTP","onsubmit":"event.preventDefault()"}},[_c('label',[_vm._v("- ENTER OTP -")]),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.OTP),expression:"OTP"}],attrs:{"name":"OTP","type":"number","placeholder":"OTP"},domProps:{"value":(_vm.OTP)},on:{"input":function($event){if($event.target.composing){ return; }_vm.OTP=$event.target.value}}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('VerifyOTP.OTP')),expression:"errors.has('VerifyOTP.OTP')"}],staticClass:"help is-danger"},[_vm._v(_vm._s(_vm.errors.first("VerifyOTP.OTP")))]),_vm._v(" "),_c('input',{attrs:{"type":"submit","value":"VERIFY OTP"},on:{"click":function($event){return _vm.confirmBooking()}}})])])]),_vm._v(" "),_c('b-modal',{ref:"hurryupmodal",attrs:{"id":"hurryupmodal","no-close-on-esc":"","no-close-on-backdrop":"","hide-header-close":"","hide-header":"","hide-footer":""}},[_c('div',{staticClass:"modal-title"},[_vm._v(_vm._s(_vm.$t("HURRY_UP")))]),_vm._v(" "),_c('div',{staticClass:"text-center text-black mt-3 mt-md-0"},[_vm._v("\n      "+_vm._s(_vm.$t("BOOKING_EXPIRED"))+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"text-center my-3"},[_c('button',{staticClass:"ticketak-btn",on:{"click":function($event){return _vm.onCloseModal('hurryupmodal')}}},[_vm._v("\n        OK\n      ")])])]),_vm._v(" "),_c('b-modal',{ref:"offermodal",attrs:{"id":"offermodal","no-close-on-esc":"","no-close-on-backdrop":"","hide-header-close":"","hide-header":"","hide-footer":""}},[_c('div',{staticClass:"modal-title"},[_vm._v("DISCOUNT APPLIED!")]),_vm._v(" "),_c('div',{staticClass:"text-center text-white mt-3 mt-md-0 p2"},[_vm._v("\n      Discount of "+_vm._s(_vm.Currency)+" "+_vm._s(_vm.bookingDetails.PromotionTextOneValue)+" is\n      auto applied on your transaction. Proceed to Payment\n    ")]),_vm._v(" "),_c('div',{staticClass:"text-center my-3"},[_c('button',{staticClass:"ticketak-btn",on:{"click":function($event){return _vm.onCloseModal('offermodal')}}},[_vm._v("\n        OK\n      ")])])]),_vm._v(" "),_c('b-modal',{ref:"redirectPayment",attrs:{"id":"redirectPayment","centered":"","no-close-on-esc":"","no-close-on-backdrop":"","hide-header-close":"","hide-header":"","hide-footer":""}},[_c('div',{staticClass:"text-center text-white mt-3 mt-md-0 pt-4 px-5"},[_vm._v("\n      Redirecting you to the payment gateway...\n      "),_c('br'),_vm._v("Please click on "),_c('b',[_vm._v("'Confirm'")]),_vm._v(" button once the payment process\n      is done, to get your ticket\n    ")]),_vm._v(" "),_c('div',{staticClass:"text-center my-3"},[_c('button',{staticClass:"ticketak-btn",on:{"click":function($event){return _vm.onclickok()}}},[_vm._v("\n        "+_vm._s(_vm.$t("PROCEED"))+"\n      ")])])]),_vm._v(" "),_c('b-modal',{ref:"couponNotAllowed",attrs:{"id":"couponNotAllowed","centered":"","no-close-on-esc":"","no-close-on-backdrop":"","hide-header-close":"","hide-header":"","hide-footer":""}},[_c('div',{staticClass:"text-center text-white mt-3 mt-md-0 pt-4 px-5"},[_vm._v("\n      "+_vm._s(_vm.promotionNotAllowed)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"text-center my-3"},[_c('button',{staticClass:"ticketak-btn",on:{"click":function($event){return _vm.couponNotAllowedHide()}}},[_vm._v("\n        Okay\n      ")])])]),_vm._v(" "),_c('b-modal',{ref:"sessionTimeOut",attrs:{"id":"sessionTimeOut","no-close-on-esc":"","no-close-on-backdrop":"","hide-header-close":"","hide-header":"","hide-footer":""}},[_c('div',{staticClass:"modal-title"},[_vm._v(_vm._s(_vm.$t("SESSION_EXPIRED")))]),_vm._v(" "),_c('div',{staticClass:"text-center text-black mt-3 mt-md-0"},[_vm._v("\n      "+_vm._s(_vm.$t("SORRT_TIMEOUT"))+".\n    ")]),_vm._v(" "),_c('div',{staticClass:"text-center my-3"},[_c('button',{staticClass:"ticketak-btn",on:{"click":function($event){return _vm.onClickRestart()}}},[_vm._v("\n        "+_vm._s(_vm.$t("START_AGAIN"))+"\n      ")])])]),_vm._v(" "),_c('b-modal',{ref:"showquitbookingModal",attrs:{"id":"showquitbookingModal","title":"Quit Booking?","no-close-on-esc":"","no-close-on-backdrop":"","hide-header-close":"","hide-footer":"","hide-header":""}},[_c('div',{staticClass:"col-sm-9 col-md-10 mx-auto"},[_c('div',{staticClass:"modal-title"},[_vm._v("Quit Booking?")]),_vm._v(" "),_c('div',{staticClass:"mb-4"},[_c('label',{staticClass:"text-white text-center"},[_vm._v("Are you sure you want to quit booking?")]),_vm._v(" "),_c('div',{staticClass:"text-center my-3"},[_c('button',{staticClass:"ticketak-btn mt-1 my-1",on:{"click":function($event){return _vm.onClickGoBack()}}},[_vm._v("\n            Yes\n          ")]),_vm._v(" "),_c('button',{staticClass:"ticketak-btn mt-1 my-1",on:{"click":function($event){return _vm.onCloseModal('showquitbookingModal')}}},[_vm._v("\n            No\n          ")])])])])]),_vm._v(" "),_c('b-modal',{ref:"applycouponModal",attrs:{"id":"applycoupon","title":"Apply Promotion","no-close-on-backdrop":"","hide-footer":"","hide-header":""}},[_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":function($event){return _vm.onCloseModal('applycouponModal')}}},[_vm._v("\n      ×\n    ")]),_vm._v(" "),_c('div',{staticClass:"col-sm-9 col-md-10 mx-auto"},[_c('div',{staticClass:"modal-title"},[_vm._v("Apply Promotion")]),_vm._v(" "),_c('div',[_c('div',{staticClass:"row mt-3 mb-2"},[_c('div',{staticClass:"col-md-9 col-sm-12 col-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.promoCode.selected.Name),expression:"promoCode.selected.Name"}],attrs:{"type":"text","placeholder":"Enter Voucher Code"},domProps:{"value":(_vm.promoCode.selected.Name)},on:{"keydown":function($event){return _vm.onKeyUp($event, 'offer')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.promoCode.selected, "Name", $event.target.value)}}}),_vm._v(" "),(_vm.promoCode.errorInputMessage.length > 0)?_c('div',{staticClass:"text-danger"},[_vm._v("\n              "+_vm._s(_vm.promoCode.errorInputMessage)+"\n            ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-sm-12 col-12"},[_c('button',{staticClass:"btn-applyvou mt-2",on:{"click":function($event){return _vm.onApplyPromocode('1')}}},[_vm._v("\n              Apply\n            ")])])])]),_vm._v(" "),_c('div',{staticClass:"base-boundary"}),_vm._v(" "),_c('div',{staticClass:"mb-4"},[_c('b-tabs',{attrs:{"content-class":"mt-3"}},_vm._l((_vm.PromotionTabs),function(tab,tabIndex){return _c('b-tab',{key:tabIndex,attrs:{"title":tab}},[_vm._l((_vm.promoCode.promoList),function(promo,promokey){return _c('div',{key:promokey},[(promo.tab == tab)?_c('div',[(tab != 'Referral')?_c('div',[_c('div',{staticClass:"row mt-4"},[_c('div',{staticClass:"col-md-6 col-sm-6 col-6"},[_c('div',{staticClass:"text-center coupon-code p-2"},[_c('span',{staticClass:"font-weight-bold text-white"},[_vm._v(_vm._s(promo.Name))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-sm-6 col-6 text-center"},[_c('button',{staticClass:"btn-apply mt-1",on:{"click":function($event){return _vm.verifyPromotion(promo, promokey)}}},[_vm._v("\n                        Apply\n                      ")])])]),_vm._v(" "),_c('div',{staticClass:"mt-3 text-white"},[_c('span',{staticClass:"text-white font-weight-bold"},[_vm._v(_vm._s(promo.ShortDescription))])]),_vm._v(" "),_c('div',{staticClass:"mt-2 text-white"},[_c('span',{}),_vm._v(" "),_c('span',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(promo.Expiry))])]),_vm._v(" "),_c('div',{staticClass:"text-danger"},[_vm._v(_vm._s(promo.errorMessage))])]):_c('div',[_c('div',{staticClass:"row mt-4"},[_c('div',{staticClass:"col-md-6 col-sm-6 col-6"},[_c('div',{staticClass:"text-center coupon-code p-2"},[_c('span',{staticClass:"font-weight-bold text-white"},[_vm._v(_vm._s(promo.Name))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-sm-6 col-6 text-center"},[_c('button',{class:[
                          'btn-apply',
                          promo.Apply ? 'disable-btn' : 'btn-apply mt-1'
                        ],attrs:{"disabled":promo.Apply},on:{"click":function($event){return _vm.verifyPromotion(promo, promokey)}}},[_vm._v("\n                        Apply\n                      ")])])]),_vm._v(" "),_c('div',{staticClass:"text-danger"},[_vm._v(_vm._s(promo.errorMessage))])])]):_vm._e()])}),_vm._v(" "),(tab == 'Referral')?_c('div',[_c('button',{staticClass:"btn-confirm active mt-2",attrs:{"type":"button"},on:{"click":function($event){return _vm.hideReferralModal()}}},[_vm._v("\n                Continue\n              ")])]):_vm._e()],2)}),1)],1)])]),_vm._v(" "),_c('div',{staticStyle:{"display":"none"},attrs:{"id":"form_sample"}}),_vm._v(" "),(_vm.sectionName.typeSelector)?_c('div',{staticClass:"modal-bg"},[_vm._m(3)]):_vm._e(),_vm._v(" "),_c('b-modal',{ref:"seattypesmodal",attrs:{"id":"seattypesmodal","title":"Seat Types","no-close-on-backdrop":"","hide-footer":"","hide-header":""}},[_c('div',{staticClass:"select-seat-section"},[_c('div',{staticClass:"modal-title"},[_vm._v(_vm._s(_vm.$t("PLEASE_SELECT_SEAT_TYPE")))]),_vm._v(" "),_c('div',{staticClass:"container px-2 px-md-3"},[_c('div',{staticClass:"select-seat-container"},[_c('div',[(_vm.OnlySeatType.length > 0)?_c('div',{staticClass:"mb-4"},[_c('div',{staticClass:"row"},_vm._l((_vm.OnlySeatType),function(SingleSeatType,SeatKey){return _c('div',{key:SeatKey,staticClass:"pr-2",class:_vm.OnlySeatType.length == 1 ? 'col-12' : 'col-' + _vm.seatsClass},[_c('button',{staticClass:"btn-rounded h-auto",on:{"click":function($event){return _vm.onNewSelectSeatType(SingleSeatType)}}},[_vm._v("\n                    "+_vm._s(SingleSeatType.SeatType)+"\n                    "),_c('br'),_vm._v("\n                    ("+_vm._s(_vm.Currency)+" "+_vm._s(SingleSeatType.Price)+")\n                  ")])])}),0)]):_vm._e()])])])])]),_vm._v(" "),_c('b-modal',{ref:"noseattype",attrs:{"no-close-on-esc":"","no-close-on-backdrop":"","hide-header-close":"","id":"noseattype","centered":"","hide-header":"","hide-footer":""}},[_c('div',{staticClass:"modal-title"}),_vm._v(" "),_c('div',{staticClass:"mx-2"},[_c('div',{staticClass:"list-group px-4"},[_c('h3',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.$t("OOPS")))]),_vm._v(" "),_c('p',[_vm._v("\n          Seems like there is some issue at cinema end. Please trying again\n          after sometime\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('router-link',{staticClass:"btn-light btn active mb-3 center",attrs:{"to":"/"}},[_vm._v("Home")])],1)]),_vm._v(" "),_c('b-modal',{ref:"scbModal",staticClass:"country-modal card-selected",attrs:{"centered":"","no-close-on-esc":"","hide-header-close":"","id":"scbModal","hide-header":"","hide-footer":""}},[_c('h5',{staticClass:"text-center card-heading"},[_vm._v("SCB CARD SELECTED")]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('h5',[_vm._v("Congratulations")]),_vm._v(" "),_c('p',{attrs:{"className":"my-3"}},[_vm._v("\n        You have availed 50% Off on Tickets by using SCB Card.\n      ")]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between px-2 px-xl-4"},[_c('div',[_c('p',[_vm._v(_vm._s(_vm.$t("Before Discount")))]),_vm._v(" "),_c('p',[_c('b',[_vm._v(_vm._s(_vm.Currency)+" "+_vm._s(_vm.bookingDetails.BeforeDiscount))])])]),_vm._v(" "),_c('div',[_c('p',[_vm._v(_vm._s(_vm.$t("After Discount")))]),_vm._v(" "),_c('p',[_c('b',[_vm._v(" "+_vm._s(_vm.Currency)+" "+_vm._s(_vm.bookingDetails.PromotionTextOneValue))])])])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"text-center mx-auto my-2"},[_c('button',{staticClass:"btn-confirm active",attrs:{"type":"button"},on:{"click":function($event){return _vm.onClickScbOk()}}},[_vm._v("\n        "+_vm._s(_vm.$t("SUBMIT"))+"\n      ")])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"payment-frame"},[_c('div',{attrs:{"id":"3ds_iframe"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12 col-sm-12 col-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 col-sm-6 col-6"},[_vm._v("Items")]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-sm-2 col-2"},[_vm._v("Qty")]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-sm-4 col-4"},[_c('div',{staticClass:"text-right"},[_vm._v("Amount")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('img',{staticClass:"icon",attrs:{"src":__webpack_require__(1078),"height":"18px","width":"18px"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-dialog modal-lg modal-dialog-centered",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('button',{staticClass:"close text-right px-2",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"col-12 mx-auto"},[_c('div',{staticClass:"seatPopHdr"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8 col-12 py-md-0 py-5"},[_c('div',{staticClass:"seatCol1"},[_c('div',{staticClass:"headline pb-4"},[_vm._v("\n                      Select Movie Class Category?\n                    ")]),_vm._v(" "),_c('div',{staticClass:"ticktSum"},[_c('hr'),_vm._v(" "),_c('div',{staticClass:"seatClass"},[_c('div',{staticClass:"fl"},[_c('input',{attrs:{"type":"radio","value":"","checked":"checked","name":"rdbschClass"}})]),_vm._v(" "),_c('p',{staticClass:"seatTitle"},[_vm._v("\n                          Bachelor\n                          "),_c('span',[_vm._v("(3.5 KWD)")])])]),_vm._v(" "),_c('div',{staticClass:"seatClass"},[_c('div',{staticClass:"fl"},[_c('input',{attrs:{"type":"radio","value":"","name":"rdbschClass"}})]),_vm._v(" "),_c('p',{staticClass:"seatTitle"},[_vm._v("\n                          Family\n                          "),_c('span',[_vm._v("(3.5 KWD)")])])]),_vm._v(" "),_c('div',{staticClass:"seatClass"},[_c('div',{staticClass:"fl"},[_c('input',{attrs:{"id":"rdbClass87098","type":"radio","value":"","name":"rdbschClass"}})]),_vm._v(" "),_c('p',{staticClass:"seatTitle"},[_vm._v("\n                          Premium Bachelor\n                          "),_c('span',[_vm._v("(4.5 KWD)")])])]),_vm._v(" "),_c('div',{staticClass:"seatClass"},[_c('div',{staticClass:"fl"},[_c('input',{attrs:{"id":"rdbClass87099","type":"radio","value":"87099","name":"rdbschClass"}})]),_vm._v(" "),_c('p',{staticClass:"seatTitle"},[_vm._v("\n                          Premium Family\n                          "),_c('span',[_vm._v("(4.5 KWD)")])])])])]),_vm._v(" "),_c('div',{staticClass:"p-3"},[_c('a',{staticClass:"btn btn-info w-75",attrs:{"href":"#"}},[_vm._v("Book Now")])])]),_vm._v(" "),_c('div',{staticClass:"col-4 p-0 d-none d-md-block"},[_c('div',{staticClass:"seatCol2",attrs:{"id":"divSeatSelMovie"}},[_c('div',{staticClass:"mvD-img"},[_c('img',{staticClass:"img-fluid",attrs:{"src":"img/e0c882f0f59849649fc8a2b392d5baeb.jpg","alt":""}})]),_vm._v(" "),_c('h1',[_vm._v("Black Water (15+)")]),_vm._v(" "),_c('p',{staticClass:"mvD-type"},[_vm._v("2D")]),_vm._v(" "),_c('p',{staticClass:"mvD-type"},[_vm._v("Action,Drama")]),_vm._v(" "),_c('div',{staticClass:"mvD-typeHdr"},[_c('p',{staticClass:"mvD-typeHdr-lg"},[_vm._v("LANGUAGE")]),_vm._v(" "),_c('p',[_vm._v("English")])]),_vm._v(" "),_c('div',{staticClass:"mvD-typeHdr"},[_c('p',{staticClass:"mvD-typeHdr-lg"},[_vm._v("SUBTITLES")]),_vm._v(" "),_c('p',[_vm._v("English")])]),_vm._v(" "),_c('div',{staticClass:"mvD-typeHdr"},[_c('p',{staticClass:"mvD-typeHdr-lg"},[_vm._v("LENGTH")]),_vm._v(" "),_c('p',[_vm._v("1h 45min")])]),_vm._v(" "),_c('div',{staticClass:"showTime"},[_c('h3',[_c('span',{staticClass:"bold"},[_vm._v("Cinescape")]),_vm._v(" : KNCC Test Site\n                      ")]),_vm._v(" "),_c('p',[_vm._v("2018-12-24, 19:15")])])])])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1147:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAARRSURBVGhD7Zpb6BVFHMf/ld3EMMyoFAvU0Ix6SMOnSlAEg6Ie1PQlBS+Q0EXy0ULpBimEophgQoSR9lB0U0ESrSerh0KswARvoeaFBBPN6vNZGFjWc45nZ2dOIn7h8zC7e2b2tzPzm9/85vRd1RWsu2EWrIXtcBj+hH/hbzgBP8Mn8AZMhv5wWWgQvATfgy9clzPwIUyBa6DnGgxvw2kIL3UMNsICmABD4CYIGgij4Sl4Db4Beyr8/keYBj0xyEbmwXGw8X/AofIEXA91pbEL4TcIBjks74Nsshc+h9Dgp/AApFA/eBYOgXX/BX6w5BoD+8FGfgd7IIcGwEqwp21rHWhkEj0MYShtgzsht5xHJ8E2P4MboJEcOkfBCvUujSusoQdBF27bH8N1ECXnRBhOH8C1ECM9V6wnGgnhQy73Ql3Z8BdgBV9DTE8Mg62giz0FiyFG48H1xnnzpBfqSI+hEU7sO7wQoW/BOsromWI0H/y9vXObF7rR7fAH+MNY73QXlA0I6LJjFVz/mqLUhVyxmzbqKh5caJkNEKvh4PriUL3XC51k7GTY4Us0Xezeh7IRF+ARaKIVYF2uLx31Ivhgk94IuhFehV2wGSZCU+lAzoM9c6sX2ukH0JBcK3cKuUD6jm1DmHvAB5zoMQFgrzQDfM8vi1ILuSnygY+K0uUr3a/zzU1byw/+LmiI+4kmuhnGtmAUpJJ7F9/1oaJU0Q7w5mNFKV56O+upshNSSTdunQ6zi3QQvDm0KMXL+Og72A25DFkK1tky7AmJAodGClV7JqUhz4N1LitKFXnDSZRKOQ2ZDda5uihV5ELjzVTKaUgIIlcVpYrCjsw4KYVyGvIyWOebRamiPeBN9+cplNOQd8A6XyhKFRlfebP25qWNchoSNn2PF6WKXgdvmjxLoVyGuHsN21/TtBfJXKw33dmlUC5DQr17i1ILmVB2b+zGxR1eU+UyxEXQ+jruFE35+JBeoalyGOKw+hWsr2MoZVbch8zFNs3w5TDEyW1d+6BjismbIbI0rG+iHIaEzMxzRekSmgo+bBB5ixdqyvztJJgLZUN+Aq+PgxjNBOs5AF3Fg/aKqX1/ZEK5rqo9USWmZ8x6hvTpM17oVveDG/yY7J6+3QOfdhiC15EfNiyAW7xQVyEwM93pV/6/ZDzle9gjsVnPvvVgJY7LlFvVbuVplu27vjXauZrKDzGYYYFnJb2Qw+ktsF0X6CTxn4m2TWCl2Y7ESjJLEvK8tvc0JJM947Yy5HNtaASkli42eCdPApqmWNvKIzGPoW3IcWsutmUEWlNGFOVjCFOs2Y/4THSbAwtn5OdA96h/1993I+eAntAA8BcIBniqOx16KlP778FZCC9i8sIQx+BzCZjtmAPOq0Xgzu4rOALhN2LsZGKw/AeDnss9vi9qr5T/CXEp3E/Ys49C7PlkNhkxm8Y0A/gKeGjky5rt0J16bOF88Hjgqq5g9fX9B5NvdrOKEE1NAAAAAElFTkSuQmCC"

/***/ }),

/***/ 1148:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 1149:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 1150:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjMDAwMDAwIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgd2lkdGg9IjI0cHgiIGhlaWdodD0iMjRweCI+PHBhdGggZD0iTSAxMiAwIEMgNS4zNzEwOTQgMCAwIDUuMzcxMDk0IDAgMTIgQyAwIDE4LjYyODkwNiA1LjM3MTA5NCAyNCAxMiAyNCBDIDE4LjYyODkwNiAyNCAyNCAxOC42Mjg5MDYgMjQgMTIgQyAyNCA1LjM3MTA5NCAxOC42Mjg5MDYgMCAxMiAwIFogTSAxMiAyIEMgMTcuNTIzNDM4IDIgMjIgNi40NzY1NjMgMjIgMTIgQyAyMiAxNy41MjM0MzggMTcuNTIzNDM4IDIyIDEyIDIyIEMgNi40NzY1NjMgMjIgMiAxNy41MjM0MzggMiAxMiBDIDIgNi40NzY1NjMgNi40NzY1NjMgMiAxMiAyIFogTSAxMiA1LjgxMjUgQyAxMS44MTY0MDYgNS44MTI1IDExLjY2NDA2MyA1LjgwODU5NCAxMS41IDUuODQzNzUgQyAxMS4zMzU5MzggNS44Nzg5MDYgMTEuMTgzNTk0IDUuOTY4NzUgMTEuMDYyNSA2LjA2MjUgQyAxMC45NDE0MDYgNi4xNTYyNSAxMC44NTE1NjMgNi4yODUxNTYgMTAuNzgxMjUgNi40Mzc1IEMgMTAuNzEwOTM4IDYuNTg5ODQ0IDEwLjY4NzUgNi43Njk1MzEgMTAuNjg3NSA3IEMgMTAuNjg3NSA3LjIyNjU2MyAxMC43MTA5MzggNy40MDYyNSAxMC43ODEyNSA3LjU2MjUgQyAxMC44NTE1NjMgNy43MTg3NSAxMC45NDE0MDYgNy44NDM3NSAxMS4wNjI1IDcuOTM3NSBDIDExLjE4MzU5NCA4LjAzMTI1IDExLjMzNTkzOCA4LjA4NTkzOCAxMS41IDguMTI1IEMgMTEuNjY0MDYzIDguMTY0MDYzIDExLjgxNjQwNiA4LjE4NzUgMTIgOC4xODc1IEMgMTIuMTc5Njg4IDguMTg3NSAxMi4zNzEwOTQgOC4xNjQwNjMgMTIuNTMxMjUgOC4xMjUgQyAxMi42OTE0MDYgOC4wODU5MzggMTIuODE2NDA2IDguMDMxMjUgMTIuOTM3NSA3LjkzNzUgQyAxMy4wNTg1OTQgNy44NDM3NSAxMy4xNDg0MzggNy43MTg3NSAxMy4yMTg3NSA3LjU2MjUgQyAxMy4yODkwNjMgNy40MTAxNTYgMTMuMzQzNzUgNy4yMjY1NjMgMTMuMzQzNzUgNyBDIDEzLjM0Mzc1IDYuNzY5NTMxIDEzLjI4OTA2MyA2LjU4OTg0NCAxMy4yMTg3NSA2LjQzNzUgQyAxMy4xNDg0MzggNi4yODUxNTYgMTMuMDU4NTk0IDYuMTU2MjUgMTIuOTM3NSA2LjA2MjUgQyAxMi44MTY0MDYgNS45Njg3NSAxMi42OTE0MDYgNS44Nzg5MDYgMTIuNTMxMjUgNS44NDM3NSBDIDEyLjM3MTA5NCA1LjgwODU5NCAxMi4xNzk2ODggNS44MTI1IDEyIDUuODEyNSBaIE0gMTAuNzgxMjUgOS4xNTYyNSBMIDEwLjc4MTI1IDE4LjEyNSBMIDEzLjIxODc1IDE4LjEyNSBMIDEzLjIxODc1IDkuMTU2MjUgWiIvPjwvc3ZnPg=="

/***/ })

});


// WEBPACK FOOTER //
// static/js/0.f309c233dde881f10e7f.js